import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Bit: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Time: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

/** API Key Input */
export type ApiKeyInput = {
  /** Number of seconds after which the key should expire. A maximum value is applied so always check the `exp` in the generated JWT. */
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  /** List of Basic permissions you wish to give this key */
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Limited scope of the key */
  scope?: InputMaybe<Array<InputMaybe<ApiKeyScopeInput>>>;
};

export type ApiKeyScope = {
  __typename?: 'APIKeyScope';
  access?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Scalars['Int']['output']>;
};

export type ApiKeyScopeInput = {
  access?: InputMaybe<Scalars['String']['input']>;
  project: Scalars['Int']['input'];
};

export type ApiKeyVerification = {
  __typename?: 'APIKeyVerification';
  email: Scalars['String']['output'];
  /** Standard Errors */
  errors?: Maybe<Array<Maybe<StdError>>>;
  generated: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scope?: Maybe<Array<Maybe<ApiKeyScope>>>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

/** An Account */
export type Account = {
  __typename?: 'Account';
  accountServiceTeam: Array<AccountServiceTeam>;
  active?: Maybe<Scalars['Int']['output']>;
  aliases?: Maybe<Scalars['String']['output']>;
  allianceContacts?: Maybe<Array<Contact>>;
  alliedCompanies: Array<Account>;
  alliedCompaniesCount: Scalars['Int']['output'];
  approved?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Person>;
  budgetCycle?: Maybe<Scalars['String']['output']>;
  businesses?: Maybe<Array<Business>>;
  clientCompliance?: Maybe<ClientCompliance>;
  clientConverted?: Maybe<Scalars['Date']['output']>;
  clientConvertedBy?: Maybe<Person>;
  clientOpsNote?: Maybe<GlobalNote>;
  clientRequested?: Maybe<Scalars['Boolean']['output']>;
  clientRequestedBy?: Maybe<Scalars['Int']['output']>;
  clientType?: Maybe<Scalars['String']['output']>;
  codename?: Maybe<Scalars['String']['output']>;
  contactCount: Scalars['Int']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  currency?: Maybe<Scalars['String']['output']>;
  currentContacts?: Maybe<Array<Contact>>;
  documents?: Maybe<Array<Document>>;
  domains: Array<ClientDomain>;
  elUsers: Array<Person>;
  execSponsor?: Maybe<Person>;
  execSponsorID?: Maybe<Scalars['Int']['output']>;
  fiscalYearDay?: Maybe<Scalars['Int']['output']>;
  fiscalYearMonth?: Maybe<Scalars['Int']['output']>;
  forecastData?: Maybe<AccountForecastData>;
  hourlyRate1Month?: Maybe<Scalars['Float']['output']>;
  hourlyRate3Month?: Maybe<Scalars['Float']['output']>;
  hourlyRate6Month?: Maybe<Scalars['Float']['output']>;
  hourlyRate12Month?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  lastMonthAsOfDate?: Maybe<Scalars['Date']['output']>;
  lastRoadmappingStatusChange?: Maybe<Scalars['Date']['output']>;
  lastRoadmappingStatusChangeBy?: Maybe<Scalars['Int']['output']>;
  lastRoadmappingStatusChangeByUser?: Maybe<Person>;
  linkedContactCount: Scalars['Int']['output'];
  logs: Array<ClientLog>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Person>;
  msaEndOfCurrentTerm?: Maybe<Scalars['Date']['output']>;
  msaNotes?: Maybe<Scalars['String']['output']>;
  msaRenewalMethod?: Maybe<Scalars['String']['output']>;
  msaRenewalReminder?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  offices?: Maybe<Array<AccountOffice>>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  portalTags?: Maybe<Array<PortalTag>>;
  previousEmployees?: Maybe<Array<Contact>>;
  programs?: Maybe<Array<Program>>;
  projects: Array<ProgramProject>;
  pursuit?: Maybe<Scalars['Boolean']['output']>;
  rateCards?: Maybe<Array<RateCard>>;
  references?: Maybe<Array<Contact>>;
  /**  Relevance score from quick search (only populated in quick search results)  */
  relevanceScore?: Maybe<Scalars['Float']['output']>;
  revenueMetrics?: Maybe<RevenueMetrics>;
  revenueTarget?: Maybe<Scalars['Float']['output']>;
  roadmappingStatus?: Maybe<Scalars['String']['output']>;
  salesEntity?: Maybe<Scalars['Int']['output']>;
  searchableName?: Maybe<Scalars['String']['output']>;
  serviceGroup?: Maybe<ServiceGroup>;
  skills?: Maybe<Array<ProfessionalSkillTagListItem>>;
  status?: Maybe<Scalars['String']['output']>;
  suggestedSkills?: Maybe<Array<EngagementSkillSuggestion>>;
  target?: Maybe<Scalars['Boolean']['output']>;
  tdUser?: Maybe<Person>;
  tdUserId?: Maybe<Scalars['Int']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};


/** An Account */
export type AccountLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An Account */
export type AccountPhotoUrlArgs = {
  size: PhotoSizes;
};


/** An Account */
export type AccountPreviousEmployeesArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modifiedWithin?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  types?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** An Account */
export type AccountProgramsArgs = {
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Account */
export type AccountProjectsArgs = {
  endsAfter?: InputMaybe<Scalars['Date']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Account */
export type AccountRateCardsArgs = {
  konradRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  resourceDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resourceDisciplineIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resourceOfficeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AccountForecastData = {
  __typename?: 'AccountForecastData';
  opportunities: Array<ForecastOpportunityItem>;
  projects: Array<ForecastProjectItem>;
};

export type AccountInput = {
  AccountOffices?: InputMaybe<Array<AccountOfficeInput>>;
  aliases?: InputMaybe<Scalars['String']['input']>;
  allianceContacts?: InputMaybe<Array<Scalars['Int']['input']>>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  budgetCycle?: InputMaybe<Scalars['String']['input']>;
  businesses?: InputMaybe<Array<Business>>;
  clientType?: InputMaybe<Scalars['String']['input']>;
  codename?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  eluserIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  execSponsorID?: InputMaybe<Scalars['Int']['input']>;
  fiscalYearDay?: InputMaybe<Scalars['Int']['input']>;
  fiscalYearMonth?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  msaEndOfCurrentTerm?: InputMaybe<Scalars['Date']['input']>;
  msaNotes?: InputMaybe<Scalars['String']['input']>;
  msaRenewalMethod?: InputMaybe<Scalars['String']['input']>;
  msaRenewalReminder?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoKey?: InputMaybe<Scalars['String']['input']>;
  portalTagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pursuit?: InputMaybe<Scalars['Boolean']['input']>;
  requested?: InputMaybe<Scalars['Boolean']['input']>;
  revenueTarget?: InputMaybe<Scalars['Float']['input']>;
  roadmappingStatus?: InputMaybe<Scalars['String']['input']>;
  salesEntity?: InputMaybe<Scalars['Int']['input']>;
  serviceGroupID?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['Boolean']['input']>;
  tdUserId?: InputMaybe<Scalars['Int']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AccountOffice = {
  __typename?: 'AccountOffice';
  Address1?: Maybe<Scalars['String']['output']>;
  Address2?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  LocationCoordinates?: Maybe<LocationCoordinates>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type AccountOfficeInput = {
  Address1?: InputMaybe<Scalars['String']['input']>;
  Address2?: InputMaybe<Scalars['String']['input']>;
  City?: InputMaybe<Scalars['String']['input']>;
  Country?: InputMaybe<Scalars['String']['input']>;
  PostalCode?: InputMaybe<Scalars['String']['input']>;
  State?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountServiceTeam = {
  __typename?: 'AccountServiceTeam';
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  modified: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<Person>;
  permissionType: Scalars['String']['output'];
  projectAccount: Account;
  projectAccountID: Scalars['Int']['output'];
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  user: Person;
  userID: Scalars['Int']['output'];
};

export type AccountServiceTeamInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  permissionType?: InputMaybe<Scalars['String']['input']>;
  projectAccountID: Scalars['Int']['input'];
  userID?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountSimple = {
  __typename?: 'AccountSimple';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
};

export type AccountTimelineEntry = {
  __typename?: 'AccountTimelineEntry';
  account?: Maybe<Scalars['String']['output']>;
  accountId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  totalHours?: Maybe<Scalars['Int']['output']>;
};

export type ActionItem = {
  __typename?: 'ActionItem';
  accountServiceTeamID?: Maybe<Scalars['Int']['output']>;
  actionTitle: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Person;
  description?: Maybe<Scalars['String']['output']>;
  descriptionLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  descriptionLastUpdatedByUser?: Maybe<Person>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  links: Array<ActionItemLink>;
  modified: Scalars['DateTime']['output'];
  modifiedBy: Person;
  owner: Person;
  ownerID: Scalars['Int']['output'];
  primaryObjectHint?: Maybe<Scalars['String']['output']>;
  primaryObjectID: Scalars['Int']['output'];
  primaryObjectType: ActionItemObjectType;
  priority?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusDescriptionLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  statusDescriptionLastUpdatedByUser?: Maybe<Person>;
};

export type ActionItemInput = {
  actionTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['Int']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  links?: InputMaybe<Array<ActionItemLinkInput>>;
  ownerID?: InputMaybe<Scalars['Int']['input']>;
  primaryObjectID?: InputMaybe<Scalars['Int']['input']>;
  primaryObjectType?: InputMaybe<ActionItemObjectType>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ActionItemLink = {
  __typename?: 'ActionItemLink';
  actionItemID: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Person;
  id: Scalars['Int']['output'];
  objectID: Scalars['Int']['output'];
  objectType: ActionItemObjectType;
};

export type ActionItemLinkInput = {
  id: Scalars['Int']['input'];
  objectID: Scalars['Int']['input'];
  objectType: ActionItemObjectType;
};

export enum ActionItemObjectType {
  BillableHours = 'billableHours',
  Client = 'client',
  Contact = 'contact',
  Note = 'note',
  Opportunity = 'opportunity',
  Proposal = 'proposal'
}

export enum ActionItemStatus {
  Backlog = 'backlog',
  Complete = 'complete',
  Incomplete = 'incomplete',
  Pending = 'pending',
  Progress = 'progress',
  Waiting = 'waiting'
}

export enum ActivePhase {
  Design = 'Design',
  Strategy = 'Strategy',
  Technology = 'Technology'
}

export type AmountsTotalForAdmin = {
  __typename?: 'AmountsTotalForAdmin';
  active?: Maybe<Scalars['Int']['output']>;
  hoursThisMonth?: Maybe<Scalars['Int']['output']>;
  inactive?: Maybe<Scalars['Int']['output']>;
  projects?: Maybe<Scalars['Int']['output']>;
  projectsActive?: Maybe<Scalars['Int']['output']>;
  projectsInactive?: Maybe<Scalars['Int']['output']>;
  timeSheetEntries?: Maybe<Scalars['Int']['output']>;
};

export type AssignmentsLog = {
  __typename?: 'AssignmentsLog';
  affectedUser: Person;
  affectedUserId?: Maybe<Scalars['Int']['output']>;
  allocationAfter?: Maybe<Scalars['Int']['output']>;
  allocationBefore?: Maybe<Scalars['Int']['output']>;
  approvingManager?: Maybe<Person>;
  approvingManagerId?: Maybe<Scalars['Int']['output']>;
  assignedBy: Person;
  assignedById?: Maybe<Scalars['Int']['output']>;
  assignment: ProgramProjectEntry;
  assignmentStatus: Scalars['String']['output'];
  changeType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dateManagerApproved?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastLog: PlannerUserLog;
  log: PlannerUserLog;
  project: Project;
  projectId?: Maybe<Scalars['Int']['output']>;
  proposalStatus?: Maybe<Scalars['String']['output']>;
};

export type Assistant = {
  __typename?: 'Assistant';
  accountId: Scalars['Int']['output'];
  assistantId: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  userID: Scalars['Int']['output'];
  vectorStoreID?: Maybe<Scalars['String']['output']>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  Action: Scalars['String']['output'];
  Changes?: Maybe<Scalars['String']['output']>;
  Comments?: Maybe<Scalars['String']['output']>;
  Created: Scalars['DateTime']['output'];
  ID: Scalars['Int']['output'];
  Notes?: Maybe<Scalars['String']['output']>;
  ObjectID: Scalars['Int']['output'];
  ObjectType: Scalars['String']['output'];
  Original?: Maybe<Scalars['String']['output']>;
  Updated?: Maybe<Scalars['String']['output']>;
  UserID: Scalars['Int']['output'];
};

export type AvailableFloatingHoliday = {
  __typename?: 'AvailableFloatingHoliday';
  date: Scalars['DateTime']['output'];
  hasPTORequest: Scalars['Boolean']['output'];
  hasTakenFloatingHoliday: Scalars['Boolean']['output'];
  hasTravelRequest: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isBeforeWindow: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type Badge = {
  __typename?: 'Badge';
  count: Scalars['Int']['output'];
  highlight: BadgeHighlight;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum BadgeHighlight {
  Error = 'ERROR',
  None = 'NONE',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type BillableHours = {
  __typename?: 'BillableHours';
  approvals: Array<BillableHoursApproval>;
  billableHoursID: Scalars['Int']['output'];
  created: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  createdByUser?: Maybe<Person>;
  hours: Array<BillableHoursHourRow>;
  invoices: Array<Invoice>;
  locked?: Maybe<Scalars['Date']['output']>;
  month: Scalars['Date']['output'];
  projects: Array<BillableHoursProject>;
  status: Scalars['String']['output'];
  timeToComplete?: Maybe<Scalars['Int']['output']>;
  updates: Array<BillableHoursUpdate>;
};


export type BillableHoursApprovalsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillableHoursApproval = {
  __typename?: 'BillableHoursApproval';
  approvedBy: Person;
  canceledByUser?: Maybe<Person>;
  canceledOn?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
};

export type BillableHoursHour = {
  __typename?: 'BillableHoursHour';
  actualHours: Scalars['Float']['output'];
  billableHoursHoursID: Scalars['Int']['output'];
  billableHoursID: Scalars['Int']['output'];
  created: Scalars['String']['output'];
  createdBy: Scalars['Int']['output'];
  enteredHours: Scalars['Float']['output'];
  plannedHours: Scalars['Float']['output'];
  projectID: Scalars['Int']['output'];
  updated: Scalars['String']['output'];
  updatedBy: Scalars['Int']['output'];
};

export type BillableHoursHourInput = {
  actualHours: Scalars['Float']['input'];
  enteredHours?: InputMaybe<Scalars['Float']['input']>;
  plannedHours: Scalars['Float']['input'];
  projectID: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
};

export type BillableHoursHourRow = {
  __typename?: 'BillableHoursHourRow';
  actualHours: Scalars['Float']['output'];
  enteredHours?: Maybe<Scalars['Float']['output']>;
  plannedHours: Scalars['Float']['output'];
  projectID: Scalars['Int']['output'];
  userID: Scalars['Int']['output'];
};

export type BillableHoursProject = {
  __typename?: 'BillableHoursProject';
  billableHoursActualHoursDelta?: Maybe<Scalars['Float']['output']>;
  billableHoursID: Scalars['Int']['output'];
  billableHoursProjectID: Scalars['Int']['output'];
  project?: Maybe<Project>;
  projectID: Scalars['Int']['output'];
  totalHoursActual?: Maybe<Scalars['Float']['output']>;
  totalHoursActualDelta?: Maybe<Scalars['Float']['output']>;
  totalHoursEntered?: Maybe<Scalars['Float']['output']>;
  totalHoursEnteredDelta?: Maybe<Scalars['Float']['output']>;
  totalHoursHoliday?: Maybe<Scalars['Float']['output']>;
  totalHoursPTO?: Maybe<Scalars['Float']['output']>;
};

export type BillableHoursUpdate = {
  __typename?: 'BillableHoursUpdate';
  billableHoursID: Scalars['Int']['output'];
  billableHoursUpdateID: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['Int']['output'];
  updatedByUser?: Maybe<Person>;
};

/** Billing Type */
export type BillingType = {
  __typename?: 'BillingType';
  /** Billing Type Abbreviation (e.g., T&M, FP, FT, MT) */
  abbreviation: Scalars['String']['output'];
  /** Billing Type ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** Billing Type Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Billing Type Order */
  order?: Maybe<Scalars['Int']['output']>;
};

export type Birthday = {
  __typename?: 'Birthday';
  /**  User's birthday day  */
  birthdayDay: Scalars['Int']['output'];
  /**  User's birthday month  */
  birthdayMonth: Scalars['Int']['output'];
  /**  User ID  */
  id: Scalars['Int']['output'];
  /**  User's first name  */
  nameFirst: Scalars['String']['output'];
  /**  User's last name  */
  nameLast: Scalars['String']['output'];
  photo?: Maybe<Scalars['String']['output']>;
  /**  Slack User ID */
  slackUserid?: Maybe<Scalars['String']['output']>;
};

/** The business(es) a record relates to. A record can relate to Konrad, BrainStation, or both. */
export enum Business {
  BrainStation = 'BrainStation',
  Konrad = 'Konrad'
}

/** Input for upserting business days */
export type BusinessDaysInput = {
  businessDays: Scalars['Int']['input'];
  month: Scalars['Date']['input'];
};

/** Business days for a specific month */
export type BusinessDaysItem = {
  __typename?: 'BusinessDaysItem';
  businessDays: Scalars['Int']['output'];
  month: Scalars['Date']['output'];
};

export type CalendarTokenVerification = {
  __typename?: 'CalendarTokenVerification';
  token?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Candidate = {
  __typename?: 'Candidate';
  currentProjects: Array<CurrentProjectPlannerEntryV2>;
  id: Scalars['Int']['output'];
  person: Person;
  professionalSkillTags: Array<CandidateSkillTag>;
  score: Scalars['Float']['output'];
  scoreBreakdown: Array<CandidateScoreBreakdown>;
};

export type CandidateScoreBreakdown = {
  __typename?: 'CandidateScoreBreakdown';
  name: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type CandidateSkillTag = {
  __typename?: 'CandidateSkillTag';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mostRecentlyUsedDate?: Maybe<Scalars['Date']['output']>;
  skillId: Scalars['Int']['output'];
  yearsExperience?: Maybe<Scalars['Float']['output']>;
};

export type Certification = {
  __typename?: 'Certification';
  certification?: Maybe<Scalars['String']['output']>;
  certificationRefID?: Maybe<Scalars['Int']['output']>;
  expiry?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  modified?: Maybe<Scalars['Date']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  skills: Array<UserCertificationSkill>;
};

export type CertificationCertItem = {
  __typename?: 'CertificationCertItem';
  expiry?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  person: Person;
};

export type CertificationCreateInput = {
  expirationYears?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['JSON']['input']>;
  skillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeCommitmentRenewalHours?: InputMaybe<Scalars['Int']['input']>;
  timeCommitmentRequiredHours?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificationDeleteImpact = {
  __typename?: 'CertificationDeleteImpact';
  canDelete: Scalars['Boolean']['output'];
  skillCount: Scalars['Int']['output'];
  userCertificationCount: Scalars['Int']['output'];
};

export type CertificationDetailsInput = {
  expirationYears?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['JSON']['input']>;
  timeCommitmentRenewalHours?: InputMaybe<Scalars['Int']['input']>;
  timeCommitmentRequiredHours?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificationExpiringItem = {
  __typename?: 'CertificationExpiringItem';
  certification: Scalars['String']['output'];
  expiry: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  person: Person;
};

export type CertificationInput = {
  certification?: InputMaybe<Scalars['String']['input']>;
  expiry?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificationItem = {
  __typename?: 'CertificationItem';
  count: Scalars['Int']['output'];
  expirationYears?: Maybe<Scalars['Int']['output']>;
  expiredUserCertificationsCount: Scalars['Int']['output'];
  holders: Array<CertificationCertItem>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['JSON']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  skills: Array<CertificationSkillItem>;
  timeCommitmentRenewalHours?: Maybe<Scalars['Int']['output']>;
  timeCommitmentRequiredHours?: Maybe<Scalars['Int']['output']>;
};

export type CertificationListItem = {
  __typename?: 'CertificationListItem';
  count: Scalars['Int']['output'];
  expirationYears?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  skills: Array<CertificationSkillItem>;
  timeCommitmentRenewalHours?: Maybe<Scalars['Int']['output']>;
  timeCommitmentRequiredHours?: Maybe<Scalars['Int']['output']>;
};

export type CertificationNoteInput = {
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['JSON']['input']>;
};

export type CertificationSkillItem = {
  __typename?: 'CertificationSkillItem';
  id: Scalars['Int']['output'];
  skill: ProfessionalSkillTagListItem;
};

export type CertificationSkillsInput = {
  id: Scalars['String']['input'];
  skillIds: Array<Scalars['Int']['input']>;
};

export type CertifiedDeveloper = {
  __typename?: 'CertifiedDeveloper';
  certifications: Array<SkillCertification>;
  person: Person;
};

export type Change = {
  __typename?: 'Change';
  op: OperationType;
  path: Array<Scalars['String']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ChangeData = {
  __typename?: 'ChangeData';
  /** The json stringified version of the data after hte change */
  after?: Maybe<Scalars['String']['output']>;
  /** The json stringified version of the data before the change */
  before?: Maybe<Scalars['String']['output']>;
  /** The project this change is attached to where applicable */
  project?: Maybe<Project>;
};

export type City = {
  __typename?: 'City';
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  geocodeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  population: Scalars['Int']['output'];
};

export type CityCoordinatesInput = {
  cityID?: InputMaybe<Scalars['Int']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CitySearchFrequency = {
  __typename?: 'CitySearchFrequency';
  city: City;
  created: Scalars['String']['output'];
  user: Person;
};

export enum CitySearchObject {
  Client = 'client',
  Contact = 'contact'
}

export type ClientCompliance = {
  __typename?: 'ClientCompliance';
  client?: Maybe<Account>;
  clientID: Scalars['Int']['output'];
  complianceNote: Scalars['String']['output'];
  created: Scalars['Date']['output'];
  deleted?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  updated: Scalars['Date']['output'];
};

export type ClientComplianceInput = {
  clientID: Scalars['Int']['input'];
  complianceNote: Scalars['String']['input'];
};

/**
 * A client-scoped link to a OneDrive transaction document template.
 * Distinct from the global ContractTemplate entity.
 */
export type ClientContractTemplate = {
  __typename?: 'ClientContractTemplate';
  clientId: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  createdByUser?: Maybe<Person>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  documentUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modified: Scalars['DateTime']['output'];
  modifiedBy: Scalars['Int']['output'];
  modifiedByUser?: Maybe<Person>;
  title: Scalars['String']['output'];
};

export type ClientContractTemplateInput = {
  clientId: Scalars['Int']['input'];
  documentUrl: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type ClientContributor = {
  __typename?: 'ClientContributor';
  departmentID?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  managerNameFirst?: Maybe<Scalars['String']['output']>;
  managerNameLast?: Maybe<Scalars['String']['output']>;
  nameFirst?: Maybe<Scalars['String']['output']>;
  nameLast?: Maybe<Scalars['String']['output']>;
  officeID?: Maybe<Scalars['Int']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  projectID: Scalars['Int']['output'];
  projectName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<Person>;
  userID: Scalars['Int']['output'];
  userJobTitle?: Maybe<Scalars['String']['output']>;
};

export type ClientDomain = {
  __typename?: 'ClientDomain';
  domain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ClientLink = {
  __typename?: 'ClientLink';
  clientId: Scalars['Int']['output'];
  created: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  createdByObject?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  digitalExperienceLink?: Maybe<Scalars['Boolean']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  konradSupported?: Maybe<KonradSupportedType>;
  modified: Scalars['Date']['output'];
  modifiedBy: Scalars['Int']['output'];
  modifiedByObject?: Maybe<Person>;
  title: Scalars['String']['output'];
  titleAuto?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ClientLinkType>;
  url: Scalars['String']['output'];
};

export type ClientLinkInput = {
  clientId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  digitalExperienceLink?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  konradSupported?: InputMaybe<KonradSupportedType>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ClientLinkType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum ClientLinkType {
  App = 'app',
  Other = 'other',
  Product = 'product',
  Website = 'website'
}

/** Client audit log entry representing a change to a client */
export type ClientLog = {
  __typename?: 'ClientLog';
  action: ClientLogAction;
  actionDoneByUser?: Maybe<Person>;
  actionDoneByUserId: Scalars['Int']['output'];
  changes: Array<Change>;
  client?: Maybe<Account>;
  clientId: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['JSON']['output']>;
  updated?: Maybe<Scalars['JSON']['output']>;
};

/** Type of action performed on a client */
export enum ClientLogAction {
  Created = 'created',
  Deleted = 'deleted',
  Updated = 'updated'
}

export type ClientSalesMeeting = {
  __typename?: 'ClientSalesMeeting';
  client: Account;
  contacts: Array<Contact>;
  created: Scalars['DateTime']['output'];
  createdBy: User;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isInPerson: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  locationLat?: Maybe<Scalars['Float']['output']>;
  locationLon?: Maybe<Scalars['Float']['output']>;
  modified: Scalars['DateTime']['output'];
  modifiedBy: User;
  opportunities: Array<Opportunity>;
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  users: Array<Person>;
};

export type ClientSalesMeetingInput = {
  clientID: Scalars['Int']['input'];
  contactIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isInPerson?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationLat?: InputMaybe<Scalars['Float']['input']>;
  locationLon?: InputMaybe<Scalars['Float']['input']>;
  opportunityIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  userIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ClientServiceMap = {
  __typename?: 'ClientServiceMap';
  client?: Maybe<Account>;
  clientId: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  createdByUser?: Maybe<Person>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  domainName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modified: Scalars['DateTime']['output'];
  modifiedBy: Scalars['Int']['output'];
  modifiedByUser?: Maybe<Person>;
  subdomains: Array<ClientServiceMapSubdomain>;
};

export type ClientServiceMapInput = {
  clientId: Scalars['Int']['input'];
  domainName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  subdomains?: InputMaybe<Array<ClientServiceMapSubdomainInput>>;
};

export type ClientServiceMapSubdomain = {
  __typename?: 'ClientServiceMapSubdomain';
  buyers: Array<Contact>;
  clientServiceMapDomainID: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  kgContacts: Array<Person>;
  kgOfferings: Array<Scalars['Int']['output']>;
  modified: Scalars['DateTime']['output'];
  subdomainName: Scalars['String']['output'];
};

export type ClientServiceMapSubdomainInput = {
  buyers?: InputMaybe<Array<Scalars['Int']['input']>>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  kgContacts?: InputMaybe<Array<Scalars['Int']['input']>>;
  kgOfferings: Array<Scalars['Int']['input']>;
  subdomainName: Scalars['String']['input'];
};

export type ClientServiceMapSubdomainUpsertInput = {
  buyers?: InputMaybe<Array<Scalars['Int']['input']>>;
  clientServiceMapDomainID: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  kgContacts?: InputMaybe<Array<Scalars['Int']['input']>>;
  kgOfferings: Array<Scalars['Int']['input']>;
  subdomainName: Scalars['String']['input'];
};

export type ColleagueWithOverlappingProjects = {
  __typename?: 'ColleagueWithOverlappingProjects';
  colleague?: Maybe<Person>;
  overlappingProjects?: Maybe<Array<Maybe<OverlappingProject>>>;
};

export type Comment = {
  __typename?: 'Comment';
  accountServiceTeamId?: Maybe<Scalars['Int']['output']>;
  author?: Maybe<Person>;
  comment: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isStatusComment: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<Comment>;
  parentID?: Maybe<Scalars['Int']['output']>;
  primaryObjectID: Scalars['Int']['output'];
  primaryObjectType: CommentObjectType;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CommentInput = {
  comment: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isStatusComment?: InputMaybe<Scalars['Boolean']['input']>;
  parentID?: InputMaybe<Scalars['Int']['input']>;
  primaryObjectID: Scalars['Int']['input'];
  primaryObjectType: CommentObjectType;
};

export enum CommentObjectType {
  BillableHours = 'billableHours',
  Engagement = 'engagement',
  Invoice = 'invoice',
  Opportunity = 'opportunity',
  PurchaseOrder = 'purchaseOrder',
  WorkbookEngagement = 'workbookEngagement'
}

/** A List of KG Companies */
export type Companies = {
  __typename?: 'Companies';
  /** List of Companies */
  companies?: Maybe<Array<Company>>;
  /** Standard Errors */
  errors?: Maybe<Array<Maybe<StdError>>>;
};

/** A KG Company */
export type Company = {
  __typename?: 'Company';
  /** Company ID */
  CompanyID: Scalars['Int']['output'];
  /** Company Name */
  Name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type ComplianceSectionSummary = {
  __typename?: 'ComplianceSectionSummary';
  complete: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  sectionID: Scalars['String']['output'];
  violations: Scalars['Int']['output'];
};

export type ComplianceWorkbook = {
  __typename?: 'ComplianceWorkbook';
  sections: Array<Section>;
  version: Scalars['Int']['output'];
};

export type ComplianceWorkbookAnswer = {
  __typename?: 'ComplianceWorkbookAnswer';
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ComplianceWorkbookAnswerInput = {
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type ComplianceWorkbookDetails = {
  __typename?: 'ComplianceWorkbookDetails';
  answers: Array<ComplianceWorkbookAnswer>;
  assignee?: Maybe<Person>;
  assigneeID?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastReviewed?: Maybe<Scalars['DateTime']['output']>;
  lastReviewedBy?: Maybe<Scalars['Int']['output']>;
  modified: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offboardingLink?: Maybe<Scalars['String']['output']>;
  onboardingLink?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Program>;
  programID?: Maybe<Scalars['Int']['output']>;
  project?: Maybe<Project>;
  projectID?: Maybe<Scalars['Int']['output']>;
  questionsVersion: Scalars['Int']['output'];
  sectionSummary: Array<ComplianceSectionSummary>;
  technologyProject?: Maybe<Scalars['Boolean']['output']>;
};

export enum ComplianceWorkbookFieldType {
  Date = 'date',
  Multiselect = 'multiselect',
  Select = 'select',
  Text = 'text',
  TextLong = 'textLong',
  UserSelect = 'userSelect',
  Yesno = 'yesno'
}

export type ComplianceWorkbookInput = {
  answers?: InputMaybe<Array<ComplianceWorkbookAnswerInput>>;
  assigneeID?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offboardingLink?: InputMaybe<Scalars['String']['input']>;
  onboardingLink?: InputMaybe<Scalars['String']['input']>;
  programID?: InputMaybe<Scalars['Int']['input']>;
  projectID?: InputMaybe<Scalars['Int']['input']>;
  questionsVersion?: InputMaybe<Scalars['Int']['input']>;
  technologyProject?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComplianceWorkbookListItem = {
  __typename?: 'ComplianceWorkbookListItem';
  DisplayName?: Maybe<Scalars['String']['output']>;
  accountID?: Maybe<Scalars['Int']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<Person>;
  assigneeID?: Maybe<Scalars['Int']['output']>;
  complete?: Maybe<Scalars['Boolean']['output']>;
  complianceWorkbookID?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  elUser?: Maybe<Person>;
  id: Scalars['Int']['output'];
  lastReviewed?: Maybe<Scalars['DateTime']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  sectionSummary?: Maybe<Array<ComplianceSectionSummary>>;
  tdUser?: Maybe<Person>;
  technologyProject?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  violations?: Maybe<Scalars['Int']['output']>;
};

export enum ComplianceWorkbookSectionType {
  Section = 'section'
}

export type Contact = {
  __typename?: 'Contact';
  account?: Maybe<Account>;
  actionItems: Array<ActionItem>;
  address1?: Maybe<Scalars['String']['output']>;
  /** Holiday box address */
  address1HB?: Maybe<Scalars['String']['output']>;
  /** Holiday box secondary address (apt, floor, suite, etc.) */
  address1Line2HB?: Maybe<Scalars['String']['output']>;
  addressType?: Maybe<Scalars['String']['output']>;
  allianceClientCount: Scalars['Int']['output'];
  allianceClients: Array<Account>;
  buyer?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** Holiday box address */
  cityHB?: Maybe<Scalars['String']['output']>;
  completeness?: Maybe<Scalars['Int']['output']>;
  contactToMeet?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Holiday box address */
  countryHB?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<Person>;
  currentAccountID?: Maybe<Scalars['Int']['output']>;
  currentTitle?: Maybe<Scalars['String']['output']>;
  eaFor?: Maybe<Array<Maybe<Contact>>>;
  email: Array<ContactEmail>;
  executiveAssistant?: Maybe<Contact>;
  executiveAssistantID?: Maybe<Scalars['Int']['output']>;
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  giftBoxCandidate?: Maybe<Scalars['Boolean']['output']>;
  goesBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isEA?: Maybe<Scalars['Boolean']['output']>;
  isReference?: Maybe<Scalars['Boolean']['output']>;
  jobHistory: Array<ContactJobHistory>;
  lastConnected?: Maybe<Scalars['Date']['output']>;
  lastInPerson?: Maybe<Scalars['Date']['output']>;
  lastName: Scalars['String']['output'];
  linkedActionItems: Array<ActionItem>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  linkedInUsernameValid?: Maybe<Scalars['Boolean']['output']>;
  linkedOfficeAddress?: Maybe<AccountOffice>;
  linkedinData?: Maybe<Scalars['String']['output']>;
  linkedinUpdated?: Maybe<Scalars['Date']['output']>;
  locationCoordinates?: Maybe<LocationCoordinates>;
  logs: Array<ContactLog>;
  mailingAddressUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  mailingAddressUpdatedBy?: Maybe<Person>;
  modified: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<Person>;
  notes?: Maybe<Scalars['String']['output']>;
  pastGiftCampaigns: Array<GiftCampaignAndEntry>;
  personalNotes?: Maybe<Scalars['String']['output']>;
  phone: Array<ContactPhone>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  photoUrlModified?: Maybe<Scalars['DateTime']['output']>;
  portalTags: Array<PortalTag>;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Holiday box address */
  postalCodeHB?: Maybe<Scalars['String']['output']>;
  primaryMailingAddressIsCustom?: Maybe<Scalars['Boolean']['output']>;
  referenceNotes?: Maybe<Scalars['String']['output']>;
  referenceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  relationshipLeads: Array<Person>;
  /**  Relevance score from quick search (only populated in quick search results)  */
  relevanceScore?: Maybe<Scalars['Float']['output']>;
  reportingTo: Array<Contact>;
  reportsTo: Array<Contact>;
  state?: Maybe<Scalars['String']['output']>;
  /** Holiday box address */
  stateHB?: Maybe<Scalars['String']['output']>;
};


export type ContactLinkedActionItemsArgs = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ActionItemStatus>>;
};


export type ContactLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactPhotoUrlArgs = {
  size?: InputMaybe<PhotoSizes>;
};

export type ContactDuplicateFind = {
  __typename?: 'ContactDuplicateFind';
  canSee?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ContactEmail = {
  __typename?: 'ContactEmail';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContactEmailInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ContactInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address1HB?: InputMaybe<Scalars['String']['input']>;
  address1Line2HB?: InputMaybe<Scalars['String']['input']>;
  allianceClients?: InputMaybe<Array<Scalars['Int']['input']>>;
  buyer?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityHB?: InputMaybe<Scalars['String']['input']>;
  contactToMeet?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryHB?: InputMaybe<Scalars['String']['input']>;
  currentAccountID?: InputMaybe<Scalars['Int']['input']>;
  currentTitle?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Array<ContactEmailInput>>;
  executiveAssistantID?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  giftBoxCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  goesBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEA?: InputMaybe<Scalars['Boolean']['input']>;
  isReference?: InputMaybe<Scalars['Boolean']['input']>;
  jobHistory?: InputMaybe<Array<ContactJobHistoryInput>>;
  lastConnected?: InputMaybe<Scalars['Date']['input']>;
  lastInPerson?: InputMaybe<Scalars['Date']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  linkedInUsernameValid?: InputMaybe<Scalars['Boolean']['input']>;
  linkedOfficeAddress?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerID?: InputMaybe<Scalars['Int']['input']>;
  personalNotes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Array<ContactPhoneInput>>;
  photoKey?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeHB?: InputMaybe<Scalars['String']['input']>;
  primaryMailingAddressIsCustom?: InputMaybe<Scalars['Boolean']['input']>;
  referenceNotes?: InputMaybe<Scalars['String']['input']>;
  relationshipLeadIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  reportsToIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
  stateHB?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ContactJobHistory = {
  __typename?: 'ContactJobHistory';
  companyID?: Maybe<Scalars['Int']['output']>;
  companyName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  jobTitle: Scalars['String']['output'];
  untilMonth?: Maybe<Scalars['Int']['output']>;
  untilYear?: Maybe<Scalars['Int']['output']>;
};

export type ContactJobHistoryInput = {
  companyID?: InputMaybe<Scalars['Int']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  untilMonth?: InputMaybe<Scalars['Int']['input']>;
  untilYear?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactLink = {
  __typename?: 'ContactLink';
  contactId: Scalars['Int']['output'];
  created: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  createdByObject?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  modified: Scalars['Date']['output'];
  modifiedBy: Scalars['Int']['output'];
  modifiedByObject?: Maybe<Person>;
  title: Scalars['String']['output'];
  titleAuto?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContactLinkInput = {
  contactId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ContactLog = {
  __typename?: 'ContactLog';
  action: Scalars['String']['output'];
  actionDoneByUser?: Maybe<Person>;
  actionDoneByUserId: Scalars['Int']['output'];
  changes: Array<Change>;
  contact?: Maybe<Contact>;
  contactId: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['JSONObject']['output']>;
  updated?: Maybe<Scalars['JSONObject']['output']>;
};

export type ContactPhone = {
  __typename?: 'ContactPhone';
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContactPhoneInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type ContactSelectOption = {
  __typename?: 'ContactSelectOption';
  accountName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
};


export type ContactSelectOptionPhotoUrlArgs = {
  size: PhotoSizes;
};

/**
 * This is a combination of a contact and their gift campaign entry record for a specific gift campaign.
 * Since some contacts may not have a decision made for a gift campaign yet, giftCampaignEntry may be null.
 */
export type ContactWithGiftCampaignEntry = {
  __typename?: 'ContactWithGiftCampaignEntry';
  /** The contact record. */
  contact: Contact;
  /** The gift campaign entry record for the contact in the specific gift campaign. NULL if no decision has been made yet for this campaign. */
  giftCampaignEntry?: Maybe<GiftCampaignEntry>;
  /** An ID that is a combination of the campaign ID and the contact ID. `{campaignId}-{contactId}` */
  id: Scalars['ID']['output'];
};

export type Content = {
  __typename?: 'Content';
  compliant_option?: Maybe<Scalars['String']['output']>;
  hide_notes?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  options?: Maybe<Array<Option>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: ComplianceWorkbookFieldType;
};

export type ContextConfig = {
  __typename?: 'ContextConfig';
  bcc?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cc?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  company?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  office?: Maybe<Scalars['String']['output']>;
};

export type ContextConfigInput = {
  bcc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  company?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  office?: InputMaybe<Scalars['String']['input']>;
};

export enum ContractStatus {
  Signed = 'Signed',
  Unsigned = 'Unsigned'
}

/** A contract template document */
export type ContractTemplate = {
  __typename?: 'ContractTemplate';
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  createdByUser?: Maybe<Person>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  documentUrl: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  modified: Scalars['DateTime']['output'];
  modifiedBy: Scalars['Int']['output'];
  modifiedByUser?: Maybe<Person>;
  title: Scalars['String']['output'];
};

export type CreateProjectInput = {
  active: Scalars['Boolean']['input'];
  activePhases?: InputMaybe<Array<ActivePhase>>;
  billingTypeId: Scalars['Int']['input'];
  businesses?: InputMaybe<Array<Business>>;
  clientServicesLocationId?: InputMaybe<Scalars['Int']['input']>;
  completed?: InputMaybe<Scalars['Int']['input']>;
  contractStatus: ContractStatus;
  currency?: InputMaybe<Scalars['String']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  deliverySubStatus?: InputMaybe<DeliverySubStatus>;
  description?: InputMaybe<Scalars['String']['input']>;
  designLeadIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  displayName: Scalars['String']['input'];
  elUserId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['Date']['input'];
  experienceDirectorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideFromForecast?: InputMaybe<Scalars['Boolean']['input']>;
  leadBillingNotes: Scalars['String']['input'];
  opportunityId?: InputMaybe<Scalars['Int']['input']>;
  plannedHours?: InputMaybe<Scalars['Int']['input']>;
  pmUserId?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['Int']['input'];
  resourcingNotes?: InputMaybe<Scalars['String']['input']>;
  salesforceId?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startDate: Scalars['Date']['input'];
  tdUserId?: InputMaybe<Scalars['Int']['input']>;
  technologyLeadIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  value?: InputMaybe<Scalars['Float']['input']>;
  weeklyReportLastSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  weeklyReportRequired: Scalars['Boolean']['input'];
  weeklyReportSenderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  weeklyReportSent?: InputMaybe<Scalars['Boolean']['input']>;
  winPercentage?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProjectRequestInput = {
  accountId: Scalars['Int']['input'];
  billingTypeId: Scalars['Int']['input'];
  businesses?: InputMaybe<Array<Business>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  elUserId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['Date']['input'];
  hideFromForecast?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityId?: InputMaybe<Scalars['Int']['input']>;
  planLink?: InputMaybe<Scalars['String']['input']>;
  plannedHours?: InputMaybe<Scalars['Int']['input']>;
  pmUserId?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['Int']['input'];
  salesforceId?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startDate: Scalars['Date']['input'];
  tdUserId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  winPercentage?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrentProjectPlannerEntry = {
  __typename?: 'CurrentProjectPlannerEntry';
  /**  Active  */
  active?: Maybe<Scalars['Boolean']['output']>;
  /**  Allocation  */
  allocation?: Maybe<Scalars['Int']['output']>;
  /**  Assigned  */
  assigned?: Maybe<Scalars['Boolean']['output']>;
  /**  Project display name  */
  displayName?: Maybe<Scalars['String']['output']>;
  /**  Project Plannerentry end date */
  endDate?: Maybe<Scalars['Date']['output']>;
  /**  Planner Project ID  */
  id?: Maybe<Scalars['Int']['output']>;
  /**  Planner Project ID  */
  plannerEntryID?: Maybe<Scalars['Int']['output']>;
  /**  The date that the project for this entry is scheduled to end  */
  projectEndDate?: Maybe<Scalars['String']['output']>;
  /**  Project ID if available  */
  projectID?: Maybe<Scalars['Int']['output']>;
  /**  Project Type  */
  projectType?: Maybe<Scalars['String']['output']>;
  /**  Project Plannerentry start date */
  startDate?: Maybe<Scalars['Date']['output']>;
  /**  Temporary Project  */
  temporary?: Maybe<Scalars['Boolean']['output']>;
  /**  Treat as Available  */
  treatAsAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type CurrentProjectPlannerEntryV2 = {
  __typename?: 'CurrentProjectPlannerEntryV2';
  /**  Active  */
  active: Scalars['Boolean']['output'];
  /**  Allocation  */
  allocation: Scalars['Int']['output'];
  /**  Project display name  */
  displayName: Scalars['String']['output'];
  /**  Engagement Lead for a project  */
  elUser?: Maybe<Person>;
  /**  Engagement Lead for a project  */
  elUserID?: Maybe<Scalars['Int']['output']>;
  /**  Project Planner entry end date */
  endDate: Scalars['Date']['output'];
  /**  Planner Entry ID  */
  id: Scalars['Int']['output'];
  /**  Planner Entry ID  */
  plannerEntryID: Scalars['Int']['output'];
  /**  Project Manager User ID  */
  pmUserID?: Maybe<Scalars['Int']['output']>;
  /**  the Project  */
  project: Project;
  /**  Name of the Project Account  */
  projectAccountName?: Maybe<Scalars['String']['output']>;
  /**  The date that the project for this entry is scheduled to end  */
  projectEndDate?: Maybe<Scalars['Date']['output']>;
  /**  Project ID   */
  projectID: Scalars['Int']['output'];
  /**  Project Type  */
  projectType: Scalars['String']['output'];
  /**  if available the assigned role end for the record  */
  roleEnd?: Maybe<Scalars['Date']['output']>;
  /**  if available the assigned role for the record  */
  roleID?: Maybe<Scalars['Int']['output']>;
  /**  if available the assigned role start for the record  */
  roleStart?: Maybe<Scalars['Date']['output']>;
  /**  if available the assigned role title for the record  */
  roleTitle?: Maybe<Scalars['String']['output']>;
  /**  Project Planner entry start date */
  startDate: Scalars['Date']['output'];
  /** Swapability */
  swapability?: Maybe<Scalars['Int']['output']>;
  /**  Technical Director for a project  */
  tdUser?: Maybe<Person>;
  /** Technical Director User ID */
  tdUserID?: Maybe<Scalars['Int']['output']>;
  /**  Temporary Project  */
  temporary?: Maybe<Scalars['Boolean']['output']>;
  /**  Treat as Available  */
  treatAsAvailable: Scalars['Boolean']['output'];
};

export type Days = {
  __typename?: 'Days';
  /** Planned allocation to project */
  allocation?: Maybe<Scalars['Float']['output']>;
  /** End */
  end?: Maybe<Scalars['Date']['output']>;
  /** Is a half day PTO */
  halfDay?: Maybe<Scalars['Boolean']['output']>;
  /** Project End Date */
  projectEndDate?: Maybe<Scalars['String']['output']>;
  /** Project ID */
  projectID?: Maybe<Scalars['Int']['output']>;
  /** Project Name */
  projectName?: Maybe<Scalars['String']['output']>;
  /** Is PTO */
  pto?: Maybe<Scalars['Boolean']['output']>;
  /** Start */
  start?: Maybe<Scalars['Date']['output']>;
  /** Whether the assignment is marked as 'treat as available' */
  treatAsAvailable: Scalars['Boolean']['output'];
  /** PTO Type */
  type?: Maybe<Scalars['Int']['output']>;
};

export enum DeliverySubStatus {
  Accelerated = 'Accelerated',
  Archived = 'Archived',
  CloseOut = 'CloseOut',
  Completed = 'Completed',
  DeliveringAtRisk = 'DeliveringAtRisk',
  DeliveringOnTrack = 'DeliveringOnTrack',
  NotStarted = 'NotStarted',
  Paused = 'Paused',
  Planning = 'Planning'
}

/** A KG Department */
export type Department = {
  __typename?: 'Department';
  /**
   * Department ID
   * @deprecated Use `id` instead.
   */
  DepartmentID: Scalars['Int']['output'];
  /** Order to be used when in a dropdown or other sortable material */
  DropdownOrder?: Maybe<Scalars['Int']['output']>;
  /** Department Name */
  Name?: Maybe<Scalars['String']['output']>;
  /** Count of timetrackers in department */
  Timetrackers?: Maybe<Scalars['Int']['output']>;
  /** Disciplines related to that department, sorted in ascending order by DropdownOrder. */
  disciplines?: Maybe<Array<DisciplineNew>>;
  /** Department ID */
  id: Scalars['Int']['output'];
};

export type DepartmentAllocation = {
  __typename?: 'DepartmentAllocation';
  allocation?: Maybe<Scalars['Int']['output']>;
  available?: Maybe<Scalars['Int']['output']>;
  availablePercentage?: Maybe<Scalars['Float']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  disciplines?: Maybe<Array<Maybe<DisciplineAllocation>>>;
  internal?: Maybe<Scalars['Int']['output']>;
  internalPercentage?: Maybe<Scalars['Float']['output']>;
  numUsers?: Maybe<Scalars['Int']['output']>;
  project?: Maybe<Scalars['Int']['output']>;
  projectPercentage?: Maybe<Scalars['Float']['output']>;
  treatedAsAvailable?: Maybe<Scalars['Int']['output']>;
  treatedAsAvailablePercentage?: Maybe<Scalars['Float']['output']>;
};

/** A List of KG Departments */
export type Departments = {
  __typename?: 'Departments';
  /** List of Departments */
  departments?: Maybe<Array<Department>>;
  /** Standard Errors */
  errors?: Maybe<Array<Maybe<StdError>>>;
};

export type Discipline = {
  __typename?: 'Discipline';
  discipline?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type DisciplineAllocation = {
  __typename?: 'DisciplineAllocation';
  allocation?: Maybe<Scalars['Int']['output']>;
  available?: Maybe<Scalars['Int']['output']>;
  availablePercentage?: Maybe<Scalars['Float']['output']>;
  discipline?: Maybe<Scalars['String']['output']>;
  internal?: Maybe<Scalars['Int']['output']>;
  internalPercentage?: Maybe<Scalars['Float']['output']>;
  numUsers?: Maybe<Scalars['Int']['output']>;
  project?: Maybe<Scalars['Int']['output']>;
  projectPercentage?: Maybe<Scalars['Float']['output']>;
  treatedAsAvailable?: Maybe<Scalars['Int']['output']>;
  treatedAsAvailablePercentage?: Maybe<Scalars['Float']['output']>;
};

export type DisciplineInput = {
  /** Department the Discipline belongs to */
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  /** Name for the Discipline */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A KG Discipline */
export type DisciplineNew = {
  __typename?: 'DisciplineNew';
  /** Discipline Name */
  Discipline?: Maybe<Scalars['String']['output']>;
  /**
   * Discipline ID
   * @deprecated Use `id` instead.
   */
  DisciplineID: Scalars['Int']['output'];
  /** Order to be used when in a dropdown or other sortable material */
  DropdownOrder?: Maybe<Scalars['Int']['output']>;
  /** Count of timetrackers in department */
  Timetrackers?: Maybe<Scalars['Int']['output']>;
  /** Count of users with this discipline */
  count?: Maybe<Scalars['Int']['output']>;
  /** Department */
  department: Department;
  /** List of users with this discipline */
  holders?: Maybe<Array<Person>>;
  /** Discipline ID */
  id: Scalars['Int']['output'];
  /** Skills associated with this discipline */
  skills?: Maybe<Array<ProfessionalSkillTagListItem>>;
};

export type Document = {
  __typename?: 'Document';
  accountServiceTeamID?: Maybe<Scalars['Int']['output']>;
  active: Scalars['Boolean']['output'];
  allVersions: Array<File>;
  created: Scalars['DateTime']['output'];
  createdByUser: Person;
  currentFile: File;
  currentFileEffectiveDate?: Maybe<Scalars['Date']['output']>;
  currentFileId?: Maybe<Scalars['Int']['output']>;
  currentFileMimeType?: Maybe<Scalars['String']['output']>;
  currentFileOriginalName?: Maybe<Scalars['String']['output']>;
  currentFileSize?: Maybe<Scalars['Int']['output']>;
  currentFileVersion: Scalars['Int']['output'];
  generatedSourceTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  modified: Scalars['DateTime']['output'];
  modifiedByUser: Person;
  primaryObjectID: Scalars['Int']['output'];
  primaryObjectType: DocumentObjectType;
  sourceURL?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  types: Array<PortalTag>;
};

export type DocumentInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  currentFileEffectiveDate?: InputMaybe<Scalars['Date']['input']>;
  currentFileId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  primaryObjectID?: InputMaybe<Scalars['Int']['input']>;
  primaryObjectType?: InputMaybe<DocumentObjectType>;
  sourceURL?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DocumentObjectType {
  Client = 'client',
  Contact = 'contact',
  Engagement = 'engagement',
  InvoiceDocument = 'invoiceDocument',
  InvoiceFile = 'invoiceFile',
  Opportunity = 'opportunity',
  Proposal = 'proposal',
  PurchaseOrder = 'purchaseOrder'
}

export type EditHistoryItem = {
  __typename?: 'EditHistoryItem';
  activeVersion: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  generatedProfiles: Array<GeneratedProfile>;
  refinementIndex: Scalars['Int']['output'];
  refinementNote: Scalars['String']['output'];
};

export type EditHistoryItemInput = {
  activeVersion: Scalars['Int']['input'];
  createdAt: Scalars['DateTime']['input'];
  generatedProfiles: Array<GeneratedProfileInput>;
  refinementIndex: Scalars['Int']['input'];
  refinementNote: Scalars['String']['input'];
};

/**
 * A Email Frequency
 * - This is a list of dates and the number of emails sent per week
 * - The date is the start of the week
 */
export type EmailFrequencyWeekly = {
  __typename?: 'EmailFrequencyWeekly';
  count: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
};

export type EmailLog = {
  __typename?: 'EmailLog';
  attachments?: Maybe<Scalars['Int']['output']>;
  bcc?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  template: Scalars['String']['output'];
  to?: Maybe<Scalars['String']['output']>;
  unfilteredBcc?: Maybe<Scalars['String']['output']>;
  unfilteredCc?: Maybe<Scalars['String']['output']>;
  unfilteredTo?: Maybe<Scalars['String']['output']>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  contextConfig?: Maybe<Array<Maybe<ContextConfig>>>;
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  dateModified?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isSystemGenerated: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  templateConfig?: Maybe<TemplateConfig>;
  vars?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Not a real version — was overloaded as a system/admin flag and is never incremented. Use `isSystemGenerated`. */
  version: Scalars['Int']['output'];
};

export type EmailTemplateResponse = {
  __typename?: 'EmailTemplateResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EmployementChangeLogInput = {
  affectedUserId: Scalars['Int']['input'];
  completed: Scalars['Boolean']['input'];
  dateToExecuteUpdate?: InputMaybe<Scalars['Date']['input']>;
  detailsAfter: UserObjInput;
  detailsBefore: UserObjInput;
  employmentTypeChange: EmploymentChangeType;
};

export enum EmploymentChangeType {
  BecomeTimeTrackingEmployee = 'BecomeTimeTrackingEmployee',
  CorrectStartDate = 'CorrectStartDate',
  Rehire = 'Rehire',
  TemporaryToFullTime = 'TemporaryToFullTime'
}

/** A KG Event */
export type EmploymentEvent = {
  __typename?: 'EmploymentEvent';
  /** Additional Text */
  AdditionalText?: Maybe<Scalars['String']['output']>;
  End?: Maybe<Scalars['Date']['output']>;
  /** Job Title */
  JobTitle?: Maybe<Scalars['String']['output']>;
  /** Notes */
  Notes?: Maybe<Scalars['String']['output']>;
  /** Event Date */
  Start: Scalars['Date']['output'];
  /** Event Type */
  Type: Scalars['Int']['output'];
  /** Event ID */
  id: Scalars['Int']['output'];
};

export type EmploymentEventInput = {
  /** Additional Text */
  additionalText?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  /** Job Title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Event Date */
  start: Scalars['Date']['input'];
  /** Event Type */
  type: Scalars['Int']['input'];
};

export type EmploymentTypeChangeLog = {
  __typename?: 'EmploymentTypeChangeLog';
  Completed: Scalars['Boolean']['output'];
  Created: Scalars['Date']['output'];
  DateToExecuteUpdate?: Maybe<Scalars['Date']['output']>;
  DetailsAfter: Scalars['String']['output'];
  DetailsBefore: Scalars['String']['output'];
  EmploymentTypeChange: EmploymentChangeType;
  UserIDAffected: Scalars['Int']['output'];
  UserIDChangeMadeBy: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type EngagementSkillSuggestion = {
  __typename?: 'EngagementSkillSuggestion';
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  projects: Array<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  skillID: Scalars['Int']['output'];
};

/** A KG Event */
export type Event = {
  __typename?: 'Event';
  /** Event Created Date */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Department List */
  departmentIDList?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** End Date */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Event ID */
  eventID: Scalars['String']['output'];
  /** Featured */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** Gallery */
  gallery?: Maybe<Array<Maybe<EventImage>>>;
  /** Holiday Type */
  holidayType?: Maybe<Scalars['String']['output']>;
  /** Icon Value */
  icon?: Maybe<Scalars['String']['output']>;
  /** Image */
  image?: Maybe<EventImage>;
  /** Image (large */
  imageLarge?: Maybe<EventImage>;
  /** Event Location */
  location?: Maybe<Scalars['String']['output']>;
  /** Long Description */
  longDescription?: Maybe<Scalars['String']['output']>;
  /** Long Description without HTML */
  markdownDescription?: Maybe<Scalars['String']['output']>;
  /** Minor event flag (like lunch) */
  minor?: Maybe<Scalars['Boolean']['output']>;
  /** Office Portal ID */
  officeID?: Maybe<Scalars['Int']['output']>;
  /** Office List */
  officeIDList?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Office Title */
  officeTitle?: Maybe<Scalars['String']['output']>;
  /** Published Date */
  published?: Maybe<Scalars['Date']['output']>;
  /** Published By */
  publishedBy?: Maybe<Scalars['String']['output']>;
  /** RSVP To */
  rsvpText?: Maybe<Scalars['String']['output']>;
  /** RSVP To */
  rsvpTo?: Maybe<Scalars['String']['output']>;
  /** Short Description */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** Start Date */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** TBD flag */
  tbd?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Event Updated Date */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Event Image Properties */
export type EventImage = {
  __typename?: 'EventImage';
  contentType?: Maybe<Scalars['String']['output']>;
  eventImageID?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  thumb?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type EventImageV2 = {
  __typename?: 'EventImageV2';
  eventImageID: Scalars['Int']['output'];
  imageKey?: Maybe<Scalars['String']['output']>;
  imageUrl: Scalars['String']['output'];
  large: Scalars['String']['output'];
  thumb: Scalars['String']['output'];
};

export type EventInputV2 = {
  departmentIdList?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  excludedDays?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  imageKey: Scalars['String']['input'];
  imageList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  location?: InputMaybe<Scalars['String']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  minor?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyOn?: InputMaybe<Scalars['String']['input']>;
  monthlyOnDay?: InputMaybe<Scalars['String']['input']>;
  officeIdList: Array<InputMaybe<Scalars['Int']['input']>>;
  published?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBy?: InputMaybe<Scalars['String']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  recurringEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  recurringStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  rsvpText?: InputMaybe<Scalars['String']['input']>;
  rsvpTo?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  tbd?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  weeklyOn?: InputMaybe<Scalars['String']['input']>;
};

/** A KG Event */
export type EventV2 = {
  __typename?: 'EventV2';
  /** Event Created Date */
  createdAt: Scalars['DateTime']['output'];
  /** Department List */
  departmentList: Array<Department>;
  /** End Date */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Excluded Days */
  excludedDays?: Maybe<Scalars['String']['output']>;
  /** Featured */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** Gallery */
  gallery: Array<EventImageV2>;
  /** Icon Type */
  icon?: Maybe<Scalars['String']['output']>;
  /** Event ID */
  id: Scalars['Int']['output'];
  /** Image URL */
  image?: Maybe<Scalars['String']['output']>;
  /** Image Key */
  imageKey?: Maybe<Scalars['String']['output']>;
  /** Image URL */
  imageLg?: Maybe<Scalars['String']['output']>;
  /** Image URL */
  imageThumb?: Maybe<Scalars['String']['output']>;
  /** Event Location */
  location?: Maybe<Scalars['String']['output']>;
  /** Long Description */
  longDescription?: Maybe<Scalars['String']['output']>;
  /** Minor event flag (like lunch) */
  minor?: Maybe<Scalars['Boolean']['output']>;
  /** Monthly On */
  monthlyOn?: Maybe<Scalars['String']['output']>;
  /** Monthly On Day */
  monthlyOnDay?: Maybe<Scalars['String']['output']>;
  /** Office List */
  officeList: Array<Office>;
  /** Published Date */
  published?: Maybe<Scalars['DateTime']['output']>;
  /** Published By */
  publishedBy?: Maybe<Scalars['String']['output']>;
  /** Recurring */
  recurring?: Maybe<Scalars['Boolean']['output']>;
  /** Recurring End Date */
  recurringEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Recurring Start Date */
  recurringStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** RSVP To */
  rsvpText?: Maybe<Scalars['String']['output']>;
  /** RSVP To */
  rsvpTo?: Maybe<Scalars['String']['output']>;
  /** Short Description */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** Slug */
  slug: Scalars['String']['output'];
  /** Start Date */
  startDate: Scalars['DateTime']['output'];
  /** TBD flag */
  tbd?: Maybe<Scalars['Boolean']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Event Updated Date */
  updatedAt: Scalars['DateTime']['output'];
  /** Weekly On */
  weeklyOn?: Maybe<Scalars['String']['output']>;
};

/** A List of KG Events */
export type Events = {
  __typename?: 'Events';
  /** Standard Errors */
  errors?: Maybe<Array<Maybe<StdError>>>;
  /** List of Events */
  events?: Maybe<Array<Maybe<Event>>>;
};

/** A KG featureFlag */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /** FeatureFlag Status */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** FeatureFlag Description */
  description?: Maybe<Scalars['String']['output']>;
  /** FeatureFlag ID */
  id: Scalars['ID']['output'];
  /** FeatureFlag */
  name?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagList = {
  __typename?: 'FeatureFlagList';
  /** FeatureFlagList */
  featureFlags: Array<FeatureFlag>;
};

export type File = {
  __typename?: 'File';
  created: Scalars['DateTime']['output'];
  createdByUser: Person;
  document: Document;
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  modified: Scalars['DateTime']['output'];
  modifiedByUser: Person;
  originalName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type FileInput = {
  documentId?: InputMaybe<Scalars['Int']['input']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type FiltersArgs = {
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  disciplines?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  levels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offices?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type FloatingHoliday = {
  __typename?: 'FloatingHoliday';
  date: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  office: Office;
  ptoDay: PtoDay;
  ptoDayId: Scalars['Int']['output'];
  user: Person;
  userId: Scalars['Int']['output'];
};

export type FloatingHolidayBalance = {
  __typename?: 'FloatingHolidayBalance';
  floatingHolidayAllowance: Scalars['Int']['output'];
  floatingHolidaysTaken: Scalars['Int']['output'];
};

export type ForecastDataInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  month?: InputMaybe<Scalars['Date']['input']>;
  objectID: Scalars['Int']['input'];
  objectType: ForecastType;
};

export type ForecastDetails = {
  __typename?: 'ForecastDetails';
  Amount: Scalars['Float']['output'];
  Hours: Scalars['Float']['output'];
  Month: Scalars['String']['output'];
  RevRec?: Maybe<Scalars['Float']['output']>;
};

export type ForecastItem = ForecastOpportunityItem | ForecastProjectItem;

export type ForecastOpportunityItem = {
  __typename?: 'ForecastOpportunityItem';
  amount?: Maybe<Scalars['Float']['output']>;
  created: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modified: Scalars['Date']['output'];
  modifiedBy: Scalars['Int']['output'];
  month: Scalars['Date']['output'];
  opportunityID: Scalars['Int']['output'];
};

export type ForecastProjectItem = {
  __typename?: 'ForecastProjectItem';
  amount?: Maybe<Scalars['Float']['output']>;
  created: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modified: Scalars['Date']['output'];
  modifiedBy: Scalars['Int']['output'];
  month: Scalars['Date']['output'];
  projectID: Scalars['Int']['output'];
  recognized?: Maybe<Scalars['Float']['output']>;
};

export enum ForecastType {
  Opportunity = 'opportunity',
  Project = 'project'
}

/**  A work history that is not in the workhistory table, and is generated from a person's timetrackerentry  */
export type GeneratedPersonWorkHistory = {
  __typename?: 'GeneratedPersonWorkHistory';
  /**  The end date of the work history item  */
  endDate: Scalars['Date']['output'];
  /**  The hours worked on the project  */
  hoursWorked: Scalars['Float']['output'];
  /**  The ID of the work history item  */
  id: Scalars['String']['output'];
  /**  The project the work history item is associated with  */
  project: Project;
  /**  The start date of the work history item  */
  startDate: Scalars['Date']['output'];
};

export type GeneratedProfile = {
  __typename?: 'GeneratedProfile';
  bio: Scalars['String']['output'];
  name: Scalars['String']['output'];
  projects: Array<ProjectItem>;
  skills: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type GeneratedProfileInput = {
  bio: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projects: Array<ProjectItemInput>;
  skills: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** A gift campaign represents a holiday gifting initiative with a specific delivery date */
export type GiftCampaign = {
  __typename?: 'GiftCampaign';
  /** Get the progress of the address confirmation. */
  addressConfirmationProgress: Scalars['Int']['output'];
  campaignTitle: Scalars['String']['output'];
  completed: Scalars['Boolean']['output'];
  created: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  /** Get all contacts that have a decision made for this campaign */
  giftCampaignEntries: Array<GiftCampaignEntry>;
  id: Scalars['Int']['output'];
  modified?: Maybe<Scalars['Date']['output']>;
  modifiedBy?: Maybe<Scalars['Int']['output']>;
  /**
   * Get the progress of the gift campaign.
   * Will be 100% if the campaign is completed.
   */
  recipientSelectionProgress: Scalars['Int']['output'];
  /** Get the progress of the shipping */
  shippingProgress: Scalars['Int']['output'];
};

export type GiftCampaignAndEntry = {
  __typename?: 'GiftCampaignAndEntry';
  /** The gift campaign record. */
  giftCampaign: GiftCampaign;
  /** The gift campaign entry record. */
  giftCampaignEntry: GiftCampaignEntry;
  /** And id used for caching purposes, is a combination of the campaign ID and the entry ID. `{campaignId}-{entryId}` */
  id: Scalars['ID']['output'];
};

/** Represents a contact's participation in a gift campaign with approval statuses */
export type GiftCampaignEntry = {
  __typename?: 'GiftCampaignEntry';
  address1HB?: Maybe<Scalars['String']['output']>;
  address1Line2HB?: Maybe<Scalars['String']['output']>;
  addressApproved?: Maybe<Scalars['Boolean']['output']>;
  addressApprovedBy?: Maybe<Scalars['Int']['output']>;
  campaignId: Scalars['Int']['output'];
  cityHB?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  contactId: Scalars['Int']['output'];
  countryHB?: Maybe<Scalars['String']['output']>;
  created: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  giftApproved?: Maybe<Scalars['Boolean']['output']>;
  giftApprovedBy?: Maybe<Scalars['Int']['output']>;
  giftShipped?: Maybe<Scalars['Boolean']['output']>;
  giftShippedBy?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isVerifiedAddress?: Maybe<Scalars['Boolean']['output']>;
  linkedAccountOffice?: Maybe<AccountOffice>;
  linkedAccountOfficeId?: Maybe<Scalars['Int']['output']>;
  modified?: Maybe<Scalars['Date']['output']>;
  modifiedBy?: Maybe<Scalars['Int']['output']>;
  postalCodeHB?: Maybe<Scalars['String']['output']>;
  sendToAddressType?: Maybe<SendToAddressType>;
  stateHB?: Maybe<Scalars['String']['output']>;
};

/** Filters for querying gift campaigns */
export type GiftCampaignFilters = {
  deliveryDateEnd?: InputMaybe<Scalars['Date']['input']>;
  deliveryDateStart?: InputMaybe<Scalars['Date']['input']>;
};

export type GlobalNote = {
  __typename?: 'GlobalNote';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['JSONObject']['output']>;
  objectID: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HandbookAcceptedLog = {
  __typename?: 'HandbookAcceptedLog';
  dateAccepted?: Maybe<Scalars['DateTime']['output']>;
  handbook?: Maybe<HandbookDoc>;
  id: Scalars['Int']['output'];
};

export type HandbookDoc = {
  __typename?: 'HandbookDoc';
  acceptable?: Maybe<Scalars['Boolean']['output']>;
  category: Scalars['String']['output'];
  companyId?: Maybe<Scalars['Int']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  dateUpdated: Scalars['DateTime']['output'];
  departmentId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  iframe?: Maybe<Scalars['Boolean']['output']>;
  link: Scalars['String']['output'];
  officeId?: Maybe<Scalars['Int']['output']>;
  openType?: Maybe<Scalars['Int']['output']>;
  permissionId?: Maybe<Scalars['Int']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
};

export type HandbookUpdateLog = {
  __typename?: 'HandbookUpdateLog';
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  handbook?: Maybe<HandbookDoc>;
  id: Scalars['Int']['output'];
  user?: Maybe<Person>;
};

export type HandbookUpdatesLogs = {
  __typename?: 'HandbookUpdatesLogs';
  errors?: Maybe<Array<Maybe<StdError>>>;
  logs?: Maybe<Array<HandbookUpdateLog>>;
};

export type Hours = {
  __typename?: 'Hours';
  /**
   * Historical provenance: hours the team member added beyond the autofilled
   * amount at submission time. Updated on team-member edits. May diverge from
   * `hours` after admin edits.
   */
  additionalHours?: Maybe<Scalars['Int']['output']>;
  /** Planned allocation to project */
  allocation?: Maybe<Scalars['Float']['output']>;
  /**
   * Historical provenance: hours originally populated by the autofill algorithm
   * (and PTO / floating-holiday sync, which behave the same way). Set once when
   * the system writes the row; not modified by subsequent team-member or admin
   * edits. May diverge from `hours` after admin edits. NULL = no system-fill
   * component.
   */
  autofillHours?: Maybe<Scalars['Int']['output']>;
  /** Date */
  date: Scalars['Date']['output'];
  /**
   * Entry ID
   * @deprecated Use `id` instead.
   */
  entryID: Scalars['Int']['output'];
  /** Entry State ID */
  entryStateID?: Maybe<Scalars['Int']['output']>;
  /**
   * Canonical total hours. Authoritative for downstream consumers. Originally
   * `autofillHours + additionalHours` at submission time, but may be adjusted
   * independently by manager/admin edits; the two provenance fields are not
   * guaranteed to sum to this value.
   */
  hours?: Maybe<Scalars['Int']['output']>;
  /** id */
  id: Scalars['Int']['output'];
  /** Project End Date */
  projectEndDate?: Maybe<Scalars['String']['output']>;
  /** Project ID */
  projectID?: Maybe<Scalars['Int']['output']>;
  /** Project Name */
  projectName?: Maybe<Scalars['String']['output']>;
  /** PTO Project */
  pto?: Maybe<Scalars['Boolean']['output']>;
  /** Temp Status */
  temporary?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the assignment is marked as 'treat as available' */
  treatAsAvailable: Scalars['Boolean']['output'];
  /** User ID */
  userID?: Maybe<Scalars['Int']['output']>;
};

export type HoursAndRevenueGroupedByRegion = {
  __typename?: 'HoursAndRevenueGroupedByRegion';
  HrsBillable: Scalars['Int']['output'];
  Month: Scalars['Int']['output'];
  Region: Scalars['Int']['output'];
  RevenueTotal?: Maybe<Scalars['Float']['output']>;
  Year: Scalars['Int']['output'];
};

export type HoursGrouped = {
  __typename?: 'HoursGrouped';
  /** Billing Type info */
  billingType?: Maybe<BillingType>;
  /** Company the hours belong to */
  company?: Maybe<Company>;
  /** Total Hours */
  hrsTotal?: Maybe<Scalars['String']['output']>;
  /** Month */
  month?: Maybe<Scalars['Int']['output']>;
  /** Project Type */
  projectType?: Maybe<Scalars['String']['output']>;
  /** Year */
  year?: Maybe<Scalars['Int']['output']>;
};

export type HoursGroupedAlt = {
  __typename?: 'HoursGroupedAlt';
  Btype?: Maybe<Scalars['String']['output']>;
  HrsTotal: Scalars['Int']['output'];
  Month: Scalars['Int']['output'];
  Year: Scalars['Int']['output'];
};

export type HoursGroupedByOffice = {
  __typename?: 'HoursGroupedByOffice';
  Btype?: Maybe<Scalars['String']['output']>;
  HrsTotal: Scalars['Int']['output'];
  Month: Scalars['Int']['output'];
  OfficeID: Scalars['Int']['output'];
  Year: Scalars['Int']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float']['output'];
  approvalCount: Scalars['Int']['output'];
  approvals: Array<InvoiceApproval>;
  billableHours: Array<BillableHours>;
  billingPeriodStartDate?: Maybe<Scalars['Date']['output']>;
  client: Account;
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  dateSent?: Maybe<Scalars['Date']['output']>;
  documents: Array<Document>;
  dueBy?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  invoiceDate: Scalars['Date']['output'];
  invoiceFiles: Array<Document>;
  links: Array<InvoiceLink>;
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  netSuite?: Maybe<Scalars['String']['output']>;
  paymentTerms: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  urls: Array<InvoiceUrl>;
};


export type InvoiceApprovalsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceApproval = {
  __typename?: 'InvoiceApproval';
  approvedBy: Person;
  canceledByUser?: Maybe<Person>;
  canceledOn?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
};

export type InvoiceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  billableHoursIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  billingPeriodStartDateMonth?: InputMaybe<Scalars['Int']['input']>;
  billingPeriodStartDateYear?: InputMaybe<Scalars['Int']['input']>;
  clientID?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dateSent?: InputMaybe<Scalars['Date']['input']>;
  dueBy?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceDate?: InputMaybe<Scalars['Date']['input']>;
  links?: InputMaybe<Array<InvoiceLinkInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  netSuite?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  urls?: InputMaybe<Array<InvoiceUrlInput>>;
};

export type InvoiceLink = {
  __typename?: 'InvoiceLink';
  createdAt: Scalars['String']['output'];
  createdBy: Person;
  id: Scalars['Int']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  invoiceID: Scalars['Int']['output'];
  objectID: Scalars['Int']['output'];
  objectType: InvoiceObjectType;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InvoiceLinkInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  objectID: Scalars['Int']['input'];
  objectType: InvoiceObjectType;
};

export enum InvoiceObjectType {
  Document = 'document',
  Engagement = 'engagement',
  InvoiceDocument = 'invoiceDocument',
  Link = 'link',
  PurchaseOrder = 'purchaseOrder'
}

export type InvoiceUrl = {
  __typename?: 'InvoiceURL';
  created: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoice: Invoice;
  modified: Scalars['Date']['output'];
  modifiedBy: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  titleAuto?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InvoiceUrlInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceID?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type Job = {
  __typename?: 'Job';
  completed?: Maybe<Scalars['DateTime']['output']>;
  interval: Scalars['String']['output'];
  jobName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  started?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

export type JobLog = {
  __typename?: 'JobLog';
  completed?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  messages?: Maybe<Array<LogMessage>>;
  name?: Maybe<Scalars['String']['output']>;
  started?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** A Job Title, Unique on title and department combination */
export type JobTitle = {
  __typename?: 'JobTitle';
  /** Department */
  department: Department;
  /** Job Title Id */
  id: Scalars['Int']['output'];
  /** Title name */
  jobTitle: Scalars['String']['output'];
  /** General experience bucket that the role falls in. e.g. associate, intermediate, senior, legend */
  level?: Maybe<Scalars['String']['output']>;
  /** Flag for if this role can be leveraged with clients */
  leverageable?: Maybe<Scalars['Boolean']['output']>;
  /** Sort order - ranking where 1 is the highest rank */
  order: Scalars['Int']['output'];
  /** Job Title Id */
  titleId: Scalars['Int']['output'];
};

export enum KgBusiness {
  /**  all brainstation branded departments */
  Brainstation = 'brainstation',
  /**  only consulting departments */
  Consulting = 'consulting',
  /**  all konrad branded departments */
  Konrad = 'konrad',
  /**  only ops departments, all businesses */
  Ops = 'ops'
}

export type KgNotification = {
  __typename?: 'KGNotification';
  archived: Scalars['Boolean']['output'];
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  important: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  readStatus: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userID: Scalars['Int']['output'];
};

export type KgNotificationInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  readStatus?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum KonradSupportedType {
  Active = 'active',
  No = 'no',
  Previously = 'previously'
}

export type LlmConversation = {
  __typename?: 'LLMConversation';
  conversationId?: Maybe<Scalars['String']['output']>;
  created: Scalars['Date']['output'];
  deleted?: Maybe<Scalars['Date']['output']>;
  historyItem: LlmConversationHistoryItem;
  id: Scalars['String']['output'];
  inputTokensUsed: Scalars['Int']['output'];
  messages?: Maybe<Array<LlmMessage>>;
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outputTokensUsed: Scalars['Int']['output'];
  pinned: Scalars['Boolean']['output'];
  reasoningEffortLevel?: Maybe<LlmReasoningEffortLevel>;
  reasoningEnabled: Scalars['Boolean']['output'];
  reasoningTokensUsed: Scalars['Int']['output'];
  searchEnabled: Scalars['Boolean']['output'];
  toolsEnabled: Scalars['Boolean']['output'];
  totalTokensUsed: Scalars['Int']['output'];
  updated: Scalars['Date']['output'];
  user?: Maybe<PersonSimple>;
  userId: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type LlmConversationHistoryItem = {
  __typename?: 'LLMConversationHistoryItem';
  created: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pinned: Scalars['Boolean']['output'];
  updated: Scalars['Date']['output'];
};

export type LlmMcpCall = {
  __typename?: 'LLMMcpCall';
  arguments: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  result: Scalars['JSON']['output'];
  serverLabel: Scalars['String']['output'];
};

export type LlmMessage = {
  __typename?: 'LLMMessage';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  likedStatus?: Maybe<LlmMessageLikedStatus>;
  mcpCalls?: Maybe<Array<LlmMcpCall>>;
  model: Scalars['String']['output'];
  modelOptions: LlmMessageOptions;
  reasoningSummary?: Maybe<Array<Scalars['String']['output']>>;
  role: LlmMessageRole;
  sources?: Maybe<Array<LlmSource>>;
  timeToGenerate?: Maybe<Scalars['Float']['output']>;
  timestamp: Scalars['DateTime']['output'];
  tokensUsed?: Maybe<LlmTokenUsage>;
  toolCalls?: Maybe<Array<LlmToolCall>>;
  wasCancelled?: Maybe<Scalars['Boolean']['output']>;
};

export enum LlmMessageLikedStatus {
  Disliked = 'disliked',
  Liked = 'liked'
}

export type LlmMessageOptions = {
  __typename?: 'LLMMessageOptions';
  reasoning?: Maybe<Scalars['Boolean']['output']>;
  reasoningEffortLevel?: Maybe<LlmReasoningEffortLevel>;
  tools?: Maybe<Scalars['Boolean']['output']>;
  webSearch?: Maybe<Scalars['Boolean']['output']>;
};

export enum LlmMessageRole {
  Assistant = 'assistant',
  System = 'system',
  User = 'user'
}

export type LlmOption = {
  __typename?: 'LLMOption';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  isReasoningEnabled: Scalars['Boolean']['output'];
  isToolsEnabled: Scalars['Boolean']['output'];
  isWebSearchEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum LlmReasoningEffortLevel {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type LlmSource = {
  __typename?: 'LLMSource';
  endIndex: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  startIndex: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LlmTokenUsage = {
  __typename?: 'LLMTokenUsage';
  /** The number of input tokens used. Includes system messages and all message history passed into the model including all previous user input and model output. */
  input: Scalars['Int']['output'];
  /** The number of output tokens used. Includes the response from the model and any additional tokens used for reasoning. I.e to get just the tokens used in the models response, you would subtract reasoning from output. */
  output: Scalars['Int']['output'];
  /** The number of tokens used for reasoning, if applicable. */
  reasoning?: Maybe<Scalars['Int']['output']>;
  /** The total number of tokens used (input + output) */
  total: Scalars['Int']['output'];
};

export type LlmTool = {
  __typename?: 'LLMTool';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type LlmToolCall = {
  __typename?: 'LLMToolCall';
  arguments: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayText: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  result: Scalars['JSON']['output'];
};

export type LastWorkedWithInfo = {
  __typename?: 'LastWorkedWithInfo';
  /**  Whether both people are currently actively working on this project together (within last 14 days)  */
  isOngoing: Scalars['Boolean']['output'];
  /**  The date when their collaboration on this project ended (last day both had overlapping work)  */
  lastWorkedDate: Scalars['Date']['output'];
  /**  The unique database ID of the project  */
  projectId: Scalars['Int']['output'];
  /**  The display name of the project where both people collaborated  */
  projectName: Scalars['String']['output'];
};

export type License = {
  __typename?: 'License';
  alertOnFind?: Maybe<Scalars['Boolean']['output']>;
  approved?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  globalStatus: LicenseStatus;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  rejected?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LicenseInput = {
  alertOnFind?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  globalStatus?: InputMaybe<LicenseStatus>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LicensePackage = {
  __typename?: 'LicensePackage';
  alertOnFind?: Maybe<Scalars['Boolean']['output']>;
  approved?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  globalStatus: LicenseStatus;
  id: Scalars['Int']['output'];
  license?: Maybe<Scalars['String']['output']>;
  licenseProjects?: Maybe<Array<Maybe<LicenseProject>>>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  packageManagementSystem?: Maybe<Scalars['String']['output']>;
  rejected?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LicensePackageInput = {
  alertOnFind?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseManual?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  packageManagementSystem?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  versions?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LicenseProject = {
  __typename?: 'LicenseProject';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastScan?: Maybe<Scalars['DateTime']['output']>;
  latestPrimaryScan?: Maybe<LicenseProjectScan>;
  latestScan?: Maybe<LicenseProjectScan>;
  licenses: Array<LicenseProjectLicense>;
  log?: Maybe<Array<Maybe<LicenseProjectLog>>>;
  name: Scalars['String']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  packages: Array<LicenseProjectPackage>;
  primaryBranch?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  projectID?: Maybe<Scalars['Int']['output']>;
  scans: Array<LicenseProjectScan>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LicenseProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  owner?: InputMaybe<Scalars['String']['input']>;
  primaryBranch?: InputMaybe<Scalars['String']['input']>;
  projectID?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LicenseProjectLicense = {
  __typename?: 'LicenseProjectLicense';
  approved?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rejected?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  status: LicenseStatus;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type LicenseProjectLicenseInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type LicenseProjectLog = {
  __typename?: 'LicenseProjectLog';
  id: Scalars['Int']['output'];
  licenseProject: LicenseProject;
  logDate: Scalars['DateTime']['output'];
  logLinkId?: Maybe<Scalars['Int']['output']>;
  logMessage: Scalars['String']['output'];
  logType: Scalars['String']['output'];
};

export type LicenseProjectPackage = {
  __typename?: 'LicenseProjectPackage';
  approved?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rejected?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  status: LicenseStatus;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type LicenseProjectPackageInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type LicenseProjectScan = {
  __typename?: 'LicenseProjectScan';
  branch: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  licenseCount?: Maybe<Scalars['Int']['output']>;
  licenseProject?: Maybe<LicenseProject>;
  packageCount?: Maybe<Scalars['Int']['output']>;
  packages: Array<LicenseProjectScanPackage>;
  pass: Scalars['Boolean']['output'];
  scanDate: Scalars['DateTime']['output'];
  violations?: Maybe<Scalars['Int']['output']>;
};

export type LicenseProjectScanInput = {
  branch: Scalars['String']['input'];
  licenseProject: Scalars['String']['input'];
  packages: Array<LicenseProjectScanPackageInput>;
  pass: Scalars['Boolean']['input'];
};

export type LicenseProjectScanPackage = {
  __typename?: 'LicenseProjectScanPackage';
  approvalType?: Maybe<Scalars['String']['output']>;
  approved?: Maybe<Scalars['DateTime']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  license?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  packageManagementSystem?: Maybe<Scalars['String']['output']>;
  rejected?: Maybe<Scalars['DateTime']['output']>;
  rejectionType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type LicenseProjectScanPackageInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  packageManagementSystem?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export enum LicenseStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type LinkedInChangeLog = {
  __typename?: 'LinkedInChangeLog';
  changeDate: Scalars['DateTime']['output'];
  contact?: Maybe<Contact>;
  contactId: Scalars['Int']['output'];
  currentValue: Scalars['String']['output'];
  fieldsChanged: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  previousValue?: Maybe<Scalars['String']['output']>;
};

export type LocationCoordinates = {
  __typename?: 'LocationCoordinates';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type LockedRevenueMonth = {
  __typename?: 'LockedRevenueMonth';
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  lockedAt?: Maybe<Scalars['Date']['output']>;
  lockedBy?: Maybe<Scalars['Int']['output']>;
  month: Scalars['Date']['output'];
  user?: Maybe<User>;
};

export type LogMessage = {
  __typename?: 'LogMessage';
  level?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  when: Scalars['DateTime']['output'];
};

export type McpTokenInput = {
  access_token: Scalars['String']['input'];
  description: Scalars['String']['input'];
  server_label: Scalars['String']['input'];
  server_url: Scalars['String']['input'];
};

export type ManagerApprovalStat = {
  __typename?: 'ManagerApprovalStat';
  /** Number of team members with timesheets this week */
  activeTeamMembersCount: Scalars['Int']['output'];
  /** Average time to approve in hours */
  averageTimeToApprove?: Maybe<Scalars['Float']['output']>;
  /** First time an entry was updated */
  firstUpdated?: Maybe<Scalars['Date']['output']>;
  /** Last time an entry was approved */
  lastApproved?: Maybe<Scalars['Date']['output']>;
  /** Manager's email address */
  managerEmail: Scalars['String']['output'];
  /** Manager ID */
  managerID: Scalars['Int']['output'];
  /** Manager's name */
  managerName: Scalars['String']['output'];
  /** Manager's photo URL */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /** Total number of team members (active and tracking time) */
  teamMembersCount: Scalars['Int']['output'];
  /** Time to approve in hours (from first update to last approval) */
  timeToApprove?: Maybe<Scalars['Float']['output']>;
  /** Manager's title */
  title?: Maybe<Scalars['String']['output']>;
  /** Week starting date */
  weekStart?: Maybe<Scalars['Date']['output']>;
};

export type ManagerDoc = {
  __typename?: 'ManagerDoc';
  /**
   * Audit log for this item, limited to super admins
   * ** Do not call this on lists, as it is incredibly expensive. **
   */
  AuditLog?: Maybe<Array<AuditLog>>;
  createdDate: Scalars['DateTime']['output'];
  departments?: Maybe<Array<Scalars['Int']['output']>>;
  description: Scalars['String']['output'];
  displayInframe?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  modifiedDate: Scalars['DateTime']['output'];
  offices?: Maybe<Array<Scalars['Int']['output']>>;
  sectionTitle: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type ManagerDocAuditLogArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ManagerDocInput = {
  /** Commas separated list of department ids */
  departments?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  displayInframe?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Commas separated list of office ids */
  offices?: InputMaybe<Scalars['String']['input']>;
  sectionTitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ManagerUnapprovedTimesheets = {
  __typename?: 'ManagerUnapprovedTimesheets';
  emptyTimesheets?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAway?: Maybe<Scalars['Boolean']['output']>;
  nameFirst?: Maybe<Scalars['String']['output']>;
  nameLast?: Maybe<Scalars['String']['output']>;
  unapprovedTimesheets?: Maybe<Scalars['Int']['output']>;
};

export type McpServer = {
  __typename?: 'McpServer';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requiresAuthentication: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type Meeting = {
  __typename?: 'Meeting';
  client?: Maybe<Account>;
  contacts: Array<Maybe<Contact>>;
  date?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type MeetingInput = {
  clientID?: InputMaybe<Scalars['Int']['input']>;
  contacts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type Memory = {
  __typename?: 'Memory';
  total?: Maybe<Scalars['Float']['output']>;
  used?: Maybe<Scalars['Float']['output']>;
};

export type Mentorship = {
  __typename?: 'Mentorship';
  mentor?: Maybe<Person>;
  mentorshipStartDate?: Maybe<Scalars['Date']['output']>;
};

export type Message = {
  __typename?: 'Message';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  role: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type MessageHistory = {
  __typename?: 'MessageHistory';
  archived?: Maybe<Scalars['Boolean']['output']>;
  assistant?: Maybe<ThreadAssistant>;
  assistantId?: Maybe<Scalars['String']['output']>;
  messages: Array<Maybe<Message>>;
  name?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<PersonSimple>;
};

export type MethodInfo = {
  __typename?: 'MethodInfo';
  high?: Maybe<Scalars['Int']['output']>;
  low?: Maybe<Scalars['Int']['output']>;
  med?: Maybe<Scalars['Int']['output']>;
};

export type Metrics = {
  __typename?: 'Metrics';
  POST200Metrics?: Maybe<MethodInfo>;
  POST500Metrics?: Maybe<MethodInfo>;
};

export type ModelOptions = {
  __typename?: 'ModelOptions';
  default: LlmOption;
  options: Array<LlmOption>;
};

export type Mutation = {
  __typename?: 'Mutation';
  OpenAIDeleteSession: Scalars['Boolean']['output'];
  OpenAIEditSession: Scalars['Boolean']['output'];
  OpenAIUpsertSession: OpenAiSession;
  OpportunityDelete?: Maybe<Scalars['Boolean']['output']>;
  OpportunityUpsert?: Maybe<Opportunity>;
  ProposalDelete?: Maybe<Scalars['Boolean']['output']>;
  ProposalUpsert?: Maybe<Proposal>;
  acceptDocument: Scalars['Boolean']['output'];
  accountServiceTeamDelete?: Maybe<Scalars['Boolean']['output']>;
  accountServiceTeamUpsert?: Maybe<File>;
  actionItemDelete: Scalars['Boolean']['output'];
  actionItemUpsert?: Maybe<ActionItem>;
  addAccount?: Maybe<Account>;
  addAccountTag?: Maybe<PortalTag>;
  addEmailTemplate?: Maybe<EmailTemplateResponse>;
  addEmploymentEvent?: Maybe<EmploymentEvent>;
  addFloatingHoliday: FloatingHoliday;
  addPlannerTempProject?: Maybe<Project>;
  addPlannerTempProjectReturnProgram?: Maybe<Program>;
  addProgram?: Maybe<Program>;
  addProgramProjectEntry?: Maybe<ProgramProject>;
  addProgramProjectRole?: Maybe<ProgramProject>;
  addProjectBudgetEntry?: Maybe<Scalars['Boolean']['output']>;
  addTimesheetEntry: Scalars['Boolean']['output'];
  aiAddMessage: NewMessage;
  aiCreateAssistant?: Maybe<Assistant>;
  aiCreateThread: Thread;
  aiDeleteAssistant?: Maybe<Scalars['Boolean']['output']>;
  aiDeleteThread?: Maybe<Scalars['Boolean']['output']>;
  aiSaveMessage?: Maybe<Scalars['Boolean']['output']>;
  approveAssignment?: Maybe<AssignmentsLog>;
  approveTravelRequest?: Maybe<TravelRequest>;
  assignProgramProject?: Maybe<Program>;
  billableHoursApprove: BillableHours;
  billableHoursLock: BillableHours;
  billableHoursUnapprove: BillableHours;
  billableHoursUnlock: BillableHours;
  billableHoursUpsert: BillableHours;
  certificationAddNote?: Maybe<CertificationItem>;
  certificationConversion?: Maybe<CertificationItem>;
  certificationCreate?: Maybe<CertificationItem>;
  certificationDelete?: Maybe<Scalars['Boolean']['output']>;
  certificationRename?: Maybe<CertificationItem>;
  certificationUpdateDetails?: Maybe<CertificationItem>;
  certificationUpdateSkills?: Maybe<CertificationItem>;
  /** Clears the entire cache, admin only */
  clearCache?: Maybe<Scalars['Boolean']['output']>;
  clientComplianceUpsert?: Maybe<ClientCompliance>;
  /** Soft-delete a client contract template */
  clientContractTemplateDelete: Scalars['Boolean']['output'];
  /** Create or update a client contract template. Provide an id to update. */
  clientContractTemplateUpsert: ClientContractTemplate;
  clientLinkDelete?: Maybe<Scalars['Boolean']['output']>;
  clientLinkUpsert?: Maybe<ClientLink>;
  commentDelete?: Maybe<Scalars['Boolean']['output']>;
  commentUpsert?: Maybe<Comment>;
  complianceWorkbookCopy?: Maybe<ComplianceWorkbookDetails>;
  complianceWorkbookReview?: Maybe<ComplianceWorkbookDetails>;
  complianceWorkbookUpsert?: Maybe<ComplianceWorkbookDetails>;
  contactDelete?: Maybe<Scalars['Boolean']['output']>;
  contactLinkDelete?: Maybe<Scalars['Boolean']['output']>;
  contactLinkUpsert?: Maybe<ContactLink>;
  contactUpsert?: Maybe<Contact>;
  createEventV2?: Maybe<EventV2>;
  createHandbookDocument: Scalars['Boolean']['output'];
  createPortalTag: PortalTag;
  createPortalTagCategory: PortalTagCategory;
  createProject?: Maybe<Project>;
  createProjectRequest?: Maybe<Project>;
  createPtoDay?: Maybe<PtoDay>;
  createReview?: Maybe<Scalars['Boolean']['output']>;
  createWireguardDevice: WireguardDevice;
  createWorkHistoryForInternalProject?: Maybe<WorkHistory>;
  deleteAccount?: Maybe<Scalars['Boolean']['output']>;
  deleteAssignment?: Maybe<Scalars['Boolean']['output']>;
  deleteClientSalesMeeting: Scalars['Boolean']['output'];
  deleteClientServiceMap: Scalars['Boolean']['output'];
  deleteClientServiceMapSubdomain: Scalars['Boolean']['output'];
  deleteEmailTemplate?: Maybe<EmailTemplateResponse>;
  deleteEventV2?: Maybe<Scalars['Boolean']['output']>;
  /** Soft delete a gift campaign */
  deleteGiftCampaign: Scalars['Boolean']['output'];
  deleteLockedRevenueMonth?: Maybe<Scalars['ID']['output']>;
  deleteManagerDoc?: Maybe<Scalars['Boolean']['output']>;
  deleteMeeting: Scalars['Boolean']['output'];
  deleteNotification?: Maybe<Scalars['Boolean']['output']>;
  deletePortalTag?: Maybe<Scalars['Int']['output']>;
  deletePortalTagCategory?: Maybe<Scalars['Int']['output']>;
  deleteProgramProjectEntry?: Maybe<ProgramProject>;
  deleteProgramProjectRole?: Maybe<ProgramProject>;
  deleteProject?: Maybe<Scalars['Boolean']['output']>;
  deleteProjectBlackoutPeriod: Scalars['Boolean']['output'];
  deletePrompt?: Maybe<Scalars['ID']['output']>;
  deletePtoDay?: Maybe<Scalars['Int']['output']>;
  deleteReview: Scalars['Boolean']['output'];
  deleteTempProject: Scalars['Boolean']['output'];
  deleteTrip: Scalars['Boolean']['output'];
  deleteTripMeeting: Scalars['Boolean']['output'];
  deleteVaultFile?: Maybe<Scalars['Boolean']['output']>;
  deleteWireguardDevice: Scalars['Boolean']['output'];
  deleteWorkHistoryItem: Scalars['Boolean']['output'];
  denyClientRequest?: Maybe<Scalars['Boolean']['output']>;
  denyTravelRequest?: Maybe<TravelRequest>;
  /** Saves a new discipline */
  disciplineCreate?: Maybe<DisciplineNew>;
  /** Updates an existing discipline */
  disciplineUpdate?: Maybe<DisciplineNew>;
  documentDelete?: Maybe<Scalars['Boolean']['output']>;
  documentUpsert?: Maybe<Document>;
  extendProgramProject?: Maybe<Program>;
  fileDelete?: Maybe<Scalars['Boolean']['output']>;
  fileUpsert?: Maybe<File>;
  /**
   * Finalize (lock) a whole week from the reconciliation queue. Admin-only. Stamps
   * the week-level FinalizedAt/FinalizedByUserID; for weeks that have entries, also
   * advances those entries to AdminFinalized (state 3). Empty / autofill-skipped
   * weeks are finalized via the week-level marker alone. No unlock mutation —
   * admins correct a finalized week in place.
   */
  finalizeTimesheetWeek: TimesheetWeeklyMetadata;
  generateAPIKey?: Maybe<ApiKeyVerification>;
  generateCalendarToken?: Maybe<CalendarTokenVerification>;
  generateExchangeKey: Scalars['String']['output'];
  globalNoteDelete: Scalars['Boolean']['output'];
  globalNoteUpsert: GlobalNote;
  helloMut?: Maybe<Scalars['String']['output']>;
  invoiceApprove?: Maybe<Invoice>;
  invoiceDelete?: Maybe<Scalars['Boolean']['output']>;
  invoiceUnapprove?: Maybe<Invoice>;
  invoiceUpsert?: Maybe<Invoice>;
  /** approve a license */
  licenseApprove?: Maybe<License>;
  /** approve a license package */
  licensePackageApprove?: Maybe<LicensePackage>;
  /** reject a license package */
  licensePackageReject?: Maybe<LicensePackage>;
  /** remove a license package */
  licensePackageRemove?: Maybe<Scalars['Boolean']['output']>;
  /** submit or modify a license package */
  licensePackageSubmit?: Maybe<LicensePackage>;
  /** approve a license project license */
  licenseProjectLicenseApprove?: Maybe<LicenseProjectLicense>;
  /** reject a license project license */
  licenseProjectLicenseReject?: Maybe<LicenseProjectLicense>;
  /** remove a license project license */
  licenseProjectLicenseRemove?: Maybe<Scalars['Boolean']['output']>;
  /** submit or modify a license project license */
  licenseProjectLicenseSubmit?: Maybe<LicenseProjectLicense>;
  /** add a project package */
  licenseProjectPackageAdd?: Maybe<LicenseProjectPackage>;
  /** approve a project package */
  licenseProjectPackageApprove?: Maybe<LicenseProjectLicense>;
  /** reject a project package */
  licenseProjectPackageReject?: Maybe<LicenseProjectLicense>;
  /** remove a license project */
  licenseProjectRemove?: Maybe<Scalars['Boolean']['output']>;
  /** submit or modify a license project */
  licenseProjectSubmit?: Maybe<LicenseProject>;
  /** reject a license */
  licenseReject?: Maybe<License>;
  /** remove a license */
  licenseRemove?: Maybe<Scalars['Boolean']['output']>;
  /** remove a license scan */
  licenseScanRemove?: Maybe<Scalars['Boolean']['output']>;
  /** submit a license scan */
  licenseScanSubmit?: Maybe<LicenseProjectScan>;
  /** submit or modify a license */
  licenseSubmit?: Maybe<License>;
  llmConversationDelete: Scalars['Boolean']['output'];
  llmConversationRename: LlmConversationHistoryItem;
  llmConversationSendMessage: LlmConversation;
  lockMonthlyHours: Array<BillableHours>;
  lockRevenueMonth: LockedRevenueMonth;
  logEmploymentChange: Scalars['Boolean']['output'];
  newTempProject: Scalars['Int']['output'];
  newTravelRequest?: Maybe<TravelRequest>;
  noteDelete?: Maybe<Scalars['Boolean']['output']>;
  noteUpsert?: Maybe<Note>;
  notifCenterSettingsUpdate: Scalars['String']['output'];
  notifCenterTest?: Maybe<Scalars['Boolean']['output']>;
  notificationContextUpsert: Array<NotificationContext>;
  offboardingUpdate: Offboarding;
  officeUpdate?: Maybe<Office>;
  onboardUser?: Maybe<OnboardingResponse>;
  opportunityLinkDelete?: Maybe<Scalars['Boolean']['output']>;
  opportunityLinkUpsert?: Maybe<OpportunityLink>;
  /** Delete a permission group, this will also remove ti from all users */
  permissionGroupDelete: Scalars['Boolean']['output'];
  /** Save a permission Group */
  permissionGroupSave: PermissionGroup;
  /** Save a permission (update its description) */
  permissionSave: PermissionNew;
  /**
   * Sets the permission groups OR permissions for a user.
   * If groups are supplied the permissions will be ignored and the groups will take precedence
   */
  personSetPermissions?: Maybe<Person>;
  professionalSkillTagV2Delete?: Maybe<Scalars['Boolean']['output']>;
  professionalSkillTagV2Upsert?: Maybe<ProfessionalSkillTagDetails>;
  projectLinkDelete?: Maybe<Scalars['Boolean']['output']>;
  projectLinkUpsert?: Maybe<ProjectLink>;
  ptoAdd?: Maybe<PtoRequest>;
  ptoApprove?: Maybe<PtoRequest>;
  ptoDecline?: Maybe<PtoRequest>;
  ptoTriage?: Maybe<PtoRequest>;
  purchaseOrderApprove?: Maybe<PurchaseOrder>;
  purchaseOrderDelete?: Maybe<Scalars['Boolean']['output']>;
  purchaseOrderUnapprove?: Maybe<PurchaseOrder>;
  purchaseOrderUpsert?: Maybe<PurchaseOrder>;
  /** Saves a new QuickLink */
  quicklinkUpdate?: Maybe<QuickLink>;
  rateCardDelete: Scalars['Boolean']['output'];
  rateCardUpsert: RateCard;
  readNotification?: Maybe<Notification>;
  reassignTempProject: Scalars['Boolean']['output'];
  /** Forces a refresh of the search cache (admin only) */
  refreshSearchCache: SearchCacheStats;
  removeAccountTag?: Maybe<PortalTag>;
  /** Remove a contact from a gift campaign */
  removeContactFromGiftCampaign: Scalars['Boolean']['output'];
  removeEmploymentEvent?: Maybe<Scalars['Boolean']['output']>;
  removeFloatingHoliday: Scalars['Boolean']['output'];
  removeProgram?: Maybe<Scalars['Boolean']['output']>;
  removeTimesheetEntry: Scalars['Boolean']['output'];
  reviewApplyTitle: Review;
  reviewApproveTitle: Review;
  runJob?: Maybe<Scalars['String']['output']>;
  runTimetrackerAutoAssignments?: Maybe<Scalars['String']['output']>;
  runTimetrackerAutoAssignmentsById?: Maybe<Scalars['String']['output']>;
  sendNotification?: Maybe<Scalars['Int']['output']>;
  sendOnboardingEmail: Scalars['Boolean']['output'];
  /**
   * Send a specific reminder touch to a single user now (sendNow), for end-to-end delivery
   * verification. Bypasses the due-time gate, eligibility, and the ledger. Superadmin only.
   */
  sendTestTimesheetReminder: TimesheetReminderTestResult;
  serviceGroupDelete: Scalars['Boolean']['output'];
  serviceGroupUpsert: ServiceGroup;
  /** Sets the sort order of departments, you must send all departments when sorting in the order you want them. */
  setDepartmentSort?: Maybe<Scalars['Boolean']['output']>;
  /** Sets the sort order of disciplines, you must send all disciplines when sorting in the order you want them. */
  setDisciplineSort?: Maybe<Scalars['Boolean']['output']>;
  setJobTitleLevel?: Maybe<Scalars['Boolean']['output']>;
  setJobTitleLeverageable?: Maybe<Scalars['Boolean']['output']>;
  /** Sets the sort order of job titles, you must send all offices when sorting in the order you want them. */
  setJobTitleSortOrder?: Maybe<Scalars['Boolean']['output']>;
  /** Sets the sort order of manager docs, you must send all manager docs when sorting in the order you want them. */
  setManagerDocSort?: Maybe<Scalars['Boolean']['output']>;
  /** Sets the sort order of offices, you must send all offices when sorting in the order you want them. */
  setOfficeSort?: Maybe<Scalars['Boolean']['output']>;
  /** Sets a SQL script as run */
  setSQLScriptAsRun?: Maybe<SqlScript>;
  /**
   * Advance the submit/approve/finalize state of an entry-less (empty) week — one
   * with no timetrackerentry rows to carry state. Used for weeks with no
   * billable/training hours and no PTO. stateID: 1 = team member submitted,
   * 2 = manager approved (auto-finalizes the empty week), 0 = unsubmitted / unapprove.
   */
  setTimesheetWeekState: TimesheetWeeklyMetadata;
  /**
   * Dry-run the reminder dispatcher at a simulated time. Returns the per-user decisions
   * (who WOULD be sent and who is skipped, with reasons) WITHOUT writing the ledger or
   * sending anything. Admin only.
   */
  simulateTimesheetReminders: TimesheetReminderSimulation;
  sqlQueriesReset: Scalars['Boolean']['output'];
  teamProfileGenerationSave?: Maybe<TeamProfileGeneration>;
  teamProfileGenerationUpdate?: Maybe<TeamProfileGeneration>;
  testSendEmail?: Maybe<Scalars['Boolean']['output']>;
  testSendEmailV2?: Maybe<Scalars['Boolean']['output']>;
  tvaVariantResolve: TvaVariant;
  tvaVariantReview: TvaVariant;
  unassignProgramProject?: Maybe<Program>;
  unlockRevenueMonth: LockedRevenueMonth;
  updateAccount?: Maybe<Account>;
  /** Note: only returns the id and entryStateID fields for now */
  updateAllTimesheetState: Array<Hours>;
  /** Update disciplines by id */
  updateDisciplines?: Maybe<Person>;
  updateEmailTemplate?: Maybe<EmailTemplateResponse>;
  updateEmploymentEvent?: Maybe<EmploymentEvent>;
  updateEventV2?: Maybe<Scalars['Boolean']['output']>;
  updateHandbookDocument: HandbookDoc;
  /** Update a mentor by id */
  updateMentor: Scalars['Boolean']['output'];
  updateMentorV2?: Maybe<Person>;
  updatePersonCertificationsV2?: Maybe<Person>;
  updatePersonV3?: Maybe<Person>;
  updatePortalTag: PortalTag;
  updatePortalTagCategory: PortalTagCategory;
  /** Update a user's preferences */
  updatePreferences: Scalars['Boolean']['output'];
  updateProgram?: Maybe<Program>;
  updateProgramProjectEntry?: Maybe<ProgramProject>;
  updateProgramProjectRole?: Maybe<ProgramProject>;
  updateProject?: Maybe<Project>;
  updateProjectDescription?: Maybe<Scalars['Boolean']['output']>;
  updateProjectEndDate?: Maybe<Scalars['Boolean']['output']>;
  updateProjectNotes: Scalars['Boolean']['output'];
  updateProjectPlanlink?: Maybe<Scalars['Boolean']['output']>;
  updateReview: Scalars['Boolean']['output'];
  /** Update a person's rollover dates */
  updateRolloverDates?: Maybe<Person>;
  updateTempProject?: Maybe<Scalars['Boolean']['output']>;
  /** Update user's TimeTracker exemption flags */
  updateTimeTrackerExemptions: Scalars['Boolean']['output'];
  updateTimesheet?: Maybe<Array<Hours>>;
  updateTimesheetEntry: Scalars['Boolean']['output'];
  /**
   * Mutation for CUD operations on timesheet entries without restrictions. Requires timetracker administrative permissions.
   * Not providing timeTrackerEntryID field will result in a create operation, passing delete: true will result in a delete operation.
   */
  updateTimesheetEntryAdmin?: Maybe<Hours>;
  updateUserEmail?: Maybe<Person>;
  /** Update the user's location (if authoritative enough) and get back where we think they are */
  updateUserLocation: PersonCurrentOffice;
  /**
   * Update a user from Admin panel
   * Any fields in UserObjInput are editable
   */
  updateUserObj?: Maybe<Person>;
  /** Update personal skill tags by name */
  updateUserPersonalSkillTags: Scalars['Boolean']['output'];
  updateUserPersonalSkillTagsV2?: Maybe<Person>;
  /** Update professional skill tags by name */
  updateUserProfessionalSkillTags?: Maybe<Array<Maybe<ProfessionalSkillTag>>>;
  updateUserProfessionalSkillTagsV2?: Maybe<Person>;
  updateVaultFileExpiration?: Maybe<Scalars['Boolean']['output']>;
  upsertBusinessDays?: Maybe<BusinessDaysItem>;
  upsertClientSalesMeeting: ClientSalesMeeting;
  upsertClientServiceMap: ClientServiceMap;
  upsertClientServiceMapSubdomain: ClientServiceMapSubdomain;
  upsertFloatingHolidays: Array<FloatingHoliday>;
  upsertForecastData?: Maybe<ForecastItem>;
  /** Create a new gift campaign or update an existing one */
  upsertGiftCampaign: GiftCampaign;
  /** Add a contact to a campaign or update their approval statuses */
  upsertGiftCampaignEntry: GiftCampaignEntry;
  upsertKGNotification: KgNotification;
  upsertManagerDoc?: Maybe<ManagerDoc>;
  upsertMeeting: Meeting;
  upsertProjectBlackoutPeriod: ProjectBlackoutPeriod;
  upsertPrompt: Prompt;
  upsertRevenueRecognition: ForecastItem;
  /**
   * Upsert the team member's flag-an-issue note for a given week's metadata row.
   * Trimmed server-side; an empty string clears the note.
   */
  upsertTimesheetWeeklyMetadataNotes: TimesheetWeeklyMetadata;
  upsertTrip: Trip;
  upsertTripMeeting: TripMeeting;
  workHistoryUpsert: WorkHistory;
};


export type MutationOpenAiDeleteSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOpenAiEditSessionArgs = {
  config?: InputMaybe<OpenAiConfig>;
  id: Scalars['ID']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOpenAiUpsertSessionArgs = {
  config?: InputMaybe<OpenAiConfig>;
  id?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOpportunityDeleteArgs = {
  OpportunityId: Scalars['Int']['input'];
};


export type MutationOpportunityUpsertArgs = {
  opportunity: OpportunityInput;
};


export type MutationProposalDeleteArgs = {
  ProposalId: Scalars['Int']['input'];
};


export type MutationProposalUpsertArgs = {
  proposal: ProposalInput;
};


export type MutationAcceptDocumentArgs = {
  handbookId: Scalars['Int']['input'];
};


export type MutationAccountServiceTeamDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAccountServiceTeamUpsertArgs = {
  input: AccountServiceTeamInput;
};


export type MutationActionItemDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationActionItemUpsertArgs = {
  input: ActionItemInput;
};


export type MutationAddAccountArgs = {
  account: AccountInput;
};


export type MutationAddAccountTagArgs = {
  accountId: Scalars['Int']['input'];
  tagId: Scalars['Int']['input'];
};


export type MutationAddEmailTemplateArgs = {
  contextConfig: Array<InputMaybe<ContextConfigInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  templateConfig?: InputMaybe<TemplateConfigInput>;
};


export type MutationAddEmploymentEventArgs = {
  event?: InputMaybe<EmploymentEventInput>;
  userID: Scalars['Int']['input'];
};


export type MutationAddFloatingHolidayArgs = {
  ptoDayId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationAddPlannerTempProjectArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  projectAccountId?: InputMaybe<Scalars['Int']['input']>;
  projectName: Scalars['String']['input'];
};


export type MutationAddPlannerTempProjectReturnProgramArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  projectAccountId?: InputMaybe<Scalars['Int']['input']>;
  projectName: Scalars['String']['input'];
};


export type MutationAddProgramArgs = {
  program: ProgramInput;
};


export type MutationAddProgramProjectEntryArgs = {
  entry: ProgramProjectEntryInput;
};


export type MutationAddProgramProjectRoleArgs = {
  role: ProgramProjectRoleInput;
};


export type MutationAddProjectBudgetEntryArgs = {
  hours: Scalars['Int']['input'];
  monthStartDate: Scalars['Date']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationAddTimesheetEntryArgs = {
  date: Scalars['Date']['input'];
  hours: Scalars['Float']['input'];
  projectID: Scalars['Int']['input'];
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAiAddMessageArgs = {
  assistantId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type MutationAiCreateAssistantArgs = {
  accountId: Scalars['Int']['input'];
  accountName: Scalars['String']['input'];
  hasFiles?: InputMaybe<Scalars['Boolean']['input']>;
  instructions: Scalars['String']['input'];
  model: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationAiCreateThreadArgs = {
  assistantId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAiDeleteAssistantArgs = {
  assistantId: Scalars['String']['input'];
};


export type MutationAiDeleteThreadArgs = {
  threadId: Scalars['String']['input'];
};


export type MutationAiSaveMessageArgs = {
  assistantID: Scalars['String']['input'];
  message: Scalars['String']['input'];
  role: Scalars['String']['input'];
  threadID: Scalars['String']['input'];
};


export type MutationApproveAssignmentArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationApproveTravelRequestArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAssignProgramProjectArgs = {
  programId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationBillableHoursApproveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationBillableHoursLockArgs = {
  id: Scalars['Int']['input'];
};


export type MutationBillableHoursUnapproveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationBillableHoursUnlockArgs = {
  id: Scalars['Int']['input'];
};


export type MutationBillableHoursUpsertArgs = {
  hoursData: Array<BillableHoursHourInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  month: Scalars['Date']['input'];
  projectIds: Array<Scalars['Int']['input']>;
};


export type MutationCertificationAddNoteArgs = {
  input: CertificationNoteInput;
};


export type MutationCertificationConversionArgs = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type MutationCertificationCreateArgs = {
  input: CertificationCreateInput;
};


export type MutationCertificationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationCertificationRenameArgs = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type MutationCertificationUpdateDetailsArgs = {
  input: CertificationDetailsInput;
};


export type MutationCertificationUpdateSkillsArgs = {
  input: CertificationSkillsInput;
};


export type MutationClientComplianceUpsertArgs = {
  input: ClientComplianceInput;
};


export type MutationClientContractTemplateDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationClientContractTemplateUpsertArgs = {
  input: ClientContractTemplateInput;
};


export type MutationClientLinkDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationClientLinkUpsertArgs = {
  input: ClientLinkInput;
};


export type MutationCommentDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCommentUpsertArgs = {
  input: CommentInput;
};


export type MutationComplianceWorkbookCopyArgs = {
  complianceWorkbookIDCopyFrom: Scalars['Int']['input'];
  projectIDCopyTo: Scalars['Int']['input'];
};


export type MutationComplianceWorkbookReviewArgs = {
  complianceWorkbookId: Scalars['Int']['input'];
};


export type MutationComplianceWorkbookUpsertArgs = {
  complianceWorkbook: ComplianceWorkbookInput;
};


export type MutationContactDeleteArgs = {
  contactId: Scalars['Int']['input'];
};


export type MutationContactLinkDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationContactLinkUpsertArgs = {
  input: ContactLinkInput;
};


export type MutationContactUpsertArgs = {
  contact: ContactInput;
};


export type MutationCreateEventV2Args = {
  event: EventInputV2;
};


export type MutationCreateHandbookDocumentArgs = {
  acceptable: Scalars['Boolean']['input'];
  category: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  iframe?: InputMaybe<Scalars['Boolean']['input']>;
  link: Scalars['String']['input'];
  officeId?: InputMaybe<Scalars['Int']['input']>;
  openType?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};


export type MutationCreatePortalTagArgs = {
  color: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
  portalTagCategoryId: Scalars['Int']['input'];
  synonyms: Scalars['String']['input'];
};


export type MutationCreatePortalTagCategoryArgs = {
  color: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateProjectArgs = {
  accountId: Scalars['Int']['input'];
  project: CreateProjectInput;
};


export type MutationCreateProjectRequestArgs = {
  project: CreateProjectRequestInput;
};


export type MutationCreatePtoDayArgs = {
  ptoDayAdd: PtoDayAddInput;
};


export type MutationCreateReviewArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  esNotes?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  newTitle?: InputMaybe<Scalars['String']['input']>;
  promotion?: InputMaybe<Scalars['Boolean']['input']>;
  raise?: InputMaybe<Scalars['Boolean']['input']>;
  raiseEffective?: InputMaybe<Scalars['Date']['input']>;
  raiseFrom?: InputMaybe<Scalars['Float']['input']>;
  raiseTo?: InputMaybe<Scalars['Float']['input']>;
  reviewDate?: InputMaybe<Scalars['String']['input']>;
  reviewType?: InputMaybe<Scalars['String']['input']>;
  revieweeUserId?: InputMaybe<Scalars['Int']['input']>;
  reviewerUserId?: InputMaybe<Scalars['Int']['input']>;
  titleEffective?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCreateWireguardDeviceArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateWorkHistoryForInternalProjectArgs = {
  projectId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationDeleteAccountArgs = {
  accountId: Scalars['Int']['input'];
};


export type MutationDeleteAssignmentArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteClientSalesMeetingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteClientServiceMapArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteClientServiceMapSubdomainArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteEmailTemplateArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteEventV2Args = {
  eventId: Scalars['Int']['input'];
};


export type MutationDeleteGiftCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteLockedRevenueMonthArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteManagerDocArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMeetingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteNotificationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeletePortalTagArgs = {
  portalTagId: Scalars['Int']['input'];
};


export type MutationDeletePortalTagCategoryArgs = {
  portalTagCategoryId: Scalars['Int']['input'];
};


export type MutationDeleteProgramProjectEntryArgs = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationDeleteProgramProjectRoleArgs = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationDeleteProjectArgs = {
  projectId: Scalars['Int']['input'];
};


export type MutationDeleteProjectBlackoutPeriodArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePromptArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePtoDayArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteReviewArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTempProjectArgs = {
  projectID: Scalars['Int']['input'];
};


export type MutationDeleteTripArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTripMeetingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteVaultFileArgs = {
  fileId: Scalars['String']['input'];
};


export type MutationDeleteWireguardDeviceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteWorkHistoryItemArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDenyClientRequestArgs = {
  accountId: Scalars['Int']['input'];
};


export type MutationDenyTravelRequestArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDisciplineCreateArgs = {
  Discipline?: InputMaybe<DisciplineInput>;
};


export type MutationDisciplineUpdateArgs = {
  Discipline?: InputMaybe<DisciplineInput>;
  id: Scalars['Int']['input'];
};


export type MutationDocumentDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDocumentUpsertArgs = {
  input: DocumentInput;
};


export type MutationExtendProgramProjectArgs = {
  newProjectId: Scalars['Int']['input'];
  oldProjectId: Scalars['Int']['input'];
  programId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFileDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationFileUpsertArgs = {
  input: FileInput;
};


export type MutationFinalizeTimesheetWeekArgs = {
  userID: Scalars['Int']['input'];
  weekStartDate: Scalars['Date']['input'];
};


export type MutationGenerateApiKeyArgs = {
  settings: ApiKeyInput;
};


export type MutationGenerateCalendarTokenArgs = {
  a?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  iov?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  md?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mr?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  prog?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  proj?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  start?: InputMaybe<Scalars['Date']['input']>;
  u?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  wfa?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationGlobalNoteDeleteArgs = {
  id: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationGlobalNoteUpsertArgs = {
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['JSONObject']['input']>;
  slug: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationInvoiceApproveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationInvoiceDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationInvoiceUnapproveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationInvoiceUpsertArgs = {
  input: InvoiceInput;
};


export type MutationLicenseApproveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLicensePackageApproveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLicensePackageRejectArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLicensePackageRemoveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLicensePackageSubmitArgs = {
  licensePackage: LicensePackageInput;
};


export type MutationLicenseProjectLicenseApproveArgs = {
  id: Scalars['Int']['input'];
  licenseProject: Scalars['String']['input'];
};


export type MutationLicenseProjectLicenseRejectArgs = {
  id: Scalars['Int']['input'];
  licenseProject: Scalars['String']['input'];
};


export type MutationLicenseProjectLicenseRemoveArgs = {
  id: Scalars['Int']['input'];
  licenseProject: Scalars['String']['input'];
};


export type MutationLicenseProjectLicenseSubmitArgs = {
  licenseProject?: InputMaybe<Scalars['String']['input']>;
  licenseProjectLicense: LicenseProjectLicenseInput;
};


export type MutationLicenseProjectPackageAddArgs = {
  licenseProject?: InputMaybe<Scalars['String']['input']>;
  licenseProjectPackage: LicenseProjectPackageInput;
};


export type MutationLicenseProjectPackageApproveArgs = {
  id: Scalars['Int']['input'];
  licenseProject: Scalars['String']['input'];
};


export type MutationLicenseProjectPackageRejectArgs = {
  id: Scalars['Int']['input'];
  licenseProject: Scalars['String']['input'];
};


export type MutationLicenseProjectRemoveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLicenseProjectSubmitArgs = {
  licenseProject: LicenseProjectInput;
};


export type MutationLicenseRejectArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLicenseRemoveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLicenseScanRemoveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationLicenseScanSubmitArgs = {
  licenseScan: LicenseProjectScanInput;
};


export type MutationLicenseSubmitArgs = {
  license: LicenseInput;
};


export type MutationLlmConversationDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationLlmConversationRenameArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationLlmConversationSendMessageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  mcpTokens?: InputMaybe<Array<McpTokenInput>>;
  message: Scalars['String']['input'];
  model: Scalars['String']['input'];
  reasoningEffortLevel?: InputMaybe<LlmReasoningEffortLevel>;
  searchEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tempSessionId?: InputMaybe<Scalars['String']['input']>;
  toolsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLockRevenueMonthArgs = {
  month: Scalars['Date']['input'];
};


export type MutationLogEmploymentChangeArgs = {
  input: EmployementChangeLogInput;
};


export type MutationNewTempProjectArgs = {
  projectName: Scalars['String']['input'];
};


export type MutationNewTravelRequestArgs = {
  travelRequest: TravelRequestInput;
  userID: Scalars['Int']['input'];
};


export type MutationNoteDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationNoteUpsertArgs = {
  input: NoteInput;
};


export type MutationNotifCenterSettingsUpdateArgs = {
  settings: Scalars['String']['input'];
};


export type MutationNotificationContextUpsertArgs = {
  contexts: Array<NotificationContextInput>;
  typeName: Scalars['String']['input'];
};


export type MutationOffboardingUpdateArgs = {
  input: OffboardingInput;
};


export type MutationOfficeUpdateArgs = {
  Office: OfficeInput;
  OfficeID: Scalars['Int']['input'];
};


export type MutationOnboardUserArgs = {
  user: OnboardingUser;
};


export type MutationOpportunityLinkDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationOpportunityLinkUpsertArgs = {
  input: OpportunityLinkInput;
};


export type MutationPermissionGroupDeleteArgs = {
  PermissionGroupID: Scalars['Int']['input'];
};


export type MutationPermissionGroupSaveArgs = {
  PermissionGroup?: InputMaybe<PermissionGroupInput>;
};


export type MutationPermissionSaveArgs = {
  Permission?: InputMaybe<PermissionInput>;
};


export type MutationPersonSetPermissionsArgs = {
  PermissionGroups?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Permissions?: InputMaybe<Array<InputMaybe<PermissionInput>>>;
  UserID: Scalars['Int']['input'];
};


export type MutationProfessionalSkillTagV2DeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationProfessionalSkillTagV2UpsertArgs = {
  input?: InputMaybe<ProfessionalSkillTagInput>;
};


export type MutationProjectLinkDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationProjectLinkUpsertArgs = {
  input: ProjectLinkInput;
};


export type MutationPtoAddArgs = {
  isAdminOverride?: InputMaybe<Scalars['Boolean']['input']>;
  ptoRequest?: InputMaybe<PtoRequestInput>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPtoApproveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPtoDeclineArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPtoTriageArgs = {
  id: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  triaged?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPurchaseOrderApproveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPurchaseOrderDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPurchaseOrderUnapproveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPurchaseOrderUpsertArgs = {
  input: PurchaseOrderInput;
};


export type MutationQuicklinkUpdateArgs = {
  quickLink: QuickLinkInput;
};


export type MutationRateCardDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRateCardUpsertArgs = {
  input: RateCardInput;
};


export type MutationReadNotificationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationReassignTempProjectArgs = {
  entryID: Scalars['Int']['input'];
  projectID: Scalars['Int']['input'];
};


export type MutationRemoveAccountTagArgs = {
  accountId: Scalars['Int']['input'];
  tagId: Scalars['Int']['input'];
};


export type MutationRemoveContactFromGiftCampaignArgs = {
  campaignId: Scalars['Int']['input'];
  contactId: Scalars['Int']['input'];
};


export type MutationRemoveEmploymentEventArgs = {
  id: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
};


export type MutationRemoveFloatingHolidayArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveProgramArgs = {
  programId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveTimesheetEntryArgs = {
  timeTrackerEntryID: Scalars['Int']['input'];
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationReviewApplyTitleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationReviewApproveTitleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRunJobArgs = {
  name: Scalars['String']['input'];
};


export type MutationRunTimetrackerAutoAssignmentsByIdArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendNotificationArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<NotificationPriority>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targets?: InputMaybe<Array<InputMaybe<SendNotificationTarget>>>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationSendOnboardingEmailArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSendTestTimesheetReminderArgs = {
  simulatedNow?: InputMaybe<Scalars['String']['input']>;
  touch: Scalars['String']['input'];
  userID: Scalars['Int']['input'];
};


export type MutationServiceGroupDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationServiceGroupUpsertArgs = {
  input: ServiceGroupInput;
};


export type MutationSetDepartmentSortArgs = {
  DepartmentIDs: Array<Scalars['Int']['input']>;
};


export type MutationSetDisciplineSortArgs = {
  DisciplineIDs: Array<Scalars['Int']['input']>;
};


export type MutationSetJobTitleLevelArgs = {
  level?: InputMaybe<Scalars['String']['input']>;
  titleId: Scalars['Int']['input'];
};


export type MutationSetJobTitleLeverageableArgs = {
  leverageable?: InputMaybe<Scalars['Boolean']['input']>;
  titleId: Scalars['Int']['input'];
};


export type MutationSetJobTitleSortOrderArgs = {
  jobTitleIds: Array<Scalars['Int']['input']>;
};


export type MutationSetManagerDocSortArgs = {
  ManagerDocIDs: Array<Scalars['Int']['input']>;
};


export type MutationSetOfficeSortArgs = {
  OfficeIDs: Array<Scalars['Int']['input']>;
};


export type MutationSetSqlScriptAsRunArgs = {
  id: Scalars['String']['input'];
};


export type MutationSetTimesheetWeekStateArgs = {
  stateID: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
  weekStartDate: Scalars['Date']['input'];
};


export type MutationSimulateTimesheetRemindersArgs = {
  onlyUserID?: InputMaybe<Scalars['Int']['input']>;
  simulatedNow: Scalars['String']['input'];
};


export type MutationTeamProfileGenerationSaveArgs = {
  input: TeamProfileGenerationSaveInput;
};


export type MutationTeamProfileGenerationUpdateArgs = {
  input: TeamProfileGenerationUpdateInput;
};


export type MutationTestSendEmailArgs = {
  templateName: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
  vars?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTestSendEmailV2Args = {
  templateName: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
  vars?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationTvaVariantResolveArgs = {
  note: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  resolved: Scalars['Boolean']['input'];
  start: Scalars['Date']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationTvaVariantReviewArgs = {
  note: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Int']['input']>;
  reviewed: Scalars['Boolean']['input'];
  start: Scalars['Date']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUnassignProgramProjectArgs = {
  programId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUnlockRevenueMonthArgs = {
  month: Scalars['Date']['input'];
};


export type MutationUpdateAccountArgs = {
  account: AccountInput;
};


export type MutationUpdateAllTimesheetStateArgs = {
  entryIDs: Array<Scalars['Int']['input']>;
  stateID: Scalars['Int']['input'];
};


export type MutationUpdateDisciplinesArgs = {
  disciplines: Array<Scalars['Int']['input']>;
  userID: Scalars['Int']['input'];
};


export type MutationUpdateEmailTemplateArgs = {
  contextConfig: Array<InputMaybe<ContextConfigInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  templateConfig?: InputMaybe<TemplateConfigInput>;
};


export type MutationUpdateEmploymentEventArgs = {
  event?: InputMaybe<EmploymentEventInput>;
  id: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
};


export type MutationUpdateEventV2Args = {
  event?: InputMaybe<EventInputV2>;
  eventId: Scalars['Int']['input'];
};


export type MutationUpdateHandbookDocumentArgs = {
  acceptable: Scalars['Boolean']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  iframe: Scalars['Boolean']['input'];
  link: Scalars['String']['input'];
  officeId?: InputMaybe<Scalars['Int']['input']>;
  openType: Scalars['Int']['input'];
  requireReacceptance: Scalars['Boolean']['input'];
  sortOrder: Scalars['Int']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMentorArgs = {
  mentorID?: InputMaybe<Scalars['Int']['input']>;
  mentorshipStartDate?: InputMaybe<Scalars['Date']['input']>;
  userID: Scalars['Int']['input'];
};


export type MutationUpdateMentorV2Args = {
  mentorID?: InputMaybe<Scalars['Int']['input']>;
  mentorshipStartDate?: InputMaybe<Scalars['Date']['input']>;
  userID: Scalars['Int']['input'];
};


export type MutationUpdatePersonCertificationsV2Args = {
  certifications?: InputMaybe<Array<InputMaybe<CertificationInput>>>;
  id: Scalars['Int']['input'];
};


export type MutationUpdatePersonV3Args = {
  id: Scalars['Int']['input'];
  person?: InputMaybe<PersonInput>;
};


export type MutationUpdatePortalTagArgs = {
  color: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
  portalTagId: Scalars['Int']['input'];
  synonyms: Scalars['String']['input'];
};


export type MutationUpdatePortalTagCategoryArgs = {
  color: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
  portalTagCategoryId: Scalars['Int']['input'];
};


export type MutationUpdatePreferencesArgs = {
  plannerUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  userID: Scalars['Int']['input'];
};


export type MutationUpdateProgramArgs = {
  program: ProgramInput;
};


export type MutationUpdateProgramProjectEntryArgs = {
  entry: ProgramProjectEntryInput;
};


export type MutationUpdateProgramProjectRoleArgs = {
  role: ProgramProjectRoleInput;
};


export type MutationUpdateProjectArgs = {
  project: UpdateProjectInput;
  projectId: Scalars['Int']['input'];
};


export type MutationUpdateProjectDescriptionArgs = {
  description: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationUpdateProjectEndDateArgs = {
  endDate: Scalars['Date']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationUpdateProjectNotesArgs = {
  notes: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationUpdateProjectPlanlinkArgs = {
  planlink: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationUpdateReviewArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  newTitle?: InputMaybe<Scalars['String']['input']>;
  promotion?: InputMaybe<Scalars['Boolean']['input']>;
  raise?: InputMaybe<Scalars['Boolean']['input']>;
  reviewDate?: InputMaybe<Scalars['String']['input']>;
  reviewType?: InputMaybe<Scalars['String']['input']>;
  revieweeUserId?: InputMaybe<Scalars['Int']['input']>;
  reviewerUserId?: InputMaybe<Scalars['Int']['input']>;
  titleEffective?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationUpdateRolloverDatesArgs = {
  nextRolloverDate?: InputMaybe<Scalars['Date']['input']>;
  rolloverDate?: InputMaybe<Scalars['Date']['input']>;
  userID: Scalars['Int']['input'];
};


export type MutationUpdateTempProjectArgs = {
  newProjectName?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateTimeTrackerExemptionsArgs = {
  isTimeTrackerAutoApproveExempt?: InputMaybe<Scalars['Boolean']['input']>;
  isTimeTrackerAutoFillExempt?: InputMaybe<Scalars['Boolean']['input']>;
  userID: Scalars['Int']['input'];
};


export type MutationUpdateTimesheetArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  entries?: InputMaybe<Array<TimesheetEntryInput>>;
  remove?: InputMaybe<Array<Scalars['Int']['input']>>;
  start?: InputMaybe<Scalars['Date']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationUpdateTimesheetEntryArgs = {
  additionalHours?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  projectID?: InputMaybe<Scalars['Int']['input']>;
  timeTrackerEntryID: Scalars['Int']['input'];
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateTimesheetEntryAdminArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  projectID?: InputMaybe<Scalars['Int']['input']>;
  timeTrackerEntryID?: InputMaybe<Scalars['Int']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateUserEmailArgs = {
  email: Scalars['String']['input'];
  userID: Scalars['Int']['input'];
};


export type MutationUpdateUserLocationArgs = {
  authority: Scalars['String']['input'];
  building?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['Int']['input']>;
  officeID: Scalars['Int']['input'];
  userID: Scalars['Int']['input'];
};


export type MutationUpdateUserObjArgs = {
  id: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<UserObjInput>;
};


export type MutationUpdateUserPersonalSkillTagsArgs = {
  displayNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateUserPersonalSkillTagsV2Args = {
  displayNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateUserProfessionalSkillTagsArgs = {
  id: Scalars['Int']['input'];
  userProfessionalSkillTags: Array<InputMaybe<UserProfessionalSkillTagInput>>;
};


export type MutationUpdateUserProfessionalSkillTagsV2Args = {
  id: Scalars['Int']['input'];
  userProfessionalSkillTags: Array<InputMaybe<UserProfessionalSkillTagInput>>;
};


export type MutationUpdateVaultFileExpirationArgs = {
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  fileId: Scalars['String']['input'];
};


export type MutationUpsertBusinessDaysArgs = {
  input: BusinessDaysInput;
};


export type MutationUpsertClientSalesMeetingArgs = {
  input: ClientSalesMeetingInput;
};


export type MutationUpsertClientServiceMapArgs = {
  input: ClientServiceMapInput;
};


export type MutationUpsertClientServiceMapSubdomainArgs = {
  input: ClientServiceMapSubdomainUpsertInput;
};


export type MutationUpsertFloatingHolidaysArgs = {
  ptoDayIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationUpsertForecastDataArgs = {
  input: ForecastDataInput;
};


export type MutationUpsertGiftCampaignArgs = {
  input: UpsertGiftCampaignInput;
};


export type MutationUpsertGiftCampaignEntryArgs = {
  input: UpsertGiftCampaignEntryInput;
};


export type MutationUpsertKgNotificationArgs = {
  kgNotification: KgNotificationInput;
};


export type MutationUpsertManagerDocArgs = {
  document: ManagerDocInput;
};


export type MutationUpsertMeetingArgs = {
  input: MeetingInput;
};


export type MutationUpsertProjectBlackoutPeriodArgs = {
  input: ProjectBlackoutPeriodInput;
};


export type MutationUpsertPromptArgs = {
  input: PromptInput;
};


export type MutationUpsertRevenueRecognitionArgs = {
  input: RevenueRecognitionInput;
};


export type MutationUpsertTimesheetWeeklyMetadataNotesArgs = {
  notes: Scalars['String']['input'];
  userID: Scalars['Int']['input'];
  weekStartDate: Scalars['Date']['input'];
};


export type MutationUpsertTripArgs = {
  input: TripInput;
};


export type MutationUpsertTripMeetingArgs = {
  input: TripMeetingInput;
};


export type MutationWorkHistoryUpsertArgs = {
  clearProposed?: InputMaybe<Scalars['Boolean']['input']>;
  proposed?: InputMaybe<Scalars['Boolean']['input']>;
  workHistoryInput: WorkHistoryInput;
};

export type NewMessage = {
  __typename?: 'NewMessage';
  assistantID?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageID?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  threadID?: Maybe<Scalars['String']['output']>;
  userID?: Maybe<Scalars['Int']['output']>;
};

export type NewTag = {
  categoryId: Scalars['Int']['input'];
  displayName: Scalars['String']['input'];
};

export type Note = {
  __typename?: 'Note';
  accountServiceTeamId?: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy: Person;
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  links: Array<NoteLink>;
  modified: Scalars['DateTime']['output'];
  modifiedBy: Person;
  note: Scalars['JSONObject']['output'];
  owner: Person;
  ownerID: Scalars['Int']['output'];
  portalTags: Array<PortalTag>;
  primaryObject?: Maybe<NotePrimaryObject>;
  primaryObjectID: Scalars['Int']['output'];
  primaryObjectType: NoteObjectType;
  title: Scalars['String']['output'];
};

export type NoteInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isPrimary: Scalars['Boolean']['input'];
  lastModified?: InputMaybe<Scalars['DateTime']['input']>;
  links: Array<NoteLinkInput>;
  note: Scalars['JSONObject']['input'];
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  ownerID?: InputMaybe<Scalars['Int']['input']>;
  primaryObjectID: Scalars['Int']['input'];
  primaryObjectType: NoteObjectType;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  title: Scalars['String']['input'];
};

export type NoteLink = {
  __typename?: 'NoteLink';
  createdAt: Scalars['String']['output'];
  createdBy: Person;
  id: Scalars['Int']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  noteID: Scalars['Int']['output'];
  objectID: Scalars['Int']['output'];
  objectType: NoteObjectType;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NoteLinkInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  objectID: Scalars['Int']['input'];
  objectType: NoteObjectType;
};

export enum NoteObjectType {
  Client = 'client',
  Contact = 'contact',
  Opportunity = 'opportunity',
  Proposal = 'proposal'
}

export type NotePrimaryObject = {
  __typename?: 'NotePrimaryObject';
  id: Scalars['Int']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** A Notification */
export type Notification = {
  __typename?: 'Notification';
  action?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  priority: NotificationPriority;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: NotificationType;
};

export type NotificationContext = {
  __typename?: 'NotificationContext';
  bcc: Array<Scalars['String']['output']>;
  cc: Array<Scalars['String']['output']>;
  company: Scalars['String']['output'];
  department: Scalars['String']['output'];
  office: Scalars['String']['output'];
};

export type NotificationContextInput = {
  bcc: Array<Scalars['String']['input']>;
  cc: Array<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  department: Scalars['String']['input'];
  office: Scalars['String']['input'];
};

export type NotificationDefaults = {
  __typename?: 'NotificationDefaults';
  browser: Scalars['Boolean']['output'];
  email: Scalars['Boolean']['output'];
  kgnotif: Scalars['Boolean']['output'];
  slack: Scalars['Boolean']['output'];
};

export type NotificationEmailOptions = {
  __typename?: 'NotificationEmailOptions';
  canBeDisabled: Scalars['Boolean']['output'];
  canBeSummarized: Scalars['Boolean']['output'];
};

export type NotificationLog = {
  __typename?: 'NotificationLog';
  attachments?: Maybe<Scalars['Int']['output']>;
  bcc: Scalars['String']['output'];
  body?: Maybe<Scalars['String']['output']>;
  cc: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sentDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  template: Scalars['String']['output'];
  to: Scalars['String']['output'];
  unfilteredBcc?: Maybe<Scalars['String']['output']>;
  unfilteredCc?: Maybe<Scalars['String']['output']>;
  unfilteredTo?: Maybe<Scalars['String']['output']>;
};

export type NotificationOptions = {
  __typename?: 'NotificationOptions';
  email: NotificationEmailOptions;
  isConfigurable: Scalars['Boolean']['output'];
  permissions?: Maybe<NotificationPermissions>;
  priority: NotificationPriorityV2;
  resendInterval?: Maybe<Scalars['Int']['output']>;
  slack: NotificationSlackOptions;
};

export type NotificationPermissions = {
  __typename?: 'NotificationPermissions';
  anyOf: Scalars['Boolean']['output'];
  required: Array<Scalars['String']['output']>;
};

export enum NotificationPriority {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL'
}

export enum NotificationPriorityV2 {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type NotificationSlackOptions = {
  __typename?: 'NotificationSlackOptions';
  canBeDeferred: Scalars['Boolean']['output'];
  canBeDisabled: Scalars['Boolean']['output'];
};

export enum NotificationType {
  ActionItem = 'ACTION_ITEM',
  AssignmentApproval = 'ASSIGNMENT_APPROVAL',
  ClientsApprovalCount = 'CLIENTS_APPROVAL_COUNT',
  Dynamic = 'DYNAMIC',
  ItCompliance = 'IT_COMPLIANCE',
  ProjectsApprovalCount = 'PROJECTS_APPROVAL_COUNT',
  PtoManager = 'PTO_MANAGER',
  Timesheet = 'TIMESHEET',
  TimesheetManager = 'TIMESHEET_MANAGER',
  TravelManager = 'TRAVEL_MANAGER',
  TravelOps = 'TRAVEL_OPS',
  UpcomingReview = 'UPCOMING_REVIEW',
  WorkHistory = 'WORK_HISTORY'
}

export type NotificationTypeV2 = {
  __typename?: 'NotificationTypeV2';
  defaults: NotificationDefaults;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  extDescription: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  options: NotificationOptions;
  typeName: Scalars['String']['output'];
};

export type Notifications = {
  __typename?: 'Notifications';
  /** Standard Errors */
  errors?: Maybe<Array<Maybe<StdError>>>;
  /** List of Notifications */
  notifications: Array<Maybe<Notification>>;
};

export type Offboarding = {
  __typename?: 'Offboarding';
  account?: Maybe<Account>;
  accountOffboard?: Maybe<Scalars['Boolean']['output']>;
  assignees: Array<Person>;
  created?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  itTicketID?: Maybe<Scalars['String']['output']>;
  itTicketKey?: Maybe<Scalars['String']['output']>;
  itTicketLink?: Maybe<Scalars['String']['output']>;
  itTicketStatus?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['Date']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  offboardingDate: Scalars['Date']['output'];
  program?: Maybe<Program>;
  programOffboard?: Maybe<Scalars['Boolean']['output']>;
  project: Project;
  projectOffboard?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user: Person;
};

export type OffboardingInput = {
  assignees?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** A KG Office */
export type Office = {
  __typename?: 'Office';
  /**
   * Complete address for the office, multi line,
   * format to show new line characters when using
   */
  Address?: Maybe<Scalars['String']['output']>;
  /**
   * Audit log for this item, limited to super admins
   * ** Do not call this on lists, as it is incredibly expensive. **
   */
  AuditLog?: Maybe<Array<Maybe<AuditLog>>>;
  /** Buildings owned by this office */
  Buildings?: Maybe<Array<Maybe<OfficeBuilding>>>;
  /** Office Country */
  Country?: Maybe<Scalars['String']['output']>;
  /** Order to be used when in a dropdown or other sortable material */
  DropdownOrder?: Maybe<Scalars['Int']['output']>;
  /**
   * Guest WiFi details for the office, multi line
   * format to show new line characters when using
   */
  GuestWifi?: Maybe<Scalars['String']['output']>;
  /** Returns standard business hours for the week (Week starts on monday), if given a specific date will return with stat holidays taken into account */
  Hours?: Maybe<OfficeHours>;
  HoursClose?: Maybe<Scalars['DateTime']['output']>;
  /** Will retreive today's hours if none specified, weekends will show closed */
  HoursOpen?: Maybe<Scalars['DateTime']['output']>;
  /** IP Addressess owned by this office */
  IPAddresses?: Maybe<Array<Maybe<OfficeIpAddress>>>;
  /** Whether this office is available as a Client Service Location */
  IsClientServicesLocation?: Maybe<Scalars['Boolean']['output']>;
  /** Latitude of office, ignore if 0 */
  Latitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude of office, ignore if 0 */
  Longitude?: Maybe<Scalars['Float']['output']>;
  /**
   * Office Name
   * Often the name of the city the office resides in
   */
  Name?: Maybe<Scalars['String']['output']>;
  /**  Office ID  */
  OfficeID: Scalars['Int']['output'];
  /**
   * Office Phone
   * Direct line to the office, this can be blank
   */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Count of timetrackers in department */
  Timetrackers?: Maybe<Scalars['Int']['output']>;
  /** IANA timezone */
  Timezone?: Maybe<Scalars['String']['output']>;
  /** The end of work hours for an office (in EST) */
  workHoursEnd?: Maybe<Scalars['String']['output']>;
  /** The beginning of work hours for an office (in EST) */
  workHoursStart?: Maybe<Scalars['String']['output']>;
};


/** A KG Office */
export type OfficeAuditLogArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


/** A KG Office */
export type OfficeHoursArgs = {
  week?: InputMaybe<Scalars['Date']['input']>;
};


/** A KG Office */
export type OfficeHoursCloseArgs = {
  day?: InputMaybe<Scalars['Date']['input']>;
};


/** A KG Office */
export type OfficeHoursOpenArgs = {
  day?: InputMaybe<Scalars['Date']['input']>;
};

export type OfficeBuilding = {
  __typename?: 'OfficeBuilding';
  IPs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  Name: Scalars['String']['output'];
};

/** Standard office hours; week begins on monday */
export type OfficeHours = {
  __typename?: 'OfficeHours';
  Friday?: Maybe<OfficeHoursDay>;
  Monday?: Maybe<OfficeHoursDay>;
  Saturday?: Maybe<OfficeHoursDay>;
  Sunday?: Maybe<OfficeHoursDay>;
  Thursday?: Maybe<OfficeHoursDay>;
  Tuesday?: Maybe<OfficeHoursDay>;
  Wednesday?: Maybe<OfficeHoursDay>;
};

/** Office hours for a single office, actual working times may vary */
export type OfficeHoursDay = {
  __typename?: 'OfficeHoursDay';
  HoursClose?: Maybe<Scalars['DateTime']['output']>;
  HoursOpen?: Maybe<Scalars['DateTime']['output']>;
  IsHoliday?: Maybe<Scalars['Boolean']['output']>;
};

export type OfficeIpAddress = {
  __typename?: 'OfficeIPAddress';
  Building?: Maybe<Scalars['String']['output']>;
  IP: Scalars['String']['output'];
};

/** Input type for updating an office */
export type OfficeInput = {
  /**
   * Complete address for the office, multi line,
   * new line characters will be respected
   */
  Address?: InputMaybe<Scalars['String']['input']>;
  /** Buildings for the office, comma separated */
  Buildings?: InputMaybe<Scalars['String']['input']>;
  /** Office Country */
  Country?: InputMaybe<Scalars['String']['input']>;
  /**
   * Guest WiFi details for the office, multi line
   * new line characters will be respected
   */
  GuestWifi?: InputMaybe<Scalars['String']['input']>;
  /** IP Addresses for the office, comma separated, format: 0.0.0.0:building,0.0.0.1:building2 */
  IPAddresses?: InputMaybe<Scalars['String']['input']>;
  /** Latitude */
  Latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude */
  Longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Office Phone Number */
  Phone?: InputMaybe<Scalars['String']['input']>;
  /** Timezone for the office, from here: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  Timezone?: InputMaybe<Scalars['String']['input']>;
  /** The end of work hours for an office (in EST) */
  workHoursEnd?: InputMaybe<Scalars['String']['input']>;
  /** The beginning of work hours for an office (in EST) */
  workHoursStart?: InputMaybe<Scalars['String']['input']>;
};

/** A List of KG Offices */
export type Offices = {
  __typename?: 'Offices';
  /** Standard Errors */
  errors?: Maybe<Array<Maybe<StdError>>>;
  /** List of Offices */
  offices?: Maybe<Array<Office>>;
};

export type OnboardingResponse = {
  __typename?: 'OnboardingResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OnboardingUser = {
  companyId: Scalars['Int']['input'];
  departmentId: Scalars['Int']['input'];
  disciplines?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  email: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isPartTime: Scalars['Boolean']['input'];
  isTemporary: Scalars['Boolean']['input'];
  jobTitle: Scalars['String']['input'];
  managerId: Scalars['Int']['input'];
  nameFirst: Scalars['String']['input'];
  nameLast: Scalars['String']['input'];
  officeId: Scalars['Int']['input'];
  preOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  ptoDays: Scalars['Float']['input'];
  startDate: Scalars['Date']['input'];
  tracksTime: Scalars['Boolean']['input'];
};

export type OpenAiConfig = {
  frequencyPenalty?: InputMaybe<Scalars['Float']['input']>;
  presencePenalty?: InputMaybe<Scalars['Float']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  topP?: InputMaybe<Scalars['Float']['input']>;
};

export type OpenAiInteraction = {
  __typename?: 'OpenAIInteraction';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  role: Scalars['String']['output'];
  user: Person;
  when: Scalars['DateTime']['output'];
};

export type OpenAiModel = {
  __typename?: 'OpenAIModel';
  default: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  internalName: Scalars['String']['output'];
};

export type OpenAiSession = {
  __typename?: 'OpenAISession';
  created: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  /** Currently generating data */
  generating: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interactions: Array<OpenAiInteraction>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  user?: Maybe<Person>;
  userID: Scalars['Int']['output'];
};

export enum OperationType {
  Add = 'add',
  Remove = 'remove',
  Replace = 'replace'
}

export type Opportunity = {
  __typename?: 'Opportunity';
  account?: Maybe<Account>;
  actualCloseDate?: Maybe<Scalars['Date']['output']>;
  approved: Scalars['Boolean']['output'];
  approvedByUser?: Maybe<Person>;
  businesses?: Maybe<Array<Business>>;
  clientServicesLocation?: Maybe<Office>;
  clientServicesLocationID?: Maybe<Scalars['Int']['output']>;
  contacts?: Maybe<Array<Contact>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  earliestEngagementStartDate?: Maybe<Scalars['Date']['output']>;
  elUser?: Maybe<Person>;
  elUserID?: Maybe<Scalars['Int']['output']>;
  estimatedClose?: Maybe<Scalars['Date']['output']>;
  estimatedStart?: Maybe<Scalars['Date']['output']>;
  generatedPurchaseOrder?: Maybe<Scalars['Boolean']['output']>;
  hasEngagement: Scalars['Boolean']['output'];
  hideFromForecast?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  lastEstimatedClose?: Maybe<Scalars['Date']['output']>;
  lastEstimatedCloseChange?: Maybe<Scalars['Date']['output']>;
  lastEstimatedStart?: Maybe<Scalars['Date']['output']>;
  lastEstimatedStartChange?: Maybe<Scalars['Date']['output']>;
  lastStage?: Maybe<Scalars['String']['output']>;
  lastStageChange?: Maybe<Scalars['Date']['output']>;
  lastStatusChange?: Maybe<Scalars['Date']['output']>;
  lastStatusChangeBy?: Maybe<Scalars['Int']['output']>;
  lastStatusChangeByUser?: Maybe<Person>;
  lastValue?: Maybe<Scalars['Float']['output']>;
  lastValueChange?: Maybe<Scalars['Date']['output']>;
  logs: Array<OpportunityLog>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Person>;
  projectAccountID?: Maybe<Scalars['Int']['output']>;
  projects: Array<Project>;
  purchaseOrders?: Maybe<Array<PurchaseOrder>>;
  /**  Relevance score from quick search (only populated in quick search results)  */
  relevanceScore?: Maybe<Scalars['Float']['output']>;
  salesEntity?: Maybe<Scalars['Int']['output']>;
  skills: Array<ProfessionalSkillTag>;
  stage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusCommentID?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['Int']['output']>>;
  tdUser?: Maybe<Person>;
  tdUserID?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  winPercentage?: Maybe<Scalars['Float']['output']>;
};


export type OpportunityLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum OpportunityDateFilter {
  Custom = 'custom',
  LastMonth = 'lastMonth',
  LastWeek = 'lastWeek',
  Latest = 'latest',
  SixMonthsAgo = 'sixMonthsAgo',
  TwoMonthsAgo = 'twoMonthsAgo'
}

export type OpportunityInput = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  businesses?: InputMaybe<Array<Business>>;
  clientServicesLocationID?: InputMaybe<Scalars['Int']['input']>;
  contacts?: InputMaybe<Array<Scalars['Int']['input']>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  elUserID?: InputMaybe<Scalars['Int']['input']>;
  estimatedClose?: InputMaybe<Scalars['Date']['input']>;
  estimatedStart?: InputMaybe<Scalars['Date']['input']>;
  generatePO?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromForecast?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  projectAccountID?: InputMaybe<Scalars['Int']['input']>;
  replaceStatus?: InputMaybe<Scalars['Boolean']['input']>;
  salesEntity?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  tdUserID?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  winPercentage?: InputMaybe<Scalars['Int']['input']>;
};

export type OpportunityLink = {
  __typename?: 'OpportunityLink';
  created: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  createdByObject?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  modified: Scalars['Date']['output'];
  modifiedBy: Scalars['Int']['output'];
  modifiedByObject?: Maybe<Person>;
  opportunityId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  titleAuto?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OpportunityLinkInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  opportunityId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityLog = {
  __typename?: 'OpportunityLog';
  action: Scalars['String']['output'];
  actionDoneByUser?: Maybe<Person>;
  actionDoneByUserId: Scalars['Int']['output'];
  changes: Array<Change>;
  created: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<Opportunity>;
  opportunityId: Scalars['Int']['output'];
  original?: Maybe<Scalars['JSONObject']['output']>;
  updated?: Maybe<Scalars['JSONObject']['output']>;
};

export type OpportunityPipelineComparisonMovement = {
  __typename?: 'OpportunityPipelineComparisonMovement';
  fromCount: Scalars['Int']['output'];
  fromValue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  stage: Scalars['String']['output'];
  toCount: Scalars['Int']['output'];
  toValue: Scalars['Float']['output'];
};

export type OpportunityPipelineComparisonStat = {
  __typename?: 'OpportunityPipelineComparisonStat';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lateCount: Scalars['Int']['output'];
  movement: Array<OpportunityPipelineComparisonMovement>;
  stage: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  valueDown: Scalars['Float']['output'];
  valueLate: Scalars['Float']['output'];
  valueUp: Scalars['Float']['output'];
};

export type OpportunityPipelineStat = {
  __typename?: 'OpportunityPipelineStat';
  count?: Maybe<Scalars['Int']['output']>;
  lateCount?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  valueLate?: Maybe<Scalars['Float']['output']>;
};

export type OpportunityStatsComparisonResponse = {
  __typename?: 'OpportunityStatsComparisonResponse';
  id: Scalars['ID']['output'];
  stats: Array<OpportunityPipelineComparisonStat>;
};

export type OpportunityStatsResponse = {
  __typename?: 'OpportunityStatsResponse';
  id: Scalars['ID']['output'];
  stats: Array<OpportunityPipelineStat>;
  targetDate: Scalars['Date']['output'];
};

export type Option = {
  __typename?: 'Option';
  compliant?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OverlappingProject = {
  __typename?: 'OverlappingProject';
  overlappingHours?: Maybe<Scalars['Int']['output']>;
  project?: Maybe<Project>;
};

export type PtoBalanceReportResults = {
  __typename?: 'PTOBalanceReportResults';
  balance?: Maybe<Scalars['Float']['output']>;
  crossesRollover?: Maybe<Scalars['Boolean']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastRolloverDate?: Maybe<Scalars['Date']['output']>;
  nameFirst?: Maybe<Scalars['String']['output']>;
  nameLast?: Maybe<Scalars['String']['output']>;
  nextRolloverDate?: Maybe<Scalars['Date']['output']>;
  officeName?: Maybe<Scalars['String']['output']>;
};

export type PtoCalc = {
  __typename?: 'PTOCalc';
  accrued?: Maybe<Scalars['Float']['output']>;
  adjustments?: Maybe<Scalars['Float']['output']>;
  allowance?: Maybe<Scalars['Float']['output']>;
  available?: Maybe<Scalars['Float']['output']>;
  availableByAccrued?: Maybe<Scalars['Float']['output']>;
  balance?: Maybe<Scalars['Float']['output']>;
  carryover?: Maybe<Scalars['Float']['output']>;
  rollover?: Maybe<Scalars['Date']['output']>;
  sickDayAllowance?: Maybe<Scalars['Int']['output']>;
  sickDayBalance?: Maybe<Scalars['Float']['output']>;
  taken?: Maybe<Scalars['Float']['output']>;
  upcoming?: Maybe<Scalars['Float']['output']>;
};

export type PtoDay = {
  __typename?: 'PTODay';
  dayCount?: Maybe<Scalars['Int']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  office?: Maybe<Array<Maybe<Office>>>;
  start?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type PtoDayAddInput = {
  end: Scalars['Date']['input'];
  officeIDs: Array<Scalars['Int']['input']>;
  start: Scalars['Date']['input'];
  title: Scalars['String']['input'];
  type: Scalars['Int']['input'];
};

export type PtoEntry = {
  __typename?: 'PTOEntry';
  approved?: Maybe<Scalars['Boolean']['output']>;
  approvedByUser?: Maybe<Person>;
  approvedDate?: Maybe<Scalars['Date']['output']>;
  dayCount?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  halfDay?: Maybe<Scalars['Boolean']['output']>;
  halfDayTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type PtoEstimateInput = {
  end: Scalars['Date']['input'];
  isHalfDay?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['Date']['input'];
  type?: InputMaybe<Scalars['Int']['input']>;
  userID: Scalars['Int']['input'];
};

export type PtoEstimatePayload = {
  __typename?: 'PTOEstimatePayload';
  estimateValue: Scalars['Float']['output'];
  hasBlackout?: Maybe<Scalars['Boolean']['output']>;
};

export type PtoRequest = {
  __typename?: 'PTORequest';
  approved: Scalars['Boolean']['output'];
  approvedByUser?: Maybe<Person>;
  approvedDate?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dayCount: Scalars['Float']['output'];
  end: Scalars['Date']['output'];
  halfDayTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  start: Scalars['Date']['output'];
  triaged?: Maybe<Scalars['Date']['output']>;
  triagedBy?: Maybe<Scalars['Int']['output']>;
  triagedNote?: Maybe<Scalars['String']['output']>;
  type: Scalars['Int']['output'];
  user?: Maybe<Person>;
  userId: Scalars['Int']['output'];
};

export type PtoRequestInput = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  dayCount?: InputMaybe<Scalars['Float']['input']>;
  end: Scalars['Date']['input'];
  halfDayTime?: InputMaybe<Scalars['String']['input']>;
  isHalfDay?: InputMaybe<Scalars['Boolean']['input']>;
  notes: Scalars['String']['input'];
  start: Scalars['Date']['input'];
  type: Scalars['Int']['input'];
};

export type PtoRolloverLog = {
  __typename?: 'PTORolloverLog';
  Details?: Maybe<Scalars['String']['output']>;
  PrevRolloverAmount?: Maybe<Scalars['Float']['output']>;
  RolloverAmount?: Maybe<Scalars['Float']['output']>;
  RolloverDate?: Maybe<Scalars['Date']['output']>;
  RolloverTimestamp?: Maybe<Scalars['DateTime']['output']>;
  Success?: Maybe<Scalars['Int']['output']>;
  UserID?: Maybe<Scalars['Int']['output']>;
};

export type People = {
  __typename?: 'People';
  /**  Standard Errors  */
  errors?: Maybe<Array<Maybe<StdError>>>;
  /**  List of People  */
  people?: Maybe<Array<Maybe<Person>>>;
  /**  List of managers  */
  timeTrackerManagers?: Maybe<Array<Maybe<Person>>>;
};

export enum PeopleEventTypes {
  OffBoarding = 'OffBoarding',
  OnBoarding = 'OnBoarding'
}

/** Permissions available in the portal */
export type Permission = {
  __typename?: 'Permission';
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /** Permission ID */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  /**
   * Audit log for this item, limited to super admins
   * ** Do not call this on lists, as it is incredibly expensive. **
   */
  AuditLog?: Maybe<Array<Maybe<AuditLog>>>;
  /** Department Link */
  department?: Maybe<Department>;
  departmentID?: Maybe<Scalars['Int']['output']>;
  /** Extended description used to help users */
  description?: Maybe<Scalars['String']['output']>;
  /** Discipline Link */
  discipline?: Maybe<Discipline>;
  disciplineID?: Maybe<Scalars['Int']['output']>;
  /** Permission group ID */
  id: Scalars['Int']['output'];
  /** Display name for the group */
  name: Scalars['String']['output'];
  /** Office Link */
  office?: Maybe<Office>;
  officeID?: Maybe<Scalars['Int']['output']>;
  /** A list of all people with a given permission group */
  people: Array<Person>;
  /** List of all permissions that are a part of this permission group */
  permissions: Array<Maybe<PermissionNew>>;
};


export type PermissionGroupAuditLogArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PermissionGroupInput = {
  /** Department Link */
  departmentID?: InputMaybe<Scalars['Int']['input']>;
  /** Extended description used to help users */
  description: Scalars['String']['input'];
  /** Discipline Link */
  disciplineID?: InputMaybe<Scalars['Int']['input']>;
  /** If set to null will create a new permissions group */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Display name for the group */
  name: Scalars['String']['input'];
  /** Office Link */
  officeID?: InputMaybe<Scalars['Int']['input']>;
  /** List of all permissions that are a part of this permission group, this will replace all existing permissions */
  permissions: Array<InputMaybe<PermissionInput>>;
};

export type PermissionInput = {
  /** Extended description intended to help users know what this permission does */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A user readable version of the permission */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Permission ID */
  id: Scalars['Int']['input'];
  /** Ignored, you cant change the name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Permissions available in the portal */
export type PermissionNew = {
  __typename?: 'PermissionNew';
  /** Extended description intended to help users know what this permission does */
  description?: Maybe<Scalars['String']['output']>;
  /** A user readable version of the permission */
  displayName: Scalars['String']['output'];
  /** A list of all permission groups that have this permission */
  groups: Array<PermissionGroup>;
  /** Permission ID */
  id: Scalars['Int']['output'];
  /** Name of the permission, used in backend calls and across the UI to turn features on or off */
  name: Scalars['String']['output'];
  /** A list of all people with a given permission */
  people: Array<Person>;
};

/**  A KG Person  */
export type Person = {
  __typename?: 'Person';
  /**
   * Audit log for this item, limited to super admins
   * ** Do not call this on lists, as it is incredibly expensive. **
   */
  AuditLog?: Maybe<Array<AuditLog>>;
  about?: Maybe<Scalars['String']['output']>;
  accountServicesTeams?: Maybe<Array<AccountServiceTeam>>;
  accountTimeline?: Maybe<Array<AccountTimelineEntry>>;
  accruedDays?: Maybe<Scalars['Float']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  adjustmentsCount?: Maybe<Scalars['Float']['output']>;
  assignmentHistory?: Maybe<Array<PersonAssignment>>;
  /**  The Person's PTO available days */
  availableDays?: Maybe<Scalars['Float']['output']>;
  /**  The Person's PTO available days by accrued */
  availableDaysByAccrued?: Maybe<Scalars['Float']['output']>;
  /**  The Person's PTO balance days */
  balanceDays?: Maybe<Scalars['Float']['output']>;
  birthdayDay?: Maybe<Scalars['Int']['output']>;
  birthdayMonth?: Maybe<Scalars['Int']['output']>;
  /**  The Person's carryover amount */
  carryover?: Maybe<Scalars['Float']['output']>;
  /**  Certifications for User  */
  certifications?: Maybe<Array<Certification>>;
  /**  Helper function to return permission type for given account  */
  clientPermission?: Maybe<Scalars['String']['output']>;
  /**  Company the person belongs to  */
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']['output']>;
  /**  User's current location if it can be found  */
  currentOffice?: Maybe<PersonCurrentOffice>;
  /**
   *  Returns a list of the users current projects, optionally filter out temp projects and future projects
   * @deprecated Use currentProjectsV2 for newer format with the new DB tables
   */
  currentProjects?: Maybe<Array<CurrentProjectPlannerEntry>>;
  /**  Returns a list of the users current projects, optionally filter out temp projects and future projects  */
  currentProjectsV2?: Maybe<Array<CurrentProjectPlannerEntryV2>>;
  dateStartedTrackingTime?: Maybe<Scalars['Date']['output']>;
  /**  degree the user holds  */
  degree?: Maybe<Scalars['String']['output']>;
  /**  Department the person belongs to  */
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['Int']['output']>;
  /**  Dietairy Restrictions for User  */
  dietRestrictions?: Maybe<Scalars['String']['output']>;
  /**  Disciplines skill tags  */
  disciplines: Array<Discipline>;
  dottedLineReportingId?: Maybe<Scalars['Int']['output']>;
  /**  Email address for the person  */
  email?: Maybe<Scalars['String']['output']>;
  /**  Employment Events */
  employmentEvents: Array<EmploymentEvent>;
  /** When a user left the company */
  endDate?: Maybe<Scalars['Date']['output']>;
  /**  Standard Errors  */
  errors?: Maybe<Array<Maybe<StdError>>>;
  /**  The person's number of years experience before KG */
  experienceBeforeKG?: Maybe<Scalars['Float']['output']>;
  /**  Floating Holiday Allowance  */
  floatingHolidayAllowance?: Maybe<Scalars['Float']['output']>;
  /**  Floating Holidays  */
  floatingHolidays?: Maybe<Array<FloatingHoliday>>;
  /**  When the person started full time  */
  ftContractDate?: Maybe<Scalars['Date']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  githubAccountStatus?: Maybe<Scalars['String']['output']>;
  githubAvatarUrl?: Maybe<Scalars['String']['output']>;
  /**  Github Information  */
  githubUserId?: Maybe<Scalars['Int']['output']>;
  githubUsername?: Maybe<Scalars['String']['output']>;
  /**  year the user graduated */
  graduationYear?: Maybe<Scalars['Int']['output']>;
  /**  Comma separated string list of users assigned groups  */
  groups?: Maybe<Scalars['String']['output']>;
  handbookAcceptanceList?: Maybe<Array<HandbookAcceptedLog>>;
  handbookAcceptedDate?: Maybe<Scalars['DateTime']['output']>;
  handbookDocumentsToAccept?: Maybe<Array<HandbookDoc>>;
  /**  Will return true if the person has already filled out their profile  */
  hasFilledProfile?: Maybe<Scalars['Boolean']['output']>;
  /**  Will return true if the person is required to fill out the handbook  */
  hasHandbookUpdates?: Maybe<Scalars['Boolean']['output']>;
  /**  helper indicator  */
  hasTimeApprovees?: Maybe<Scalars['Boolean']['output']>;
  /**  List of people that the person has timesheet access for  */
  hasTimesheetAccessFor: Array<Person>;
  /**  helper indicator thatuser currently needs to fill their timesheet  */
  hasTimesheetDue?: Maybe<Scalars['Boolean']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /**  Home Location for User  */
  homeLocation?: Maybe<Scalars['String']['output']>;
  /**  Home Office the person belongs to  */
  homeOffice?: Maybe<Office>;
  homeOfficeId?: Maybe<Scalars['Int']['output']>;
  /**  User ID  */
  id: Scalars['Int']['output'];
  /**  Institution the user graduated from  */
  institution?: Maybe<Scalars['String']['output']>;
  internalBio?: Maybe<Scalars['String']['output']>;
  internalProjectsWithoutWorkHistory: Array<GeneratedPersonWorkHistory>;
  /**  will return true if the person is away from the office   */
  isAway?: Maybe<Scalars['Boolean']['output']>;
  /**  helper indicator  */
  isManager?: Maybe<Scalars['Boolean']['output']>;
  isPartTime?: Maybe<Scalars['Boolean']['output']>;
  /**  helper indicator  */
  isSubordinateOfCurUser?: Maybe<Scalars['Boolean']['output']>;
  isTemporary?: Maybe<Scalars['Boolean']['output']>;
  isTimeTrackerAutoApproveExempt?: Maybe<Scalars['Boolean']['output']>;
  /**  TimeTracker exemptions  */
  isTimeTrackerAutoFillExempt?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  jobTitleLevel?: Maybe<Scalars['String']['output']>;
  /**  experiences at kg blurb  */
  kgExperience?: Maybe<Scalars['String']['output']>;
  kgExperienceLastUpdated?: Maybe<Scalars['Date']['output']>;
  /**  The Person's last review date */
  lastReviewDate?: Maybe<Scalars['Date']['output']>;
  /**  The Person's last review type */
  lastReviewType?: Maybe<Scalars['String']['output']>;
  /**  Information about the last project this person worked on with another person  */
  lastWorkedWith?: Maybe<LastWorkedWithInfo>;
  /**  Last time the user had a yearly review */
  lastYearlyReview?: Maybe<Scalars['Date']['output']>;
  /**  LinkedIn Link for User  */
  linkedIn?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<Person>;
  managerId?: Maybe<Scalars['Int']['output']>;
  /**  Information about a users mentorship, if one exists.  */
  mentorship?: Maybe<Mentorship>;
  nameFirst: Scalars['String']['output'];
  nameLast: Scalars['String']['output'];
  /**  The next date the Person has more than 10 hours available in a week  */
  nextAvailableDate?: Maybe<Scalars['Date']['output']>;
  /**  The Person's next check-in date */
  nextCheckin?: Maybe<Scalars['Date']['output']>;
  /**  The Person's review date */
  nextReviewDate?: Maybe<Scalars['Date']['output']>;
  /**  The Person's next review type */
  nextReviewType?: Maybe<Scalars['String']['output']>;
  /**  The Person's next rollover date */
  nextRolloverDate?: Maybe<Scalars['Date']['output']>;
  /**  the person's next yearly review date  */
  nextYearlyReview?: Maybe<Scalars['Date']['output']>;
  /**  Office the person belongs to  */
  office?: Maybe<Office>;
  officeId?: Maybe<Scalars['Int']['output']>;
  /**  past experience blurb */
  pastExperience?: Maybe<Scalars['String']['output']>;
  pastExperienceLastUpdated?: Maybe<Scalars['Date']['output']>;
  /**  List of Permission Groups for this User  */
  permissionGroups?: Maybe<Array<PermissionGroup>>;
  /**  List of Permission Groups for this User - auto applied  */
  permissionGroupsAuto?: Maybe<Array<PermissionGroup>>;
  /**  List of Assigned Permissions  */
  permissions?: Maybe<Array<Permission>>;
  /**  Personal Email for User  */
  personalEmail?: Maybe<Scalars['String']['output']>;
  /**  Personal skill tags  */
  personalSkillTags?: Maybe<PersonalSkillTags>;
  /**  Personal Website for User  */
  personalWebsite?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /**  Stringified hash array representing the person's profile picture  */
  photoThumbhash?: Maybe<Scalars['String']['output']>;
  /**  Url of the person's profile picture  */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /**  Planner group override: 5: tech, 6: design, 5: strategy  */
  plannerGroup?: Maybe<Scalars['Int']['output']>;
  preOnboarded?: Maybe<Scalars['Boolean']['output']>;
  /**  Preference to receive planner Updates  */
  prefPlannerUpdates?: Maybe<Scalars['Boolean']['output']>;
  /**
   *  Professional skill tags
   * @deprecated Use professionalSkillTagsV2 for newer format
   */
  professionalSkillTags?: Maybe<ProfessionalSkillTags>;
  professionalSkillTagsV2: Array<UserProfessionalSkillTag>;
  profileLink?: Maybe<Scalars['String']['output']>;
  /**  Returns this users project work history  */
  projectHistory: Array<PersonProject>;
  projectPTOBlackout?: Maybe<Array<ProjectBlackoutPeriod>>;
  projectTimeline: Array<ProjectTimelineEntry>;
  pronouns?: Maybe<Scalars['String']['output']>;
  /** PTO Entries for the person */
  pto: Array<PtoEntry>;
  ptoDays?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['Int']['output']>;
  /**  Relevance score from quick search (only populated in quick search results)  */
  relevanceScore?: Maybe<Scalars['Float']['output']>;
  /**  The Person's rollover date */
  rolloverDate?: Maybe<Scalars['Date']['output']>;
  rolloverDays?: Maybe<Scalars['Float']['output']>;
  sickDaysAvailablePerYear?: Maybe<Scalars['Int']['output']>;
  sickDaysBalance?: Maybe<Scalars['Float']['output']>;
  skillsLastUpdated?: Maybe<Scalars['Date']['output']>;
  /**  If the user skips checkins  */
  skipsCheckins?: Maybe<Scalars['Boolean']['output']>;
  /**  Slack user id for User  */
  slackUserid?: Maybe<Scalars['String']['output']>;
  /**  Slack username for User  */
  slackUsername?: Maybe<Scalars['String']['output']>;
  /**  When the person joined the company  */
  startDate?: Maybe<Scalars['Date']['output']>;
  suggestedSkills: Array<EngagementSkillSuggestion>;
  takenCount?: Maybe<Scalars['Float']['output']>;
  /**  List of people on the person's team  */
  team: Array<Person>;
  /** Time user has been in current position */
  timeInRole?: Maybe<Scalars['Int']['output']>;
  timeTrackerApprover?: Maybe<Person>;
  /**  List of people on the perons's team that they are a Project Tracker Approver for  */
  timeTrackerApproverFor: Array<Person>;
  timeTrackerApproverId?: Maybe<Scalars['Int']['output']>;
  timesheetHistory?: Maybe<Array<TimesheetEntry>>;
  tracksPTO?: Maybe<Scalars['Boolean']['output']>;
  tracksTime?: Maybe<Scalars['Boolean']['output']>;
  /**  Returns this users project work history  */
  trainingHistoryEstimated: Array<PersonTrainingEstimated>;
  /** Travel Entries for the person */
  travel?: Maybe<Array<TravelEntry>>;
  upcomingCount?: Maybe<Scalars['Float']['output']>;
  /**  Returns the list of handbook documents that a user can view in the handbook  */
  visibleHandbookDocuments?: Maybe<Array<HandbookDoc>>;
  /**  Network Devices  */
  wireguardDevices?: Maybe<Array<WireguardDevice>>;
  /**  Work History  */
  workHistories: Array<WorkHistory>;
};


/**  A KG Person  */
export type PersonAuditLogArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


/**  A KG Person  */
export type PersonClientPermissionArgs = {
  accountId: Scalars['Int']['input'];
};


/**  A KG Person  */
export type PersonCurrentProjectsArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  future?: InputMaybe<Scalars['Boolean']['input']>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  A KG Person  */
export type PersonCurrentProjectsV2Args = {
  date?: InputMaybe<Scalars['Date']['input']>;
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  future?: InputMaybe<Scalars['Boolean']['input']>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  A KG Person  */
export type PersonFloatingHolidaysArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


/**  A KG Person  */
export type PersonIsSubordinateOfCurUserArgs = {
  directOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/**  A KG Person  */
export type PersonLastWorkedWithArgs = {
  otherPersonId: Scalars['Int']['input'];
};


/**  A KG Person  */
export type PersonPhotoUrlArgs = {
  size: PhotoSizes;
};


/**  A KG Person  */
export type PersonPtoArgs = {
  approvedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  futureOnly?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


/**  A KG Person  */
export type PersonTimesheetHistoryArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};


/**  A KG Person  */
export type PersonTravelArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type PersonAssignment = {
  __typename?: 'PersonAssignment';
  assignment?: Maybe<ProgramProjectEntry>;
  engagement?: Maybe<Project>;
  role?: Maybe<ProgramProjectRole>;
};

export type PersonCurrentOffice = {
  __typename?: 'PersonCurrentOffice';
  building?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Int']['output']>;
  inOffice?: Maybe<Scalars['Boolean']['output']>;
  office?: Maybe<Office>;
  optedOut?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  birthdayDay?: InputMaybe<Scalars['Int']['input']>;
  birthdayMonth?: InputMaybe<Scalars['Int']['input']>;
  certifications?: InputMaybe<Array<CertificationInput>>;
  degree?: InputMaybe<Scalars['String']['input']>;
  dietRestrictions?: InputMaybe<Scalars['String']['input']>;
  experienceBeforeKG?: InputMaybe<Scalars['Float']['input']>;
  ftContractDate?: InputMaybe<Scalars['Date']['input']>;
  githubUsername?: InputMaybe<Scalars['String']['input']>;
  graduationYear?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  homeLocation?: InputMaybe<Scalars['String']['input']>;
  institution?: InputMaybe<Scalars['String']['input']>;
  internalBio?: InputMaybe<Scalars['String']['input']>;
  kgExperience?: InputMaybe<Scalars['String']['input']>;
  lastReviewDate?: InputMaybe<Scalars['Date']['input']>;
  lastReviewType?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  nextCheckin?: InputMaybe<Scalars['Date']['input']>;
  nextReviewDate?: InputMaybe<Scalars['Date']['input']>;
  nextReviewType?: InputMaybe<Scalars['String']['input']>;
  nextYearlyReview?: InputMaybe<Scalars['Date']['input']>;
  pastExperience?: InputMaybe<Scalars['String']['input']>;
  personalEmail?: InputMaybe<Scalars['String']['input']>;
  personalWebsite?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  skipsCheckins?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A person working on a project */
export type PersonOnProject = {
  __typename?: 'PersonOnProject';
  departmentID?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  nameFirst?: Maybe<Scalars['String']['output']>;
  nameLast?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  userID: Scalars['Int']['output'];
};

export type PersonProject = {
  __typename?: 'PersonProject';
  endDate?: Maybe<Scalars['Date']['output']>;
  /**  Number of hours they worked on said project  */
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /**  Project a person has worked on  */
  project?: Maybe<Project>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

/**  A KG Person simplified for dropdowns and other filters  */
export type PersonSimple = {
  __typename?: 'PersonSimple';
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  nameFirst: Scalars['String']['output'];
  nameLast: Scalars['String']['output'];
  officeId?: Maybe<Scalars['Int']['output']>;
  /**  Url of the person's profile picture  */
  photoUrl?: Maybe<Scalars['String']['output']>;
};


/**  A KG Person simplified for dropdowns and other filters  */
export type PersonSimplePhotoUrlArgs = {
  size: PhotoSizes;
};

export type PersonTrainingEstimated = {
  __typename?: 'PersonTrainingEstimated';
  endDate?: Maybe<Scalars['Date']['output']>;
  /**  Number of hours they worked on said project  */
  hours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /**  Project a person has worked on  */
  project?: Maybe<Project>;
  skill?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type PersonalSkillTag = {
  __typename?: 'PersonalSkillTag';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type PersonalSkillTags = {
  __typename?: 'PersonalSkillTags';
  errors?: Maybe<Array<Maybe<StdError>>>;
  personalSkillTags?: Maybe<Array<PersonalSkillTag>>;
};

export enum PhotoSizes {
  Large = 'large',
  Medium = 'medium',
  Original = 'original',
  Small = 'small'
}

export type PlannedEntriesPoint = {
  __typename?: 'PlannedEntriesPoint';
  assignedEntries?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  unassignedEntries?: Maybe<Scalars['Int']['output']>;
  unresourcedRoles?: Maybe<Scalars['Int']['output']>;
};

export type PlannerUserLog = {
  __typename?: 'PlannerUserLog';
  /** The user who was affected by the change (from the before state where appropriate) */
  affectedUser?: Maybe<Person>;
  /** The other user who was affected by the change (usually only on a person swap on a role) */
  affectedUserAlt?: Maybe<Person>;
  /** What was changed about the object */
  changeData: ChangeData;
  /** The type of change that was made */
  changeType: Scalars['String']['output'];
  /** Who made the change */
  changedBy: Person;
  /** The date and time the change was made */
  createdAt: Scalars['DateTime']['output'];
  /** The id of the change */
  id: Scalars['Int']['output'];
  /** The item type that was changed */
  itemChanged: Scalars['String']['output'];
};

/** A KG Portal Tag */
export type PortalTag = {
  __typename?: 'PortalTag';
  /** Color */
  Color: Scalars['String']['output'];
  /** Portal Tag Display Name */
  DisplayName: Scalars['String']['output'];
  /** Portal Tag Icon */
  Icon: Scalars['String']['output'];
  /** Portal Tag DB Name */
  Name: Scalars['String']['output'];
  /** Portal Tag Category */
  PortalTagCategory: PortalTagCategory;
  /**
   * Tag ID
   * @deprecated use ID Instead
   */
  PortalTagID: Scalars['Int']['output'];
  /** Portal Tag Synonyms */
  Synonyms: Scalars['String']['output'];
  /** Tag ID */
  id: Scalars['Int']['output'];
};

/** A KG Portal Tag Category */
export type PortalTagCategory = {
  __typename?: 'PortalTagCategory';
  /** Portal Tag Category Color */
  Color: Scalars['String']['output'];
  /** Portal Tag Category Display Name */
  DisplayName: Scalars['String']['output'];
  /** Portal Tag Category Icon */
  Icon: Scalars['String']['output'];
  /** Portal Tag Category DB Name */
  Name: Scalars['String']['output'];
  /**
   * Tag Category ID
   * @deprecated use ID Instead
   */
  PortalTagCategoryID: Scalars['Int']['output'];
  Tags: Array<PortalTag>;
  /** Tag Category ID */
  id: Scalars['Int']['output'];
};

export type PowerHour = {
  __typename?: 'PowerHour';
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  presentationDate: Scalars['Date']['output'];
  presenters: Array<Person>;
  slug?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

export type PowerHourList = {
  __typename?: 'PowerHourList';
  past: Array<PowerHour>;
  upcoming: Array<PowerHour>;
};

export type PreviewEmailTemplateResponse = {
  __typename?: 'PreviewEmailTemplateResponse';
  errors: Array<Scalars['String']['output']>;
  html: Scalars['String']['output'];
};

export type ProfessionalSkillTag = {
  __typename?: 'ProfessionalSkillTag';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type ProfessionalSkillTagChange = {
  __typename?: 'ProfessionalSkillTagChange';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Person>;
};

export type ProfessionalSkillTagDetails = {
  __typename?: 'ProfessionalSkillTagDetails';
  category?: Maybe<Scalars['Int']['output']>;
  certifications: Array<CertificationListItem>;
  certifiedDevelopers: Array<CertifiedDeveloper>;
  coreSkill?: Maybe<Scalars['Boolean']['output']>;
  count: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discipline?: Maybe<DisciplineNew>;
  displayName: Scalars['String']['output'];
  holders: Array<ProfessionalSkillTagHolder>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  legacy?: Maybe<Scalars['Boolean']['output']>;
};

export type ProfessionalSkillTagHolder = {
  __typename?: 'ProfessionalSkillTagHolder';
  id: Scalars['Int']['output'];
  person: Person;
  yearsExperience?: Maybe<Scalars['Float']['output']>;
};

export type ProfessionalSkillTagInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  coreSkill?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disciplineID?: InputMaybe<Scalars['Int']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalSkillTagListItem = {
  __typename?: 'ProfessionalSkillTagListItem';
  category?: Maybe<Scalars['Int']['output']>;
  certifications: Array<CertificationListItem>;
  certifiedDevelopers: Array<CertifiedDeveloper>;
  coreSkill?: Maybe<Scalars['Boolean']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  discipline?: Maybe<Scalars['String']['output']>;
  disciplineID?: Maybe<Scalars['Int']['output']>;
  displayName: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  legacy?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['Int']['output']>;
};

export type ProfessionalSkillTags = {
  __typename?: 'ProfessionalSkillTags';
  errors?: Maybe<Array<Maybe<StdError>>>;
  professionalSkillTags?: Maybe<Array<ProfessionalSkillTag>>;
};

/** A Planner Program */
export type Program = {
  __typename?: 'Program';
  account?: Maybe<Account>;
  active?: Maybe<Scalars['Int']['output']>;
  complianceWorkbookID?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  issues?: Maybe<Array<ProgramIssue>>;
  name: Scalars['String']['output'];
  projects: Array<ProgramProject>;
  rateCards?: Maybe<Array<RateCard>>;
  skills?: Maybe<Array<ProfessionalSkillTagListItem>>;
  start?: Maybe<Scalars['Date']['output']>;
  trackedHours?: Maybe<Array<TimeTrackerEntryByDepartmentUser>>;
};


/** A Planner Program */
export type ProgramProjectsArgs = {
  endsAfter?: InputMaybe<Scalars['Date']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  recentlyInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A Planner Program */
export type ProgramRateCardsArgs = {
  konradRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  resourceDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resourceDisciplineIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resourceOfficeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** A Planner Program */
export type ProgramTrackedHoursArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type ProgramContributor = {
  __typename?: 'ProgramContributor';
  departmentID?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  managerNameFirst?: Maybe<Scalars['String']['output']>;
  managerNameLast?: Maybe<Scalars['String']['output']>;
  nameFirst?: Maybe<Scalars['String']['output']>;
  nameLast?: Maybe<Scalars['String']['output']>;
  officeID?: Maybe<Scalars['Int']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  projectID?: Maybe<Scalars['Int']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  userID: Scalars['Int']['output'];
  userJobTitle?: Maybe<Scalars['String']['output']>;
};

export type ProgramInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

/** A Planner Program */
export type ProgramIssue = {
  __typename?: 'ProgramIssue';
  id?: Maybe<Scalars['Int']['output']>;
  ref?: Maybe<Scalars['Int']['output']>;
  refType?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** A Planner Program */
export type ProgramProject = {
  __typename?: 'ProgramProject';
  entries?: Maybe<Array<ProgramProjectEntry>>;
  id: Scalars['Int']['output'];
  issues?: Maybe<Array<ProgramIssue>>;
  project?: Maybe<Project>;
  pto?: Maybe<Array<ProjectPto>>;
  roles?: Maybe<Array<ProgramProjectRole>>;
};


/** A Planner Program */
export type ProgramProjectEntriesArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A Planner Program */
export type ProgramProjectPtoArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};


/** A Planner Program */
export type ProgramProjectRolesArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Program Planner Entry */
export type ProgramProjectEntry = {
  __typename?: 'ProgramProjectEntry';
  allocation?: Maybe<Scalars['Int']['output']>;
  assigned?: Maybe<Scalars['Boolean']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  issues?: Maybe<Array<ProgramIssue>>;
  likelihoodToExtend?: Maybe<Scalars['Int']['output']>;
  likelihoodToExtendDate?: Maybe<Scalars['Date']['output']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['Int']['output']>;
  roleObject?: Maybe<ProgramProjectRole>;
  skills?: Maybe<Array<ProfessionalSkillTagListItem>>;
  start?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  swapability?: Maybe<Scalars['Int']['output']>;
  swapabilityLastUpdated?: Maybe<Scalars['Date']['output']>;
  treatAsAvailable?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<Person>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ProgramProjectEntryInput = {
  allocation?: InputMaybe<Scalars['Int']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  likelihoodToExtend?: InputMaybe<Scalars['Int']['input']>;
  likelihoodToExtendDate?: InputMaybe<Scalars['Date']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  start?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  swapability?: InputMaybe<Scalars['Int']['input']>;
  swapabilityLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  treatAsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A Program Planner Role */
export type ProgramProjectRole = {
  __typename?: 'ProgramProjectRole';
  allocation?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Department>;
  disciplines?: Maybe<Array<DisciplineNew>>;
  end?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  issues?: Maybe<Array<ProgramIssue>>;
  level?: Maybe<Array<Scalars['String']['output']>>;
  notes?: Maybe<Scalars['String']['output']>;
  offices?: Maybe<Array<Office>>;
  optionalSkills?: Maybe<Array<ProfessionalSkillTag>>;
  project?: Maybe<ProgramProjectRoleProjectInfo>;
  requiredSkills?: Maybe<Array<ProfessionalSkillTag>>;
  start?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProgramProjectRoleInput = {
  allocation?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  disciplineIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  end?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  officeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  optionalSkillIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  requiredSkillIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  start?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramProjectRoleProjectInfo = {
  __typename?: 'ProgramProjectRoleProjectInfo';
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** A KG Project */
export type Project = {
  __typename?: 'Project';
  account?: Maybe<Account>;
  /** The Client Account id the project belongs to */
  accountId?: Maybe<Scalars['Int']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  activePhases?: Maybe<Array<ActivePhase>>;
  actualHourlyRate?: Maybe<Scalars['Float']['output']>;
  actualHourlyRateAsOfDate?: Maybe<Scalars['Date']['output']>;
  actualHourlyRateHours?: Maybe<Scalars['Int']['output']>;
  actualHourlyRateLastMonthAsOfDate?: Maybe<Scalars['Float']['output']>;
  actualHours?: Maybe<Scalars['Int']['output']>;
  /** a list of people addigned to the project */
  assigned?: Maybe<Array<ProjectAllocation>>;
  billingType?: Maybe<BillingType>;
  businesses?: Maybe<Array<Business>>;
  clientServicesLocation?: Maybe<Office>;
  clientServicesLocationId?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  complianceWorkbook?: Maybe<ComplianceWorkbookDetails>;
  complianceWorkbookID?: Maybe<Scalars['Int']['output']>;
  contractStatus?: Maybe<ContractStatus>;
  currency?: Maybe<Scalars['String']['output']>;
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  deliverySubStatus?: Maybe<DeliverySubStatus>;
  /** Department ID */
  departmentID?: Maybe<Scalars['Int']['output']>;
  /** Project Description */
  description?: Maybe<Scalars['String']['output']>;
  designLeads?: Maybe<Array<Person>>;
  /** Project */
  displayName?: Maybe<Scalars['String']['output']>;
  elUser?: Maybe<Person>;
  /** EL User */
  elUserId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  executed?: Maybe<Scalars['Boolean']['output']>;
  experienceDirectors?: Maybe<Array<Person>>;
  forecastDetails?: Maybe<Array<ForecastDetails>>;
  hideFromForecast?: Maybe<Scalars['Boolean']['output']>;
  /** Project ID */
  id: Scalars['Int']['output'];
  invoices?: Maybe<Array<Invoice>>;
  lastEndDate?: Maybe<Scalars['Date']['output']>;
  lastEndDateChange?: Maybe<Scalars['Date']['output']>;
  lastMonthAsOfDate?: Maybe<Scalars['Date']['output']>;
  latestTimesheetEntry?: Maybe<Scalars['Date']['output']>;
  leadBillingNotes?: Maybe<Scalars['String']['output']>;
  /** Leverage Ratio */
  leverage?: Maybe<Scalars['Float']['output']>;
  logs?: Maybe<Array<ProjectLog>>;
  /** Miscelaneous Project Notes */
  notes?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<Opportunity>;
  opportunityID?: Maybe<Scalars['Int']['output']>;
  /** people who have worked on the project */
  people?: Maybe<Array<Person>>;
  /** History of people who have worked on this project */
  peopleHistory?: Maybe<Array<ProjectPerson>>;
  planlink?: Maybe<Scalars['String']['output']>;
  plannedHourlyRate?: Maybe<Scalars['Float']['output']>;
  plannedHours?: Maybe<Scalars['Int']['output']>;
  plannedRoleHours?: Maybe<Array<ProjectPlannedEntryByRole>>;
  plannedUserHours?: Maybe<Array<ProjectPlannedEntryByUser>>;
  plannerTemp?: Maybe<Scalars['Boolean']['output']>;
  pmUser?: Maybe<Person>;
  /** PM User */
  pmUserId?: Maybe<Scalars['Int']['output']>;
  program?: Maybe<Program>;
  programId?: Maybe<Scalars['Int']['output']>;
  projectAccountId?: Maybe<Scalars['Int']['output']>;
  projectAccountName?: Maybe<Scalars['String']['output']>;
  /** Account Details */
  projectAccountPhotoUrl?: Maybe<Scalars['String']['output']>;
  projectBudgetEntries?: Maybe<Array<ProjectBudgetEntry>>;
  projectGroup?: Maybe<Scalars['String']['output']>;
  projectPeople?: Maybe<ProjectPeople>;
  projectType?: Maybe<Scalars['String']['output']>;
  projectedHourlyRate?: Maybe<Scalars['Float']['output']>;
  pto?: Maybe<Array<ProjectPto>>;
  ptoBlackoutPeriods?: Maybe<Array<ProjectBlackoutPeriod>>;
  purchaseOrders: Array<PurchaseOrder>;
  rateCards?: Maybe<Array<RateCard>>;
  region?: Maybe<Scalars['Int']['output']>;
  /**  Relevance score from quick search (only populated in quick search results)  */
  relevanceScore?: Maybe<Scalars['Float']['output']>;
  requested?: Maybe<Scalars['Boolean']['output']>;
  resourcingNotes?: Maybe<Scalars['String']['output']>;
  salesforceId?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<ProfessionalSkillTagListItem>>;
  stage?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  suggestedSkills?: Maybe<Array<EngagementSkillSuggestion>>;
  tdUser?: Maybe<Person>;
  /** TD User */
  tdUserId?: Maybe<Scalars['Int']['output']>;
  technologyLeads?: Maybe<Array<Person>>;
  temporary?: Maybe<Scalars['Boolean']['output']>;
  timesheetHours?: Maybe<Scalars['Int']['output']>;
  totalHoursHoliday?: Maybe<Scalars['Int']['output']>;
  totalHoursPTO?: Maybe<Scalars['Int']['output']>;
  trackedHours?: Maybe<Array<TimeTrackerEntryByDepartmentUser>>;
  trackedHoursTotal?: Maybe<Scalars['Int']['output']>;
  /** Customer or Internal */
  type?: Maybe<Scalars['String']['output']>;
  userPlannedHoursReduced?: Maybe<Array<UserPlannedHoursReduced>>;
  value?: Maybe<Scalars['Float']['output']>;
  weeklyReportLastSentAt?: Maybe<Scalars['DateTime']['output']>;
  weeklyReportRequired?: Maybe<Scalars['Boolean']['output']>;
  weeklyReportSenders?: Maybe<Array<Person>>;
  weeklyReportSent?: Maybe<Scalars['Boolean']['output']>;
  winPercentage?: Maybe<Scalars['Int']['output']>;
};


/** A KG Project */
export type ProjectPeopleArgs = {
  company?: InputMaybe<Scalars['Int']['input']>;
  department?: InputMaybe<Scalars['Int']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  inactiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
  manager?: InputMaybe<Scalars['Int']['input']>;
  office?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['Int']['input']>;
  tracksTime?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A KG Project */
export type ProjectPlannedRoleHoursArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


/** A KG Project */
export type ProjectPlannedUserHoursArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


/** A KG Project */
export type ProjectProjectAccountPhotoUrlArgs = {
  size?: InputMaybe<PhotoSizes>;
};


/** A KG Project */
export type ProjectPtoArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};


/** A KG Project */
export type ProjectRateCardsArgs = {
  konradRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  resourceDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resourceDisciplineIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resourceOfficeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** A KG Project */
export type ProjectTotalHoursHolidayArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


/** A KG Project */
export type ProjectTotalHoursPtoArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


/** A KG Project */
export type ProjectTrackedHoursArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


/** A KG Project */
export type ProjectTrackedHoursTotalArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


/** A KG Project */
export type ProjectUserPlannedHoursReducedArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

export type ProjectAllocation = {
  __typename?: 'ProjectAllocation';
  allocation?: Maybe<Scalars['Float']['output']>;
  departmentId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  officeId?: Maybe<Scalars['Int']['output']>;
  /**  Url of the person's profile picture  */
  photoUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<ProjectAllocationRole>;
  startDate?: Maybe<Scalars['Date']['output']>;
  userID: Scalars['Int']['output'];
};


export type ProjectAllocationPhotoUrlArgs = {
  size: PhotoSizes;
};

export type ProjectAllocationPoint = {
  __typename?: 'ProjectAllocationPoint';
  billable?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  maxAllocation?: Maybe<Scalars['Int']['output']>;
  nonBillable?: Maybe<Scalars['Int']['output']>;
  numUsers?: Maybe<Scalars['Int']['output']>;
  overallocated?: Maybe<Scalars['Int']['output']>;
  pto?: Maybe<Scalars['Int']['output']>;
  stat?: Maybe<Scalars['Int']['output']>;
  unallocated?: Maybe<Scalars['Int']['output']>;
};

export type ProjectAllocationRole = {
  __typename?: 'ProjectAllocationRole';
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProjectBlackoutPeriod = {
  __typename?: 'ProjectBlackoutPeriod';
  createdBy: Scalars['Int']['output'];
  dateEnd: Scalars['Date']['output'];
  dateStart: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  modifiedBy: Scalars['Int']['output'];
  peopleAffected: Array<Person>;
  project: Project;
  ptoAffected: Array<PtoRequest>;
  reason?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ProjectBlackoutPeriodInput = {
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  projectID: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectBudgetEntry = {
  __typename?: 'ProjectBudgetEntry';
  hours: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  monthStartDate: Scalars['Date']['output'];
  projectId: Scalars['Int']['output'];
};

export type ProjectHistory = {
  __typename?: 'ProjectHistory';
  completed?: Maybe<Scalars['Int']['output']>;
  contractedHours?: Maybe<Scalars['Int']['output']>;
  date: Scalars['Date']['output'];
  hoursBurned?: Maybe<Scalars['Int']['output']>;
  hoursBurnedAfter2022?: Maybe<Scalars['Int']['output']>;
  hoursPTOToDate?: Maybe<Scalars['Int']['output']>;
  hoursPTOTotal?: Maybe<Scalars['Int']['output']>;
  hoursPlannedToDate?: Maybe<Scalars['Int']['output']>;
  hoursPlannedTotal?: Maybe<Scalars['Int']['output']>;
  hoursRolesToDate?: Maybe<Scalars['Int']['output']>;
  hoursRolesTotal?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  leverage?: Maybe<Scalars['Float']['output']>;
  peopleCountCurrent?: Maybe<Scalars['Int']['output']>;
  peopleCountToDate?: Maybe<Scalars['Int']['output']>;
  peopleCountTotal?: Maybe<Scalars['Int']['output']>;
  projectID: Scalars['Int']['output'];
  rolesCountCurrent?: Maybe<Scalars['Int']['output']>;
  rolesCountToDate?: Maybe<Scalars['Int']['output']>;
  rolesCountTotal?: Maybe<Scalars['Int']['output']>;
};

export type ProjectItem = {
  __typename?: 'ProjectItem';
  company: Scalars['String']['output'];
  content: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ProjectItemInput = {
  company: Scalars['String']['input'];
  content: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ProjectLink = {
  __typename?: 'ProjectLink';
  created: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  createdByObject?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  modified: Scalars['Date']['output'];
  modifiedBy: Scalars['Int']['output'];
  modifiedByObject?: Maybe<Person>;
  projectId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  titleAuto?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ProjectLinkInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectLog = {
  __typename?: 'ProjectLog';
  action: Scalars['String']['output'];
  actionDoneByUser?: Maybe<Person>;
  actionDoneByUserId: Scalars['Int']['output'];
  changes: Array<Change>;
  created: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['JSONObject']['output']>;
  project?: Maybe<Project>;
  projectId: Scalars['Int']['output'];
  updated?: Maybe<Scalars['JSONObject']['output']>;
};

export type ProjectPto = {
  __typename?: 'ProjectPTO';
  dayCount: Scalars['Float']['output'];
  end: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  start: Scalars['Date']['output'];
  type: Scalars['Int']['output'];
  user: PersonSimple;
  userID: Scalars['Int']['output'];
};

/** People working on a project */
export type ProjectPeople = {
  __typename?: 'ProjectPeople';
  people?: Maybe<Array<Maybe<PersonOnProject>>>;
  projectID: Scalars['Int']['output'];
};

export type ProjectPerson = {
  __typename?: 'ProjectPerson';
  endDate?: Maybe<Scalars['Date']['output']>;
  /**  Number of hours they worked on this project  */
  hours?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<Person>;
};

/** A project planner entry with role information */
export type ProjectPlannedEntryByRole = {
  __typename?: 'ProjectPlannedEntryByRole';
  /**  hours of entry  */
  allocation?: Maybe<Scalars['Int']['output']>;
  /**  Department of the entry  */
  departmentId?: Maybe<Scalars['Int']['output']>;
  /**  Date of entry  */
  end: Scalars['Date']['output'];
  /**  programProjectRoleID  */
  id: Scalars['Int']['output'];
  /**  Role  */
  role?: Maybe<Scalars['String']['output']>;
  /**  Date of entry  */
  start: Scalars['Date']['output'];
};

/** A project planner entry with user information */
export type ProjectPlannedEntryByUser = {
  __typename?: 'ProjectPlannedEntryByUser';
  /**  hours of entry  */
  allocation?: Maybe<Scalars['Int']['output']>;
  /**  if this is an assigned entry  */
  assigned?: Maybe<Scalars['Boolean']['output']>;
  /**  Date of entry  */
  end: Scalars['Date']['output'];
  /**  Planner Assignement Entry ID  */
  id: Scalars['Int']['output'];
  /**  Role ID  */
  programProjectRoleID?: Maybe<Scalars['Int']['output']>;
  /**  Date of entry  */
  start: Scalars['Date']['output'];
  /**  User assigned to the entry */
  user?: Maybe<Person>;
};

export enum ProjectRole {
  Architect = 'ARCHITECT',
  BackendDev = 'BACKEND_DEV',
  DataAnalyst = 'DATA_ANALYST',
  DataEngineer = 'DATA_ENGINEER',
  DevopsEngineer = 'DEVOPS_ENGINEER',
  FrontendDev = 'FRONTEND_DEV',
  FullStackDev = 'FULL_STACK_DEV',
  MobileDev = 'MOBILE_DEV',
  PlatformSpecialist = 'PLATFORM_SPECIALIST',
  QaAnalyst = 'QA_ANALYST',
  QaEngineer = 'QA_ENGINEER',
  QaLead = 'QA_LEAD',
  TechnicalProjectManager = 'TECHNICAL_PROJECT_MANAGER',
  TechnicalWriter = 'TECHNICAL_WRITER',
  TechLead = 'TECH_LEAD'
}

export type ProjectTimelineEntry = {
  __typename?: 'ProjectTimelineEntry';
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  /**  Skills the person used on the project  */
  tags?: Maybe<Tags>;
  totalHours?: Maybe<Scalars['Int']['output']>;
};

export type ProjectWithHours = {
  __typename?: 'ProjectWithHours';
  hours: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  project: Project;
  projectID: Scalars['Int']['output'];
};

/** A List of KG Projects */
export type Projects = {
  __typename?: 'Projects';
  /** Standard Errors */
  errors?: Maybe<Array<Maybe<StdError>>>;
  /** List of Projects */
  projects?: Maybe<Array<Project>>;
};

export type Prompt = {
  __typename?: 'Prompt';
  content: Scalars['String']['output'];
  created: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modified: Scalars['Date']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PromptInput = {
  content: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type Proposal = {
  __typename?: 'Proposal';
  account?: Maybe<Account>;
  businesses?: Maybe<Array<Business>>;
  clientServicesLocation: Office;
  clientServicesLocationID: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  createdBy: Person;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  logs: Array<ProposalLog>;
  modified: Scalars['DateTime']['output'];
  modifiedBy: Person;
  nextAction?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<Opportunity>;
  opportunityID?: Maybe<Scalars['Int']['output']>;
  owners: Array<Person>;
  projectAccountID?: Maybe<Scalars['Int']['output']>;
  proposalType?: Maybe<ProposalType>;
  status: ProposalStatus;
  tdUser?: Maybe<Person>;
  tdUserID?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type ProposalChange = {
  __typename?: 'ProposalChange';
  op: ProposalOperationType;
  path: Array<Scalars['String']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ProposalInput = {
  businesses?: InputMaybe<Array<Business>>;
  clientServicesLocationID?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nextAction?: InputMaybe<Scalars['String']['input']>;
  opportunityID?: InputMaybe<Scalars['Int']['input']>;
  ownerUserIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  projectAccountID?: InputMaybe<Scalars['Int']['input']>;
  proposalType?: InputMaybe<ProposalType>;
  status?: InputMaybe<ProposalStatus>;
  tdUserID?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type ProposalLog = {
  __typename?: 'ProposalLog';
  action: Scalars['String']['output'];
  actionDoneByUser?: Maybe<Person>;
  actionDoneByUserId: Scalars['Int']['output'];
  changes: Array<ProposalChange>;
  created: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['JSONObject']['output']>;
  proposal?: Maybe<Proposal>;
  proposalId: Scalars['Int']['output'];
  updated?: Maybe<Scalars['JSONObject']['output']>;
};

export enum ProposalOperationType {
  Add = 'add',
  Remove = 'remove',
  Replace = 'replace'
}

export enum ProposalStatus {
  Archived = 'Archived',
  ClientReview = 'ClientReview',
  ClosedLost = 'ClosedLost',
  ClosedWon = 'ClosedWon',
  Drafting = 'Drafting',
  FollowUp = 'FollowUp',
  InternalReview = 'InternalReview',
  Shaping = 'Shaping',
  Submitted = 'Submitted',
  Waiting = 'Waiting'
}

export enum ProposalType {
  Contract = 'Contract',
  Profile = 'Profile',
  Proposal = 'Proposal',
  Rfp = 'RFP'
}

export type ProposedUserUpdate = {
  __typename?: 'ProposedUserUpdate';
  skills?: Maybe<Array<Scalars['Int']['output']>>;
  workDescription?: Maybe<Scalars['String']['output']>;
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  amount: Scalars['Float']['output'];
  approvalCount: Scalars['Int']['output'];
  approvals: Array<PurchaseOrderApproval>;
  client: Account;
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  dateIssued?: Maybe<Scalars['Date']['output']>;
  documents: Array<Document>;
  id: Scalars['Int']['output'];
  links: Array<PurchaseOrderLink>;
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  validThrough?: Maybe<Scalars['Date']['output']>;
};


export type PurchaseOrderApprovalsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PurchaseOrderApproval = {
  __typename?: 'PurchaseOrderApproval';
  approvedBy: Person;
  canceledByUser?: Maybe<Person>;
  canceledOn?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
};

export type PurchaseOrderInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  clientID?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dateIssued?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  links: Array<PurchaseOrderLinkInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  validThrough?: InputMaybe<Scalars['Date']['input']>;
};

export type PurchaseOrderLink = {
  __typename?: 'PurchaseOrderLink';
  createdAt: Scalars['String']['output'];
  createdBy: Person;
  id: Scalars['Int']['output'];
  imgUrl?: Maybe<Scalars['String']['output']>;
  objectID: Scalars['Int']['output'];
  objectType: PurchaseOrderObjectType;
  purchaseOrderID: Scalars['Int']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PurchaseOrderLinkInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  objectID: Scalars['Int']['input'];
  objectType: PurchaseOrderObjectType;
};

export enum PurchaseOrderObjectType {
  Document = 'document',
  Engagement = 'engagement',
  Opportunity = 'opportunity'
}

export type Query = {
  __typename?: 'Query';
  OpenAIModels: Array<OpenAiModel>;
  OpenAISession?: Maybe<OpenAiSession>;
  OpenAISessions: Array<OpenAiSession>;
  Opportunities: Array<Opportunity>;
  Opportunity?: Maybe<Opportunity>;
  Proposal?: Maybe<Proposal>;
  ProposalAccountEngagementLeads: Array<Person>;
  Proposals: Array<Proposal>;
  /** Gets SQLScripts from table */
  SQLScripts: Array<SqlScript>;
  account?: Maybe<Account>;
  accountBadges: Array<Badge>;
  accountServiceTeam?: Maybe<AccountServiceTeam>;
  accountServiceTeams: Array<AccountServiceTeam>;
  accountlistContributors?: Maybe<Array<ClientContributor>>;
  accounts: Array<Account>;
  accountsEngagementSimple: Array<AccountSimple>;
  accountsNearLocation?: Maybe<Array<Account>>;
  accountsOpportunitySimple: Array<AccountSimple>;
  accountsProposalSimple: Array<AccountSimple>;
  accountsQuickSearch?: Maybe<Array<Account>>;
  actionItem: ActionItem;
  /** Returns users who currently own at least one action item. Used to populate action item owner filter dropdowns. */
  actionItemOwnerSelectOptions: Array<PersonSimple>;
  actionItems: Array<ActionItem>;
  /** Admin dashboard totals */
  adminDashboardReportTotals?: Maybe<AmountsTotalForAdmin>;
  /** Grouped hours and revenue by country */
  adminGroupedHoursAndRevenueByRegion: Array<HoursAndRevenueGroupedByRegion>;
  /** Grouped hours */
  adminGroupedHoursByMonth: Array<HoursGroupedAlt>;
  /** Grouped hours by office */
  adminGroupedHoursByMonthPerOffice: Array<HoursGroupedByOffice>;
  /** Revenue by client data for admin dashboard */
  adminRevenueByClient: Array<RevenueByClientRow>;
  aiAssistant: Assistant;
  aiMessageHistory: MessageHistory;
  aiThread: Thread;
  aiThreads?: Maybe<Array<Thread>>;
  allocationInsightsUserCount?: Maybe<Scalars['Int']['output']>;
  allocationsByDepartment?: Maybe<Array<Maybe<DepartmentAllocation>>>;
  assignmentsLogList: Array<AssignmentsLog>;
  availableFlexibleWork?: Maybe<TravelDays>;
  availableFloatingHolidays: Array<AvailableFloatingHoliday>;
  billableHour: BillableHours;
  billableHours: Array<BillableHours>;
  birthdays: Array<Birthday>;
  businessDays: Array<BusinessDaysItem>;
  /** Get all contacts and their decisions for a gift campaign including potential recipients who have not yet made a decision. */
  campaignContactsWithEntries: Array<ContactWithGiftCampaignEntry>;
  candidateList: Array<Candidate>;
  certification?: Maybe<CertificationItem>;
  certificationDeleteImpact?: Maybe<CertificationDeleteImpact>;
  certificationExpiring: Array<CertificationExpiringItem>;
  certifications: Array<CertificationListItem>;
  checkSlug?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<City>;
  cityList: Array<City>;
  citySearchLogs: Array<CitySearchFrequency>;
  /** Get a single client contract template by ID */
  clientContractTemplate?: Maybe<ClientContractTemplate>;
  /** Get all client contract templates for a given client */
  clientContractTemplates: Array<ClientContractTemplate>;
  clientLink?: Maybe<ClientLink>;
  clientLinks: Array<ClientLink>;
  clientSalesMeeting?: Maybe<ClientSalesMeeting>;
  clientSalesMeetingList: Array<ClientSalesMeeting>;
  clientServiceMap?: Maybe<ClientServiceMap>;
  clientServiceMaps: Array<ClientServiceMap>;
  /** Get only offices that are marked as Client Service Locations */
  clientServicesLocations: Array<Office>;
  clientsWithMeetings: Array<Account>;
  /**  List of colleagues for a given person. A colleague is defined as a person who has worked on the same project as the given person for a total of 120 hours or more */
  colleagues?: Maybe<Array<ColleagueWithOverlappingProjects>>;
  comment?: Maybe<Comment>;
  comments: Array<Comment>;
  /**
   * Get a list of companies at KG
   * @deprecated Use companyListV2
   */
  companyList?: Maybe<Companies>;
  /** Get a list of companies at KG */
  companyListV2?: Maybe<Array<Company>>;
  complianceWorkbook?: Maybe<ComplianceWorkbookDetails>;
  complianceWorkbookAssignees?: Maybe<Array<Person>>;
  complianceWorkbookList: Array<ComplianceWorkbookListItem>;
  complianceWorkbookListSiblings: Array<ComplianceWorkbookListItem>;
  complianceWorkbookQuestions?: Maybe<ComplianceWorkbook>;
  contact?: Maybe<Contact>;
  contactBadges: Array<Badge>;
  contactByLinkedin?: Maybe<Contact>;
  contactDuplicateFind?: Maybe<ContactDuplicateFind>;
  contactLink?: Maybe<ContactLink>;
  contactLinks: Array<ContactLink>;
  contactSelectOptions: Array<ContactSelectOption>;
  contacts: Array<Contact>;
  contactsNearLocation?: Maybe<Array<Contact>>;
  contactsQuickSearch?: Maybe<Array<Contact>>;
  /** Get a single contract template by ID */
  contractTemplate?: Maybe<ContractTemplate>;
  /** Get all contract templates (enabled only by default) */
  contractTemplates: Array<ContractTemplate>;
  /** Get a single department */
  department?: Maybe<Department>;
  /**
   * Departments available at KG
   * All departments are active
   * @deprecated Use `departmentListV2` instead.
   */
  departmentList?: Maybe<Departments>;
  /**
   * Departments available at KG
   * All departments are active
   */
  departmentListV2: Array<Department>;
  /** Get a single discipline */
  discipline?: Maybe<DisciplineNew>;
  /**
   * Disciplines available at KG, sorted in ascending order by DropdownOrder.
   * All disciplines are active
   */
  disciplineList?: Maybe<Array<DisciplineNew>>;
  document?: Maybe<Document>;
  documents: Array<Document>;
  employmentChanges: Array<EmploymentTypeChangeLog>;
  /** Gets the current environment */
  environment: Scalars['String']['output'];
  event?: Maybe<Event>;
  eventList?: Maybe<Events>;
  eventListV2: Array<EventV2>;
  eventV2?: Maybe<EventV2>;
  featureFlag?: Maybe<FeatureFlag>;
  featureFlagList: FeatureFlagList;
  featureFlagListV2: Array<FeatureFlag>;
  file?: Maybe<File>;
  files: Array<File>;
  floatingHoliday?: Maybe<FloatingHoliday>;
  floatingHolidayBalance: FloatingHolidayBalance;
  floatingHolidays: Array<FloatingHoliday>;
  getEmailFrequencyByWeek: Array<Maybe<EmailFrequencyWeekly>>;
  getEmailLogById?: Maybe<EmailLog>;
  getEmailLogsByRecent: Array<EmailLog>;
  getEmailLogsByStatus: Array<EmailLog>;
  getEmailLogsByTemplate: Array<EmailLog>;
  getEmailLogsByUser: Array<EmailLog>;
  getEmailTemplates: Array<EmailTemplate>;
  /** Get a list of all portal tag categories */
  getPortalTagCategoryById?: Maybe<PortalTagCategory>;
  getPortalTagsByPortalTagCategoryId: Array<PortalTag>;
  /** Get a single gift campaign by ID */
  giftCampaign?: Maybe<GiftCampaign>;
  /** Get a single gift campaign entry by unique campaignEntryId */
  giftCampaignEntry?: Maybe<GiftCampaignEntry>;
  /** Get a single gift campaign entry by contact and campaign IDs */
  giftCampaignEntryByContactAndCampaignId?: Maybe<GiftCampaignEntry>;
  /** List all gift campaigns with optional date range filtering */
  giftCampaignList: Array<GiftCampaign>;
  globalNote: GlobalNote;
  handbookDoc?: Maybe<HandbookDoc>;
  handbookDocs?: Maybe<Array<HandbookDoc>>;
  handbookDocsByTag?: Maybe<Array<HandbookDoc>>;
  handbookDocsByTitle: Array<HandbookDoc>;
  handbookUpdateLog?: Maybe<HandbookUpdateLog>;
  handbookUpdatesLogs?: Maybe<HandbookUpdatesLogs>;
  hello?: Maybe<Scalars['String']['output']>;
  /** Number of total Hours recorded */
  hoursByMonthAndBillingType?: Maybe<Array<HoursGrouped>>;
  /** Number of total Hours recorded */
  hoursByMonthAndProjectType?: Maybe<Array<HoursGrouped>>;
  /** Number of total Hours recorded, by date range + split by PTO */
  hoursByProjectType?: Maybe<Array<ProjectAllocationPoint>>;
  /**
   * Institutions available used for the institution list
   * This is a list of all unique within the system
   */
  institutionList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  invoice?: Maybe<Invoice>;
  invoices: Array<Invoice>;
  invoicesPendingApproval: Array<Invoice>;
  jobLogs?: Maybe<Array<JobLog>>;
  /** Job Titles and their sort order */
  jobTitlesList: Array<JobTitle>;
  kgNotifications: Array<KgNotification>;
  /** Get the most recent gift campaign entry where address is approved and the campaign is completed */
  lastCompletedAndApprovedGiftCampaignEntry?: Maybe<GiftCampaignEntry>;
  lastMonthlyHoursLockMonth?: Maybe<LastMonthlyHourReportMonth>;
  /** get a single license by its id or name, one is required */
  license?: Maybe<License>;
  /** get a list of all licenses that we know about, or a list for the specific project */
  licenseList: Array<License>;
  /** get a specific package and its license status, one is required */
  licensePackage?: Maybe<LicensePackage>;
  /** get the list of packages and their license status, optionally for a specific project */
  licensePackageList: Array<LicensePackage>;
  /** get a specific license project */
  licenseProject?: Maybe<LicenseProject>;
  /** get the list of license projects */
  licenseProjectList: Array<LicenseProject>;
  /** get a specific scan */
  licenseScan?: Maybe<LicenseProjectScan>;
  /** get a list of scans for a project */
  licenseScanList: Array<LicenseProjectScan>;
  linkedInChangeLogList?: Maybe<Array<LinkedInChangeLog>>;
  linkedInChangeLogRecord?: Maybe<LinkedInChangeLog>;
  listAiAssistants?: Maybe<Array<Assistant>>;
  listModelOptions?: Maybe<Array<ModelOption>>;
  listStaticCalendars?: Maybe<StaticCalendarList>;
  llmConversation: LlmConversation;
  llmConversations?: Maybe<Array<LlmConversationHistoryItem>>;
  llmMcpServers: Array<McpServer>;
  llmModelOptions: ModelOptions;
  llmToolGroups: Array<ToolGroup>;
  lockedRevenueMonth?: Maybe<LockedRevenueMonth>;
  lockedRevenueMonthByID?: Maybe<LockedRevenueMonth>;
  lockedRevenueMonthsList: Array<LockedRevenueMonth>;
  /** Get a single manager doc by id */
  managerDoc?: Maybe<ManagerDoc>;
  /** Get a list of manager docs optionally iltered by department */
  managerDocsList: Array<ManagerDoc>;
  me: Person;
  meeting?: Maybe<Meeting>;
  meetingList: Array<Meeting>;
  /** Gets request metrics */
  metrics: Metrics;
  myPtoRequests?: Maybe<Array<PtoRequest>>;
  myReports?: Maybe<Reports>;
  myWireguardDevices: Array<WireguardDevice>;
  note?: Maybe<Note>;
  /** Returns users who have authored a note on the given parent record. Used to populate note owner filter dropdowns. */
  noteOwnerSelectOptions: Array<PersonSimple>;
  notes: Array<Note>;
  notesByAccountID: Array<Note>;
  notificationContext: Array<NotificationContext>;
  notificationLogById?: Maybe<NotificationLog>;
  notificationLogs: Array<NotificationLog>;
  notificationSettings: Scalars['String']['output'];
  notificationTypes: Array<NotificationTypeV2>;
  notifications?: Maybe<Notifications>;
  offboardingAssignees: Array<Person>;
  offboardingList: Array<Offboarding>;
  /** Get a single KG Office */
  office?: Maybe<Office>;
  /**
   * KG Offices and information about them.
   * Use this for canonical information about the offices
   */
  officeList?: Maybe<Offices>;
  officeListV2: Array<Office>;
  opportunitiesQuickSearch?: Maybe<Array<Opportunity>>;
  opportunityBadges: Array<Badge>;
  opportunityEngagements: Array<Project>;
  opportunityLink?: Maybe<OpportunityLink>;
  opportunityLinks: Array<OpportunityLink>;
  opportunityMetricsSummary: OpportunityMetricsSummaryResponse;
  opportunityProposals: Array<Proposal>;
  opportunityStatistics: OpportunityStatsResponse;
  opportunityStatisticsComparison: OpportunityStatsComparisonResponse;
  /** @deprecated Use peopleV2 for newer format */
  people?: Maybe<People>;
  peopleQuickSearch?: Maybe<Array<Person>>;
  peopleSimpleAccountMentionable: Array<PersonSimple>;
  peopleV2: Array<Person>;
  /** A permission available on the KG Portal */
  permission: PermissionNew;
  /** a single permission group based on ID */
  permissionGroup: PermissionGroup;
  /** A list of all permission groups available on the portal */
  permissionGroups: Array<PermissionGroup>;
  /** A list of all permissions available to be assigned */
  permissions: Array<PermissionNew>;
  person?: Maybe<Person>;
  personalSkillTag?: Maybe<Tag>;
  personalSkillTags?: Maybe<PersonalSkillTags>;
  plannedHoursByProjectType?: Maybe<Array<ProjectAllocationPoint>>;
  plannedRolesAndAllocation?: Maybe<Array<PlannedEntriesPoint>>;
  /**
   * A list of changes made within planner, this can be multiple types of changes, across multiple objects
   * This is designed as an audit log
   * Limit 1000 items
   */
  plannerUserLogList: Array<PlannerUserLog>;
  portalTagCategoriesList: Array<PortalTagCategory>;
  portalTagsList: Array<PortalTag>;
  powerhours: PowerHourList;
  previewEmailTemplate?: Maybe<PreviewEmailTemplateResponse>;
  professionalSkillBadges: Array<Badge>;
  professionalSkillTag?: Maybe<ProfessionalSkillTagListItem>;
  professionalSkillTagChanges: Array<ProfessionalSkillTagChange>;
  professionalSkillTagV2?: Maybe<ProfessionalSkillTagDetails>;
  /** @deprecated Use professionalSkillTagsV2 */
  professionalSkillTags?: Maybe<ProfessionalSkillTags>;
  professionalSkillTagsV2: Array<ProfessionalSkillTagListItem>;
  program?: Maybe<Program>;
  programBadges: Array<Badge>;
  programProject?: Maybe<ProgramProject>;
  programProjectEntries: Array<ProgramProjectEntry>;
  programlistContributors?: Maybe<Array<ProgramContributor>>;
  programs: Array<Program>;
  project?: Maybe<Project>;
  projectBadges: Array<Badge>;
  projectBlackoutPeriod?: Maybe<ProjectBlackoutPeriod>;
  projectBlackoutPeriodList: Array<ProjectBlackoutPeriod>;
  projectHistory: Array<ProjectHistory>;
  projectLink?: Maybe<ProjectLink>;
  projectLinks: Array<ProjectLink>;
  /** @deprecated Use projectListV2 */
  projectList?: Maybe<Projects>;
  projectListV2: Array<Project>;
  projectsQuickSearch?: Maybe<Array<Project>>;
  projectsWithHours: Array<ProjectWithHours>;
  prompt?: Maybe<Prompt>;
  promptList: Array<Prompt>;
  proposalBadges: Array<Badge>;
  /** Returns users who currently own at least one proposal. Used to populate proposal owner filter dropdowns. */
  proposalOwnerSelectOptions: Array<PersonSimple>;
  ptoBalanceAsOfTodayReport?: Maybe<Array<PtoBalanceReportResults>>;
  ptoCalc?: Maybe<PtoCalc>;
  ptoDay?: Maybe<PtoDay>;
  ptoDays?: Maybe<Array<PtoDay>>;
  ptoEstimate?: Maybe<PtoEstimatePayload>;
  /** Query for user's pto by office */
  ptoForOffice?: Maybe<Array<Maybe<Days>>>;
  /** Query for user's approved pto requests */
  ptoForUser?: Maybe<Array<Maybe<Days>>>;
  ptoRequest?: Maybe<PtoRequest>;
  ptoRequests?: Maybe<Array<PtoRequest>>;
  ptoRequestsPublic?: Maybe<Array<PtoRequest>>;
  ptoUpdateRolloverLog?: Maybe<Array<PtoRolloverLog>>;
  purchaseOrder?: Maybe<PurchaseOrder>;
  purchaseOrders: Array<PurchaseOrder>;
  quickSearch?: Maybe<QuickSearchResults>;
  /** Get a single QuickLink */
  quicklink?: Maybe<QuickLink>;
  /** Quicklinks */
  quicklinks: Array<QuickLink>;
  rateCard?: Maybe<RateCard>;
  rateCardList: Array<RateCard>;
  /**
   * Org-wide reconciliation queue: team members with a timesheet "issue" for the
   * week. Admin-only (timetracker.admin). Returns the same per-week detail shape as
   * timesheetDetailsList, but only for users matching the requested issue
   * categories. Finalized weeks are excluded unless includeFinalized is true.
   * categories: ASSIGNMENT_FLAGGED | ADDITIONAL_HOURS | AUTOFILL_SKIPPED (defaults
   * to ASSIGNMENT_FLAGGED + AUTOFILL_SKIPPED when omitted/empty).
   */
  reconciliationQueue: Array<TimesheetDetails>;
  referrableCompanies: Array<Company>;
  referrableOffices: Array<Office>;
  /** Creates a report of type given and parameters given and returns a download url, url is good for 5 min */
  reportCreate?: Maybe<Scalars['String']['output']>;
  reportCreateRaw?: Maybe<Scalars['JSON']['output']>;
  /** Month will be the first day of the month in question. */
  revenueRecognition: Array<RevenueRecognition>;
  review?: Maybe<Review>;
  reviewTitleApprovals: Array<Review>;
  reviews: Reviews;
  roleTrendsByDateRange: Array<RoleTrend>;
  roleTrendsByNames: Array<RoleTrend>;
  roleTrendsList: Array<RoleTrend>;
  /** Returns a list of the top project roles used in work histories for a given month */
  roleTrendsMonthsMostCommon: Array<RoleTrend>;
  /** Returns a list of all unique project roles used in work histories */
  roleTrendsUnique: Array<Scalars['String']['output']>;
  scheduledJobs: Array<Job>;
  /** Gets the current search cache statistics (admin only) */
  searchCacheStats: SearchCacheStats;
  serviceGroup?: Maybe<ServiceGroup>;
  serviceGroupList: Array<ServiceGroup>;
  skillTrendsByDateRange: Array<SkillTrend>;
  skillTrendsBySkillIds: Array<SkillTrend>;
  skillTrendsList: Array<SkillTrend>;
  /** Returns a list of the most common skills used in work histories for a given month */
  skillTrendsMonthsMostCommon: Array<SkillTrend>;
  skillsSuggested: Array<SkillWithReasoning>;
  slackMessageLogList: Array<SlackMessageLog>;
  sqlQueriesRecent: Array<SqlQueryDetails>;
  suggestSkill: Array<SuggestedSkill>;
  /** Gets the current system load */
  systemInformation: SystemInformation;
  /** Gets info about each table in the DB */
  tablesInfo?: Maybe<Array<TableInfo>>;
  teamProfileGenerationLoad?: Maybe<TeamProfileGeneration>;
  /** Query for all timesheet hours within a certain date */
  timeSheetEntries?: Maybe<Array<Maybe<Hours>>>;
  timeTrackerManagers: Array<Person>;
  timedFileAccessUrl?: Maybe<Scalars['String']['output']>;
  /** Gets timesheet completion statistics for the last 10 weeks */
  timesheetCompletionStats: Array<TimesheetCompletionStat>;
  /** User timesheet details (blank userID gets for current user) */
  timesheetDetails: TimesheetDetails;
  /** User timesheet details list */
  timesheetDetailsList: Array<TimesheetDetails>;
  /** Gets manager approval statistics for the last 10 weeks */
  timesheetManagerApprovalStats: Array<ManagerApprovalStat>;
  /**
   * Audit log of weekly timesheet reminders that have been sent. Admin only.
   * Optional filters by week (Monday), reminder type, and user.
   */
  timesheetReminderSends: Array<TimesheetReminderSend>;
  /** gets a list of timesheet entries that are linked to temp project and in a state that can be reassigned */
  timesheetTempProjectEntries?: Maybe<Array<TimesheetTempProjectEntry>>;
  /**
   * Effective lifecycle state of a user's week (0 Unsubmitted, 1 TeamMemberSubmitted,
   * 2 ManagerApproved, 3 AdminFinalized), computed as the max of the week-level
   * metadata markers and the highest entry state in the week — so it covers both
   * empty weeks (metadata-only) and auto-approved weeks (entry-only). NULL when the
   * week isn't applicable for the user (inactive, doesn't track time, or joined after
   * the week ended). Self-or-manager/admin guarded, same as timesheetDetails.
   */
  timesheetWeekStatus?: Maybe<Scalars['Int']['output']>;
  travelEstimate?: Maybe<TravelEstimatePayload>;
  travelPublic?: Maybe<Array<TravelRequest>>;
  travelRequests?: Maybe<Array<TravelRequest>>;
  trip?: Maybe<Trip>;
  tripMeeting?: Maybe<TripMeeting>;
  tripMeetings: Array<TripMeeting>;
  trips: Array<Trip>;
  tvaReport: Array<TvaVariant>;
  /**  List of managers whose team has unapproved timesheets (entries below ManagerApproved).  */
  unapprovedTimesheets?: Maybe<Array<ManagerUnapprovedTimesheets>>;
  /**
   * Search users by name for async select dropdowns.
   * Returns matching active users filtered by search term.
   * Use `ids` to resolve initial values by ID.
   */
  userSearchOptions: Array<PersonSimple>;
  /**
   * User select options with backend filtering by department and seniority level.
   * Used for populating user selects with filtered options.
   * Filters are applied with OR logic between filter groups and AND logic within each filter.
   */
  userSelectOptions: Array<PersonSimple>;
  /**
   * Query for user
   * @deprecated Use `timesheetDetails` instead.
   */
  userTimesheet?: Maybe<Array<Hours>>;
  /** @deprecated Use `timesheetDetails` instead. */
  userTimesheetList: Array<TimesheetListItem>;
  validateAPIKey?: Maybe<ApiKeyVerification>;
  vaultActivity?: Maybe<Array<VaultActivity>>;
  vaultFile?: Maybe<VaultFile>;
  vaultInbox?: Maybe<Array<VaultFile>>;
  vaultUploads?: Maybe<Array<VaultFile>>;
  whosVisiting?: Maybe<Array<TravelRequest>>;
  wireguardDevice?: Maybe<WireguardDevice>;
  wireguardDevices: Array<WireguardDevice>;
  wireguardServerInfo: Array<WireguardServerInfo>;
  workHistories: Array<WorkHistory>;
  workHistory?: Maybe<WorkHistory>;
};


export type QueryOpenAiSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpportunitiesArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  approvalFilter?: InputMaybe<Scalars['Boolean']['input']>;
  businesses?: InputMaybe<Array<Business>>;
  clientServicesLocationId?: InputMaybe<Array<Scalars['Int']['input']>>;
  closeEnd?: InputMaybe<Scalars['Date']['input']>;
  closeStart?: InputMaybe<Scalars['Date']['input']>;
  contactId?: InputMaybe<Scalars['Int']['input']>;
  cstOnly?: InputMaybe<Scalars['Boolean']['input']>;
  elId?: InputMaybe<Scalars['Int']['input']>;
  excludeWithEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  execSponsorId?: InputMaybe<Scalars['Int']['input']>;
  fulltext?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkedContactID?: InputMaybe<Scalars['Int']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  maxLastUpdated?: InputMaybe<Scalars['Int']['input']>;
  maxStatusLastUpdated?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyInactiveOwners?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  tdId?: InputMaybe<Scalars['Int']['input']>;
  valueEnd?: InputMaybe<Scalars['Float']['input']>;
  valueStart?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryOpportunityArgs = {
  OpportunityId: Scalars['Int']['input'];
};


export type QueryProposalArgs = {
  ProposalId: Scalars['Int']['input'];
};


export type QueryProposalAccountEngagementLeadsArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryProposalsArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  businesses?: InputMaybe<Array<Business>>;
  clientServicesLocationId?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdById?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dueDateEnd?: InputMaybe<Scalars['Date']['input']>;
  dueDateStart?: InputMaybe<Scalars['Date']['input']>;
  elId?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  opportunityId?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  proposalType?: InputMaybe<Array<ProposalType>>;
  salesEntity?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ProposalStatus>>;
  tdId?: InputMaybe<Scalars['Int']['input']>;
  valueEnd?: InputMaybe<Scalars['Float']['input']>;
  valueStart?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerySqlScriptsArgs = {
  onlyHasNotRun?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAccountArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryAccountBadgesArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryAccountServiceTeamArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccountServiceTeamsArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryAccountlistContributorsArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryAccountsArgs = {
  alliance?: InputMaybe<Scalars['Boolean']['input']>;
  businesses?: InputMaybe<Array<Business>>;
  city?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<CityCoordinatesInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  cstOnly?: InputMaybe<Scalars['Boolean']['input']>;
  el?: InputMaybe<Scalars['Int']['input']>;
  es?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openProjects?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  requested?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skillID?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  target?: InputMaybe<Scalars['Boolean']['input']>;
  td?: InputMaybe<Scalars['Int']['input']>;
  writable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAccountsEngagementSimpleArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAccountsNearLocationArgs = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAccountsQuickSearchArgs = {
  clientType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActionItemArgs = {
  id: Scalars['Int']['input'];
};


export type QueryActionItemsArgs = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyInactiveOwners?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  ownerID?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ActionItemStatus>>;
  type?: InputMaybe<ActionItemObjectType>;
};


export type QueryAdminGroupedHoursByMonthArgs = {
  departments?: InputMaybe<Array<Scalars['Int']['input']>>;
  disciplines?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludeInterns?: InputMaybe<Scalars['Boolean']['input']>;
  offices?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryAdminGroupedHoursByMonthPerOfficeArgs = {
  departments?: InputMaybe<Array<Scalars['Int']['input']>>;
  disciplines?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludeInterns?: InputMaybe<Scalars['Boolean']['input']>;
  offices?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryAdminRevenueByClientArgs = {
  maxHours?: InputMaybe<Scalars['Int']['input']>;
  minHours?: InputMaybe<Scalars['Int']['input']>;
  month: Scalars['Int']['input'];
  salesEntity?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryAiAssistantArgs = {
  assistantId: Scalars['String']['input'];
};


export type QueryAiMessageHistoryArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryAiThreadArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryAiThreadsArgs = {
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllocationInsightsUserCountArgs = {
  filters?: InputMaybe<FiltersArgs>;
};


export type QueryAllocationsByDepartmentArgs = {
  filters?: InputMaybe<FiltersArgs>;
};


export type QueryAssignmentsLogListArgs = {
  approvalEnd?: InputMaybe<Scalars['Date']['input']>;
  approvalStart?: InputMaybe<Scalars['Date']['input']>;
  creationEnd?: InputMaybe<Scalars['Date']['input']>;
  creationStart?: InputMaybe<Scalars['Date']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryAvailableFlexibleWorkArgs = {
  period?: InputMaybe<TravelPeriod>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAvailableFloatingHolidaysArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryBillableHourArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBillableHoursArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  projectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryBusinessDaysArgs = {
  endMonth: Scalars['Date']['input'];
  startMonth: Scalars['Date']['input'];
};


export type QueryCampaignContactsWithEntriesArgs = {
  campaignId: Scalars['Int']['input'];
};


export type QueryCandidateListArgs = {
  availabilityWeight: Scalars['Int']['input'];
  disciplines?: InputMaybe<Array<Scalars['Int']['input']>>;
  office?: InputMaybe<Array<Scalars['Int']['input']>>;
  officeWeight: Scalars['Int']['input'];
  optionalSkills?: InputMaybe<Array<Scalars['Int']['input']>>;
  recencyWeight: Scalars['Int']['input'];
  seniority?: InputMaybe<Scalars['String']['input']>;
  seniorityWeight: Scalars['Int']['input'];
  skillWeight: Scalars['Int']['input'];
  skills?: InputMaybe<Array<Scalars['Int']['input']>>;
  targetDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCertificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryCertificationDeleteImpactArgs = {
  id: Scalars['String']['input'];
};


export type QueryCheckSlugArgs = {
  eventId?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryCityArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCityListArgs = {
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  population?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCitySearchLogsArgs = {
  cityId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientContractTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClientContractTemplatesArgs = {
  clientId: Scalars['Int']['input'];
};


export type QueryClientLinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClientLinksArgs = {
  clientId: Scalars['Int']['input'];
  digitalExperienceLink?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryClientSalesMeetingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClientSalesMeetingListArgs = {
  clientID?: InputMaybe<Scalars['Int']['input']>;
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  isInPerson?: InputMaybe<Scalars['Boolean']['input']>;
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showNoDateSet?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryClientServiceMapArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClientServiceMapsArgs = {
  clientId: Scalars['Int']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryColleaguesArgs = {
  id: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCommentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCommentsArgs = {
  parentID?: InputMaybe<Scalars['Int']['input']>;
  primaryObjectID?: InputMaybe<Scalars['Int']['input']>;
  primaryObjectType: CommentObjectType;
};


export type QueryComplianceWorkbookArgs = {
  complianceWorkbookId: Scalars['Int']['input'];
};


export type QueryComplianceWorkbookListArgs = {
  assigneeId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  engagementId?: InputMaybe<Scalars['Int']['input']>;
  hasViolations?: InputMaybe<Scalars['Boolean']['input']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  noExistingCompliance?: InputMaybe<Scalars['Boolean']['input']>;
  onlyMyProjects?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  projectType?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryComplianceWorkbookListSiblingsArgs = {
  complianceWorkbookId?: InputMaybe<Scalars['Int']['input']>;
  engagementId?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryComplianceWorkbookQuestionsArgs = {
  version: Scalars['Int']['input'];
};


export type QueryContactArgs = {
  contactId: Scalars['Int']['input'];
};


export type QueryContactBadgesArgs = {
  contactId: Scalars['Int']['input'];
};


export type QueryContactByLinkedinArgs = {
  linedIn: Scalars['String']['input'];
};


export type QueryContactDuplicateFindArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  nameFirst: Scalars['String']['input'];
  nameLast: Scalars['String']['input'];
};


export type QueryContactLinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContactLinksArgs = {
  contactId: Scalars['Int']['input'];
};


export type QueryContactSelectOptionsArgs = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactsArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  addressType?: InputMaybe<Scalars['String']['input']>;
  buyer?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactToMeet?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<CityCoordinatesInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  giftBoxCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isEA?: InputMaybe<Scalars['Boolean']['input']>;
  isReference?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxCompleteness?: InputMaybe<Scalars['Int']['input']>;
  modifiedWithin?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  types?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryContactsNearLocationArgs = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryContactsQuickSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContractTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContractTemplatesArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDepartmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDepartmentListV2Args = {
  business?: InputMaybe<KgBusiness>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDisciplineArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDisciplineListArgs = {
  departmentID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentsArgs = {
  id: Scalars['Int']['input'];
  objectType?: InputMaybe<DocumentObjectType>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<DocumentObjectType>;
  types?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryEmploymentChangesArgs = {
  affectedUserId: Scalars['Int']['input'];
};


export type QueryEventArgs = {
  eventID?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventListArgs = {
  departmentID?: InputMaybe<Scalars['Int']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  officeID?: InputMaybe<Scalars['Int']['input']>;
  onOrAfterDate?: InputMaybe<Scalars['DateTime']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventListV2Args = {
  departmentID?: InputMaybe<Scalars['Int']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  officeId?: InputMaybe<Scalars['Int']['input']>;
  onOrAfterDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryEventV2Args = {
  eventId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeatureFlagArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFilesArgs = {
  documentId: Scalars['Int']['input'];
};


export type QueryFloatingHolidayArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFloatingHolidayBalanceArgs = {
  targetDate: Scalars['Date']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryFloatingHolidaysArgs = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  managerId?: InputMaybe<Scalars['Int']['input']>;
  officeId?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEmailLogByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetEmailLogsByRecentArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetEmailLogsByStatusArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
};


export type QueryGetEmailLogsByTemplateArgs = {
  template: Scalars['String']['input'];
};


export type QueryGetEmailLogsByUserArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryGetPortalTagCategoryByIdArgs = {
  portalTagCategoryId: Scalars['Int']['input'];
};


export type QueryGetPortalTagsByPortalTagCategoryIdArgs = {
  PortalTagsIDs: Array<Scalars['Int']['input']>;
};


export type QueryGiftCampaignArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGiftCampaignEntryArgs = {
  campaignEntryId: Scalars['Int']['input'];
};


export type QueryGiftCampaignEntryByContactAndCampaignIdArgs = {
  campaignId: Scalars['Int']['input'];
  contactId: Scalars['Int']['input'];
};


export type QueryGiftCampaignListArgs = {
  filters?: InputMaybe<GiftCampaignFilters>;
};


export type QueryGlobalNoteArgs = {
  id: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryHandbookDocArgs = {
  id: Scalars['Int']['input'];
};


export type QueryHandbookDocsArgs = {
  acceptable?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  officeId?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHandbookDocsByTagArgs = {
  tag: Scalars['String']['input'];
};


export type QueryHandbookDocsByTitleArgs = {
  title: Scalars['String']['input'];
};


export type QueryHandbookUpdateLogArgs = {
  id: Scalars['Int']['input'];
};


export type QueryHoursByMonthAndBillingTypeArgs = {
  excludeInternal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHoursByMonthAndProjectTypeArgs = {
  excludeInternal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHoursByProjectTypeArgs = {
  filters?: InputMaybe<FiltersArgs>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryInvoiceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvoicesArgs = {
  clientID?: InputMaybe<Scalars['Int']['input']>;
  el?: InputMaybe<Scalars['Int']['input']>;
  es?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInvoicesPendingApprovalArgs = {
  needsApprovalBy?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobLogsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  num?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobTitlesListArgs = {
  department?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKgNotificationsArgs = {
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyArchived?: InputMaybe<Scalars['Boolean']['input']>;
  onlyImportant?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLastCompletedAndApprovedGiftCampaignEntryArgs = {
  contactId: Scalars['Int']['input'];
};


export type QueryLicenseArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLicenseListArgs = {
  licenseProject?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLicensePackageArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLicensePackageListArgs = {
  licenseProject?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLicenseProjectArgs = {
  id: Scalars['String']['input'];
};


export type QueryLicenseScanArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLicenseScanListArgs = {
  licenseProject?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLinkedInChangeLogListArgs = {
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  showPreviousBlank?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLinkedInChangeLogRecordArgs = {
  linkedInChangeLogRecordId: Scalars['Int']['input'];
};


export type QueryListAiAssistantsArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLlmConversationArgs = {
  id: Scalars['String']['input'];
};


export type QueryLlmConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLlmToolGroupsArgs = {
  forDisplay?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLockedRevenueMonthArgs = {
  month: Scalars['Date']['input'];
};


export type QueryLockedRevenueMonthByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryManagerDocArgs = {
  id: Scalars['Int']['input'];
};


export type QueryManagerDocsListArgs = {
  department?: InputMaybe<Scalars['Int']['input']>;
  office?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMeetingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMeetingListArgs = {
  clientID?: InputMaybe<Scalars['Int']['input']>;
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyPtoRequestsArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryNoteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNoteOwnerSelectOptionsArgs = {
  objectId: Scalars['Int']['input'];
  objectType: NoteObjectType;
};


export type QueryNotesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
  type: NoteObjectType;
};


export type QueryNotesByAccountIdArgs = {
  accountID: Scalars['Int']['input'];
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryNotificationContextArgs = {
  typeName: Scalars['String']['input'];
};


export type QueryNotificationLogByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationLogsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  typeName: Scalars['String']['input'];
};


export type QueryNotificationsArgs = {
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOffboardingListArgs = {
  assignee?: InputMaybe<Scalars['Int']['input']>;
  clientID?: InputMaybe<Scalars['Int']['input']>;
  dateEnd: Scalars['Date']['input'];
  dateStart: Scalars['Date']['input'];
  department?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subordinates?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOfficeArgs = {
  OfficeID: Scalars['Int']['input'];
};


export type QueryOfficeListV2Args = {
  business?: InputMaybe<KgBusiness>;
};


export type QueryOpportunitiesQuickSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOpportunityBadgesArgs = {
  opportunityId: Scalars['Int']['input'];
};


export type QueryOpportunityEngagementsArgs = {
  opportunityId: Scalars['Int']['input'];
};


export type QueryOpportunityLinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOpportunityLinksArgs = {
  opportunityId: Scalars['Int']['input'];
};


export type QueryOpportunityMetricsSummaryArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  clientType?: InputMaybe<Scalars['String']['input']>;
  elUserID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpportunityProposalsArgs = {
  opportunityId: Scalars['Int']['input'];
};


export type QueryOpportunityStatisticsArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  clientType?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  elUserID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOpportunityStatisticsComparisonArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  clientType?: InputMaybe<Scalars['String']['input']>;
  date1: Scalars['Date']['input'];
  date2: Scalars['Date']['input'];
  elUserID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPeopleArgs = {
  business?: InputMaybe<KgBusiness>;
  company?: InputMaybe<Scalars['Int']['input']>;
  department?: InputMaybe<Scalars['Int']['input']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  hasHandbookUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  inactiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
  joinedBeforeDate?: InputMaybe<Scalars['Date']['input']>;
  manager?: InputMaybe<Scalars['Int']['input']>;
  office?: InputMaybe<Scalars['Int']['input']>;
  precache?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['Int']['input']>;
  tracksTime?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPeopleQuickSearchArgs = {
  business?: InputMaybe<KgBusiness>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPeopleSimpleAccountMentionableArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryPeopleV2Args = {
  business?: InputMaybe<KgBusiness>;
  company?: InputMaybe<Scalars['Int']['input']>;
  department?: InputMaybe<Scalars['Int']['input']>;
  departments?: InputMaybe<Array<Scalars['Int']['input']>>;
  filledProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasHandbookUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  inactiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobTitles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  joinedBeforeDate?: InputMaybe<Scalars['Date']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  manager?: InputMaybe<Scalars['Int']['input']>;
  office?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  partTime?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  preOnboardedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  precache?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  showPreOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  tracksTime?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPermissionArgs = {
  PermissionID: Scalars['Int']['input'];
};


export type QueryPermissionGroupArgs = {
  PermissionGroupID: Scalars['Int']['input'];
};


export type QueryPersonArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPersonalSkillTagArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlannedHoursByProjectTypeArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<FiltersArgs>;
};


export type QueryPlannedRolesAndAllocationArgs = {
  filters?: InputMaybe<FiltersArgs>;
};


export type QueryPlannerUserLogListArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  item?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalTagsListArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPowerhoursArgs = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPreviewEmailTemplateArgs = {
  templateString: Scalars['String']['input'];
};


export type QueryProfessionalSkillBadgesArgs = {
  skillID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProfessionalSkillTagArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProfessionalSkillTagV2Args = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProgramArgs = {
  programId: Scalars['Int']['input'];
};


export type QueryProgramBadgesArgs = {
  programId: Scalars['Int']['input'];
};


export type QueryProgramProjectArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryProgramProjectEntriesArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  assignedToID?: InputMaybe<Scalars['Int']['input']>;
  departments?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  engagementID?: InputMaybe<Scalars['Int']['input']>;
  onlyMyProjects?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  programID?: InputMaybe<Scalars['Int']['input']>;
  skillsEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  swapabilityIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  swapabilityLastUpdatedRangeEnd?: InputMaybe<Scalars['Date']['input']>;
  swapabilityLastUpdatedRangeStart?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryProgramlistContributorsArgs = {
  programId: Scalars['Int']['input'];
};


export type QueryProgramsArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  hideDefaults?: InputMaybe<Scalars['Boolean']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectBadgesArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryProjectBlackoutPeriodArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectBlackoutPeriodListArgs = {
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  projectID: Scalars['Int']['input'];
};


export type QueryProjectHistoryArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryProjectLinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectLinksArgs = {
  engagementId: Scalars['Int']['input'];
};


export type QueryProjectListArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  adminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  billingTypeId?: InputMaybe<Scalars['Int']['input']>;
  elUserId?: InputMaybe<Scalars['Int']['input']>;
  forReporting?: InputMaybe<Scalars['Boolean']['input']>;
  fulltext?: InputMaybe<Scalars['Boolean']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  includePlannerTemp?: InputMaybe<Scalars['Boolean']['input']>;
  includeRequested?: InputMaybe<Scalars['Boolean']['input']>;
  isPartTime?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  pmUserId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tdUserId?: InputMaybe<Scalars['Int']['input']>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
  temporaryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  tracksPTO?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProjectListV2Args = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  activePhase?: InputMaybe<ActivePhase>;
  activePhases?: InputMaybe<Array<ActivePhase>>;
  adminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  billingTypeId?: InputMaybe<Scalars['Int']['input']>;
  businesses?: InputMaybe<Array<Business>>;
  clientServicesLocationId?: InputMaybe<Scalars['Int']['input']>;
  contractStatus?: InputMaybe<ContractStatus>;
  deliverySubStatus?: InputMaybe<DeliverySubStatus>;
  deliverySubStatuses?: InputMaybe<Array<DeliverySubStatus>>;
  elUserId?: InputMaybe<Scalars['Int']['input']>;
  endDateEnd?: InputMaybe<Scalars['Date']['input']>;
  endDateStart?: InputMaybe<Scalars['Date']['input']>;
  excludeProjectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  experienceDirectorId?: InputMaybe<Scalars['Int']['input']>;
  forReporting?: InputMaybe<Scalars['Boolean']['input']>;
  fulltext?: InputMaybe<Scalars['Boolean']['input']>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  includeOnlyInactive?: InputMaybe<Scalars['Boolean']['input']>;
  includePlannerTemp?: InputMaybe<Scalars['Boolean']['input']>;
  includeRequested?: InputMaybe<Scalars['Boolean']['input']>;
  isPartTime?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyInactiveOwners?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUnassignedToProgram?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  pmUserId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skillID?: InputMaybe<Scalars['Int']['input']>;
  tdUserId?: InputMaybe<Scalars['Int']['input']>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
  temporaryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  tracksPTO?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProjectsQuickSearchArgs = {
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectsWithHoursArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};


export type QueryPromptArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPromptListArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProposalBadgesArgs = {
  ProposalId: Scalars['Int']['input'];
};


export type QueryPtoBalanceAsOfTodayReportArgs = {
  targetDate?: InputMaybe<Scalars['Date']['input']>;
  userInfo?: InputMaybe<Array<InputMaybe<UserInfoInput>>>;
};


export type QueryPtoCalcArgs = {
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPtoDayArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPtoDaysArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  officeID?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Scalars['Int']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPtoEstimateArgs = {
  input: PtoEstimateInput;
};


export type QueryPtoForOfficeArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPtoForUserArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPtoRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPtoRequestsArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  departmentID?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  managerID?: InputMaybe<Scalars['Int']['input']>;
  myTeam?: InputMaybe<Scalars['Boolean']['input']>;
  officeID?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Array<Scalars['Int']['input']>>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPtoRequestsPublicArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  departmentID?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  halfDayTime?: InputMaybe<Scalars['String']['input']>;
  managerID?: InputMaybe<Scalars['Int']['input']>;
  myTeam?: InputMaybe<Scalars['Boolean']['input']>;
  officeID?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  tracksTime?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPurchaseOrderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPurchaseOrdersArgs = {
  clientID?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQuickSearchArgs = {
  accountsLimit: Scalars['Int']['input'];
  business?: InputMaybe<KgBusiness>;
  clientType?: InputMaybe<Scalars['String']['input']>;
  contactsLimit: Scalars['Int']['input'];
  opportunitiesLimit: Scalars['Int']['input'];
  peopleLimit: Scalars['Int']['input'];
  projectInactive?: InputMaybe<Scalars['Boolean']['input']>;
  projectsLimit: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  relevanceThreshold: Scalars['Float']['input'];
};


export type QueryQuicklinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryQuicklinksArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRateCardArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRateCardListArgs = {
  konradRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  objectId?: InputMaybe<Scalars['Int']['input']>;
  objectType?: InputMaybe<RateCardObjectType>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  resourceDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resourceDisciplineIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resourceOfficeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReconciliationQueueArgs = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  includeFinalized?: InputMaybe<Scalars['Boolean']['input']>;
  managerID?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  weekStart: Scalars['Date']['input'];
};


export type QueryReportCreateArgs = {
  params: Array<InputMaybe<ReportParamInput>>;
  type: Scalars['String']['input'];
};


export type QueryReportCreateRawArgs = {
  params: Array<InputMaybe<ReportParamInput>>;
  type: Scalars['String']['input'];
};


export type QueryRevenueRecognitionArgs = {
  month: Scalars['Date']['input'];
};


export type QueryReviewArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReviewsArgs = {
  promotion?: InputMaybe<Scalars['Boolean']['input']>;
  raise?: InputMaybe<Scalars['Boolean']['input']>;
  reviewType?: InputMaybe<Scalars['String']['input']>;
  revieweeUserId: Scalars['Int']['input'];
};


export type QueryRoleTrendsByDateRangeArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


export type QueryRoleTrendsByNamesArgs = {
  roles: Array<Scalars['String']['input']>;
};


export type QueryRoleTrendsMonthsMostCommonArgs = {
  date: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryServiceGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceGroupListArgs = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkillTrendsByDateRangeArgs = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


export type QuerySkillTrendsBySkillIdsArgs = {
  skillIds: Array<Scalars['Int']['input']>;
};


export type QuerySkillTrendsMonthsMostCommonArgs = {
  date: Scalars['Date']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySkillsSuggestedArgs = {
  additionalData?: InputMaybe<SkillSuggestionAdditionalDataInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SuggestionObjectType>;
};


export type QuerySlackMessageLogListArgs = {
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySqlQueriesRecentArgs = {
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QuerySuggestSkillArgs = {
  for: SuggestionObjectType;
  from: SuggestionObjectType;
  fromId: Scalars['Int']['input'];
};


export type QueryTeamProfileGenerationLoadArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTimeSheetEntriesArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  failedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryTimedFileAccessUrlArgs = {
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  fileId: Scalars['String']['input'];
};


export type QueryTimesheetDetailsArgs = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTimesheetDetailsListArgs = {
  end: Scalars['Date']['input'];
  managerID?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['Date']['input'];
  userIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryTimesheetReminderSendsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  reminderType?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  weekStartDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryTimesheetWeekStatusArgs = {
  userID?: InputMaybe<Scalars['Int']['input']>;
  weekStart: Scalars['Date']['input'];
};


export type QueryTravelEstimateArgs = {
  input: TravelEstimateInput;
};


export type QueryTravelPublicArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  departmentID?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  managerID?: InputMaybe<Scalars['Int']['input']>;
  myTeam?: InputMaybe<Scalars['Boolean']['input']>;
  officeID?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  tracksTime?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTravelRequestsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  departmentID?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  managerID?: InputMaybe<Scalars['Int']['input']>;
  officeID?: InputMaybe<Scalars['Int']['input']>;
  opsUser?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTripArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTripMeetingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTripMeetingsArgs = {
  filters?: InputMaybe<QueryTripMeetingListArgs>;
};


export type QueryTripsArgs = {
  filters?: InputMaybe<QueryTripListArgs>;
};


export type QueryTvaReportArgs = {
  billingTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  categories?: InputMaybe<Array<TvaVariantCategory>>;
  elId?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['Date']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUnapprovedTimesheetsArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryUserSearchOptionsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserSelectOptionsArgs = {
  filters?: InputMaybe<Array<UserFilterInput>>;
};


export type QueryUserTimesheetArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserTimesheetListArgs = {
  end: Scalars['Date']['input'];
  includeAllocation?: InputMaybe<Scalars['Boolean']['input']>;
  managerID?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['Date']['input'];
  userIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryValidateApiKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryVaultFileArgs = {
  fileId: Scalars['String']['input'];
};


export type QueryWhosVisitingArgs = {
  end?: InputMaybe<Scalars['Date']['input']>;
  officeID?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryWireguardDeviceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWorkHistoriesArgs = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  hasProposedChanges?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeFormerEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorkHistoryOrderBy>;
  projectID?: InputMaybe<Scalars['Int']['input']>;
  projectRoles?: InputMaybe<Array<ProjectRole>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkHistoryArgs = {
  id: Scalars['Int']['input'];
};

export type QueryTripListArgs = {
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTripMeetingListArgs = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderReverse?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['Int']['input']>;
};

/** A KG QuickLink */
export type QuickLink = {
  __typename?: 'QuickLink';
  /** QuickLink Access config */
  access?: Maybe<Scalars['String']['output']>;
  /** QuickLink Created time */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** QuickLink Description of the link for search and tooltips */
  description?: Maybe<Scalars['String']['output']>;
  /** QuickLink Group */
  group?: Maybe<Scalars['String']['output']>;
  /** QuickLink Icon name or URL */
  icon?: Maybe<Scalars['String']['output']>;
  /** QuickLink ID */
  id: Scalars['Int']['output'];
  /** QuickLink Name */
  title: Scalars['String']['output'];
  /** QuickLink Last Updated */
  updates?: Maybe<Scalars['DateTime']['output']>;
  /** QuickLink URL */
  url: Scalars['String']['output'];
};

export type QuickLinkInput = {
  /** QuickLink Access config */
  access?: InputMaybe<Scalars['String']['input']>;
  /** QuickLink Description of the link for search and tooltips */
  description?: InputMaybe<Scalars['String']['input']>;
  /** QuickLink Group */
  group?: InputMaybe<Scalars['String']['input']>;
  /** QuickLink Icon name or URL */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** QuickLink ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** QuickLink Name */
  title: Scalars['String']['input'];
  /** QuickLink URL */
  url: Scalars['String']['input'];
};

export type QuickSearchResults = {
  __typename?: 'QuickSearchResults';
  accounts?: Maybe<Array<Account>>;
  contacts?: Maybe<Array<Contact>>;
  opportunities?: Maybe<Array<Opportunity>>;
  people?: Maybe<Array<Person>>;
  projects?: Maybe<Array<Project>>;
};

export type RateCard = {
  __typename?: 'RateCard';
  clientRole: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  createdByUser?: Maybe<Person>;
  currency: Scalars['String']['output'];
  hourlyRate: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  konradRoles: Array<Scalars['String']['output']>;
  modified: Scalars['DateTime']['output'];
  modifiedByUser?: Maybe<Person>;
  notes?: Maybe<Scalars['String']['output']>;
  objectId: Scalars['Int']['output'];
  objectType: RateCardObjectType;
  resourceDepartments?: Maybe<Array<Department>>;
  resourceDisciplines?: Maybe<Array<DisciplineNew>>;
  resourceOffices?: Maybe<Array<Office>>;
};

export type RateCardInput = {
  clientRole?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  konradRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['Int']['input']>;
  objectType?: InputMaybe<RateCardObjectType>;
  resourceDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resourceDisciplineIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  resourceOfficeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum RateCardObjectType {
  Client = 'client',
  Program = 'program',
  Project = 'project'
}

export type ReportParamInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Reports = {
  __typename?: 'Reports';
  /**  Standard Errors  */
  errors?: Maybe<Array<Maybe<StdError>>>;
  extReports?: Maybe<Array<Person>>;
  /**  List of people who reprt to this person  */
  reports?: Maybe<Array<Person>>;
};

export type RevenueByClientRow = {
  __typename?: 'RevenueByClientRow';
  /** Planned client rate (to be implemented in future) */
  avgClientPlannedRate?: Maybe<Scalars['Float']['output']>;
  /** Percentage difference between average client rate and average planned rate */
  avgClientRateDeltaPercent?: Maybe<Scalars['Float']['output']>;
  /** Average client rate over the past 12 months (rolling calculation) */
  avgClientRateToDate?: Maybe<Scalars['Float']['output']>;
  /** The unique identifier for the client */
  clientID: Scalars['Int']['output'];
  /** The display name of the client */
  clientName: Scalars['String']['output'];
  /** Monthly rate calculated as revenue divided by hours for the specified month */
  monthlyRate: Scalars['Float']['output'];
  /** Human-readable region name derived from sales entity */
  region?: Maybe<Scalars['String']['output']>;
  /** Total revenue recognized for this client in the specified month */
  revenueMonth: Scalars['Float']['output'];
  /** Sales entity identifier (2=Canada, 3=United States, 4=United Kingdom, null=unassigned) */
  salesEntity?: Maybe<Scalars['Int']['output']>;
  /** Total hours tracked for this client in the specified month */
  totalHoursMonth: Scalars['Float']['output'];
};

export type RevenueMetrics = {
  __typename?: 'RevenueMetrics';
  asOfDate: Scalars['String']['output'];
  createdLast30Days: Scalars['Float']['output'];
  createdLast90Days: Scalars['Float']['output'];
  createdLastQuarter: Scalars['Float']['output'];
  createdYTD: Scalars['Float']['output'];
  currentProjection: Scalars['Float']['output'];
  delta: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
  projectedTotal: Scalars['Float']['output'];
  revenueToDate: Scalars['Float']['output'];
  target: Scalars['Float']['output'];
};

export type RevenueRecognition = {
  __typename?: 'RevenueRecognition';
  forecast?: Maybe<Scalars['Float']['output']>;
  hoursActual?: Maybe<Scalars['Int']['output']>;
  hoursBillable?: Maybe<Scalars['Int']['output']>;
  hoursPlanned?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  project: Project;
  recognized?: Maybe<Scalars['Float']['output']>;
};

export type RevenueRecognitionInput = {
  month: Scalars['Date']['input'];
  projectId: Scalars['Int']['input'];
  recognized?: InputMaybe<Scalars['Float']['input']>;
};

export type Review = {
  __typename?: 'Review';
  approvalNeeded?: Maybe<Scalars['Boolean']['output']>;
  approvedBy?: Maybe<Scalars['Int']['output']>;
  approvedOn?: Maybe<Scalars['DateTime']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  dateDeleted?: Maybe<Scalars['DateTime']['output']>;
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  newTitle?: Maybe<Scalars['String']['output']>;
  promotion?: Maybe<Scalars['Boolean']['output']>;
  raise?: Maybe<Scalars['Boolean']['output']>;
  reviewDate?: Maybe<Scalars['DateTime']['output']>;
  reviewType?: Maybe<Scalars['String']['output']>;
  reviewee?: Maybe<Person>;
  revieweeUserId?: Maybe<Scalars['Int']['output']>;
  reviewer?: Maybe<Person>;
  reviewerUserId?: Maybe<Scalars['Int']['output']>;
  titleApplied?: Maybe<Scalars['Boolean']['output']>;
  titleEffective?: Maybe<Scalars['Date']['output']>;
};

export type Reviews = {
  __typename?: 'Reviews';
  /**  Standard Errors  */
  errors?: Maybe<Array<Maybe<StdError>>>;
  /**  List of review objects  */
  reviews: Array<Review>;
};

/**
 * Represents aggregated roles trend data for a specific month
 * Tracks how many work histories used each project role in a given time period
 */
export type RoleTrend = {
  __typename?: 'RoleTrend';
  count: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  projectRole: Scalars['String']['output'];
};

export type Roles = {
  __typename?: 'Roles';
  errors?: Maybe<Array<Maybe<StdError>>>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SqlQueryDetails = {
  __typename?: 'SQLQueryDetails';
  query: Scalars['String']['output'];
  table?: Maybe<Scalars['String']['output']>;
  time: Scalars['Int']['output'];
  when: Scalars['DateTime']['output'];
};

export type SqlScript = {
  __typename?: 'SQLScript';
  errorMessage?: Maybe<Scalars['String']['output']>;
  hasRun: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  wasRunManually: Scalars['Boolean']['output'];
};

export type SearchCacheBuildStats = {
  __typename?: 'SearchCacheBuildStats';
  buildMs: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
};

export type SearchCacheStats = {
  __typename?: 'SearchCacheStats';
  accounts: SearchCacheBuildStats;
  contacts: SearchCacheBuildStats;
  cstCount: Scalars['Int']['output'];
  lastRebuiltAt?: Maybe<Scalars['DateTime']['output']>;
  opportunities: SearchCacheBuildStats;
  people: SearchCacheBuildStats;
  projects: SearchCacheBuildStats;
  timesheetCount: Scalars['Int']['output'];
  totalBuildMs: Scalars['Int']['output'];
  userContextCount: Scalars['Int']['output'];
};

export type Section = {
  __typename?: 'Section';
  content: Array<Content>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ComplianceWorkbookSectionType;
};

export type SendNotificationTarget = {
  department?: InputMaybe<Scalars['Int']['input']>;
  office?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

/** Enum for specifying where to send the gift */
export enum SendToAddressType {
  Address = 'ADDRESS',
  Office = 'OFFICE'
}

export type ServiceGroup = {
  __typename?: 'ServiceGroup';
  clients: Array<Account>;
  created: Scalars['Date']['output'];
  createdByUser: Person;
  engagementLeads: Array<Person>;
  execSponsors: Array<Person>;
  id: Scalars['Int']['output'];
  modified: Scalars['Date']['output'];
  modifiedByUser: Person;
  name: Scalars['String']['output'];
  techLeads: Array<Person>;
};

export type ServiceGroupInput = {
  clientIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SkillCertification = {
  __typename?: 'SkillCertification';
  expiry?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  isExpired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
};

export type SkillSuggestionAdditionalDataInput = {
  input: Array<SkillSuggestionAdditionalDataInputItem>;
};

export type SkillSuggestionAdditionalDataInputItem = {
  type: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

/**
 * Represents aggregated skills trend data for a specific month
 * Tracks how many work histories used each skill in a given time period
 */
export type SkillTrend = {
  __typename?: 'SkillTrend';
  count: Scalars['Int']['output'];
  date: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  skill?: Maybe<ProfessionalSkillTag>;
  skillId: Scalars['Int']['output'];
};

export type SkillWithReasoning = {
  __typename?: 'SkillWithReasoning';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type SlackMessageLog = {
  __typename?: 'SlackMessageLog';
  channelId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  sent: Scalars['Boolean']['output'];
  timeStamp?: Maybe<Scalars['DateTime']['output']>;
};

export type StaticCalendar = {
  __typename?: 'StaticCalendar';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type StaticCalendarList = {
  __typename?: 'StaticCalendarList';
  calendars?: Maybe<Array<Maybe<StaticCalendar>>>;
};

export type StdError = {
  __typename?: 'StdError';
  code?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type SuggestedSkill = {
  __typename?: 'SuggestedSkill';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export enum SuggestionObjectType {
  Account = 'Account',
  Assignment = 'Assignment',
  Client = 'Client',
  Engagement = 'Engagement',
  Opportunity = 'Opportunity',
  Person = 'Person',
  Program = 'Program',
  Project = 'Project',
  Role = 'Role',
  WorkHistory = 'WorkHistory'
}

export type SystemInformation = {
  __typename?: 'SystemInformation';
  cpu?: Maybe<Scalars['Float']['output']>;
  dsk?: Maybe<Memory>;
  mem?: Maybe<Memory>;
};

export type TvaVariant = {
  __typename?: 'TVAVariant';
  additionalHours?: Maybe<Scalars['Float']['output']>;
  allocation: Scalars['Float']['output'];
  autofillHours?: Maybe<Scalars['Float']['output']>;
  autofillSkipMessage?: Maybe<Scalars['String']['output']>;
  autofillSkipReasonCode?: Maybe<Scalars['Int']['output']>;
  category: TvaVariantCategory;
  el?: Maybe<Person>;
  hadPto: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAdminEdited: Scalars['Boolean']['output'];
  noteEL?: Maybe<Scalars['String']['output']>;
  noteResolve?: Maybe<Scalars['String']['output']>;
  person: Person;
  project?: Maybe<Project>;
  ptoHours: Scalars['Float']['output'];
  resolvedBy?: Maybe<Person>;
  reviewedBy?: Maybe<Person>;
  status: Scalars['Int']['output'];
  /**
   * The trimmed flag-an-issue note the team member attached to the week.
   * Only set on ASSIGNMENT_FLAGGED_BY_TEAM_MEMBER rows.
   */
  teamMemberNote?: Maybe<Scalars['String']['output']>;
  tracked: Scalars['Float']['output'];
  variance: Scalars['Float']['output'];
  weekStartDate: Scalars['Date']['output'];
};

export enum TvaVariantCategory {
  AssignmentFlaggedByTeamMember = 'ASSIGNMENT_FLAGGED_BY_TEAM_MEMBER',
  AutofillSkipped = 'AUTOFILL_SKIPPED',
  AutofillVsTracked = 'AUTOFILL_VS_TRACKED',
  PlannerVsTracked = 'PLANNER_VS_TRACKED',
  TrackedWithoutAssignment = 'TRACKED_WITHOUT_ASSIGNMENT'
}

export type TableInfo = {
  __typename?: 'TableInfo';
  recordsNumber?: Maybe<Scalars['Int']['output']>;
  tableName?: Maybe<Scalars['String']['output']>;
};

export type Tag = {
  __typename?: 'Tag';
  categoryId?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type Tags = {
  __typename?: 'Tags';
  errors?: Maybe<Array<Maybe<StdError>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type TeamProfileGeneration = {
  __typename?: 'TeamProfileGeneration';
  createdAt: Scalars['DateTime']['output'];
  createdByUser: Person;
  editHistory?: Maybe<Array<EditHistoryItem>>;
  employeeId: Scalars['Int']['output'];
  generatedProfiles: Array<GeneratedProfile>;
  id: Scalars['Int']['output'];
  narrativeGuidance?: Maybe<Scalars['String']['output']>;
  originalGeneratedProfiles: Array<GeneratedProfile>;
  proposalDetails?: Maybe<Scalars['String']['output']>;
  selectedTemplate: Scalars['String']['output'];
  selectedWorkHistory: Array<Scalars['Int']['output']>;
  timesRefined: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type TeamProfileGenerationSaveInput = {
  employeeId: Scalars['Int']['input'];
  generatedProfiles: Array<GeneratedProfileInput>;
  narrativeGuidance?: InputMaybe<Scalars['String']['input']>;
  proposalDetails?: InputMaybe<Scalars['String']['input']>;
  selectedTemplate: Scalars['String']['input'];
  selectedWorkHistory: Array<Scalars['Int']['input']>;
};

export type TeamProfileGenerationUpdateInput = {
  editHistory: Array<EditHistoryItemInput>;
  generatedProfiles: Array<GeneratedProfileInput>;
  id: Scalars['String']['input'];
};

export type TemplateConfig = {
  __typename?: 'TemplateConfig';
  body: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type TemplateConfigInput = {
  body: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type Thread = {
  __typename?: 'Thread';
  Deleted?: Maybe<Scalars['DateTime']['output']>;
  assistant?: Maybe<ThreadAssistant>;
  assistantId: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  messages?: Maybe<Array<Maybe<Message>>>;
  name?: Maybe<Scalars['String']['output']>;
  threadId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
};

/** A project tracker entry with user and department information */
export type TimeTrackerEntryByDepartmentUser = {
  __typename?: 'TimeTrackerEntryByDepartmentUser';
  approved?: Maybe<Scalars['Boolean']['output']>;
  /**  Date of entry  */
  date: Scalars['Date']['output'];
  /**  hours of entry  */
  hours?: Maybe<Scalars['Int']['output']>;
  /**  TimetrackerID  */
  id: Scalars['Int']['output'];
  user?: Maybe<Person>;
};

export type TimesheetCompletionStat = {
  __typename?: 'TimesheetCompletionStat';
  /** Average time to complete in hours */
  averageTimeToComplete?: Maybe<Scalars['Float']['output']>;
  /** Email address */
  email: Scalars['String']['output'];
  /** Most recent update time for this week */
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  /** User's photo URL */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /** Time to complete in hours (from first creation to last update) */
  timeToComplete?: Maybe<Scalars['Float']['output']>;
  /** User's title */
  title?: Maybe<Scalars['String']['output']>;
  /** Total time to complete in hours */
  totalTimeToComplete?: Maybe<Scalars['Float']['output']>;
  /** User ID */
  userID: Scalars['Int']['output'];
  /** User's name */
  userName: Scalars['String']['output'];
  /** Week starting date */
  weekStart?: Maybe<Scalars['Date']['output']>;
};

export type TimesheetDetails = {
  __typename?: 'TimesheetDetails';
  Entries: Array<TimesheetDetailsEntry>;
  PTO: Array<TimesheetDetailsPto>;
  Planned: Array<TimesheetDetailsPlan>;
  WeeklyMetadata?: Maybe<TimesheetWeeklyMetadata>;
  /**
   * Expected autofill run instant (UTC) for the queried week, derived from the
   * scheduled job's cron. Null when the job isn't scheduled (or its schedule
   * can't be resolved to a single weekly instant).
   */
  autofillExpectedRunAt?: Maybe<Scalars['DateTime']['output']>;
  /** The team member's office IANA timezone (defaults to America/New_York). */
  officeTimezone: Scalars['String']['output'];
  userID: Scalars['Int']['output'];
};

export type TimesheetDetailsEntry = {
  __typename?: 'TimesheetDetailsEntry';
  additionalHours?: Maybe<Scalars['Int']['output']>;
  autofillHours?: Maybe<Scalars['Int']['output']>;
  date: Scalars['Date']['output'];
  entryStateID: Scalars['Int']['output'];
  hours: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  projectEndDate?: Maybe<Scalars['Date']['output']>;
  projectID: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
};

export type TimesheetDetailsPto = {
  __typename?: 'TimesheetDetailsPTO';
  end?: Maybe<Scalars['Date']['output']>;
  halfDay: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  start: Scalars['Date']['output'];
  type: Scalars['Int']['output'];
};

export type TimesheetDetailsPlan = {
  __typename?: 'TimesheetDetailsPlan';
  allocation?: Maybe<Scalars['Float']['output']>;
  billingTypeID?: Maybe<Scalars['Int']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  projectEndDate?: Maybe<Scalars['Date']['output']>;
  projectID: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
  start: Scalars['Date']['output'];
  treatAsAvailable: Scalars['Boolean']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type TimesheetEntry = {
  __typename?: 'TimesheetEntry';
  date?: Maybe<Scalars['Date']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  project?: Maybe<Project>;
  timeTrackerEntryID: Scalars['Int']['output'];
};

export type TimesheetEntryInput = {
  /** UserID */
  UserID?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Team-member-added hours portion (beyond the autofilled amount). Written to
   * `timetrackerentry.AdditionalHours`. If omitted, AdditionalHours is left
   * unchanged on existing rows.
   */
  additionalHours?: InputMaybe<Scalars['Int']['input']>;
  /** Date */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Canonical total hours for the entry. Written to `timetrackerentry.Hours`. */
  hours?: InputMaybe<Scalars['Int']['input']>;
  /** id */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Project ID */
  projectID?: InputMaybe<Scalars['Int']['input']>;
  /** Project Name */
  projectName?: InputMaybe<Scalars['String']['input']>;
  /** Temp Status */
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimesheetListItem = {
  __typename?: 'TimesheetListItem';
  email?: Maybe<Scalars['String']['output']>;
  nameFirst?: Maybe<Scalars['String']['output']>;
  nameLast?: Maybe<Scalars['String']['output']>;
  timesheetEntries?: Maybe<Array<Hours>>;
  userId: Scalars['Int']['output'];
};

export type TimesheetReminderDecision = {
  __typename?: 'TimesheetReminderDecision';
  firstName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  touch: Scalars['String']['output'];
  userID: Scalars['Int']['output'];
  weekStartDate: Scalars['String']['output'];
};

export type TimesheetReminderSend = {
  __typename?: 'TimesheetReminderSend';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  reminderType: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  userID: Scalars['Int']['output'];
  weekStartDate: Scalars['Date']['output'];
};

export type TimesheetReminderSimulation = {
  __typename?: 'TimesheetReminderSimulation';
  counts?: Maybe<Scalars['JSON']['output']>;
  decisions: Array<TimesheetReminderDecision>;
  dryRun: Scalars['Boolean']['output'];
  now: Scalars['String']['output'];
};

export type TimesheetReminderTestResult = {
  __typename?: 'TimesheetReminderTestResult';
  delivered: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  touch: Scalars['String']['output'];
  userID: Scalars['Int']['output'];
  weekStartDate: Scalars['String']['output'];
};

export type TimesheetTempProjectEntry = {
  __typename?: 'TimesheetTempProjectEntry';
  date: Scalars['Date']['output'];
  entryStateID: Scalars['Int']['output'];
  hours: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  projectID: Scalars['Int']['output'];
  projectName?: Maybe<Scalars['String']['output']>;
  userID: Scalars['Int']['output'];
};

/**
 * Per-team-member, per-week metadata for a timesheet. Separate from individual timesheet
 * entries so notes, autofill diagnostics, and submission timestamps can persist at the
 * week level without polluting each row.
 */
export type TimesheetWeeklyMetadata = {
  __typename?: 'TimesheetWeeklyMetadata';
  /**
   * When this week was last approved by a manager/admin. NULL when the week is
   * not currently approved (or was approved before this column existed).
   */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Any issues the autofill job recorded while processing this week
   * (e.g. over-allocation, existing manual entries, no allocation).
   */
  autofillIssues?: Maybe<Scalars['JSON']['output']>;
  /**
   * When this week was finalized (locked past approval) by an admin. For weeks
   * with entries the entries are also set to AdminFinalized (state 3); for empty /
   * autofill-skipped weeks this is the only finalized marker. A week counts as
   * finalized when any entry is at state 3 OR this is set. NULL when not finalized.
   */
  finalizedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The admin who finalized this week. NULL when not finalized. */
  finalizedByUserID?: Maybe<Scalars['Int']['output']>;
  /**
   * The last time the team member submitted this week's timesheet.
   * Name disambiguates from manager-approval / auto-approval timestamps.
   */
  lastSubmittedByTeamMemberDateTime?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Free-form note the team member attached when flagging an issue with this
   * week's timesheet (e.g. wrong assignment, missing engagement, incorrect
   * planned hours). Trimmed; NULL when no issue is flagged.
   */
  teamMemberNotes?: Maybe<Scalars['String']['output']>;
  userID: Scalars['Int']['output'];
  weekStartDate: Scalars['Date']['output'];
};

export type ToolGroup = {
  __typename?: 'ToolGroup';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tools: Array<LlmTool>;
};

export type TravelDays = {
  __typename?: 'TravelDays';
  end?: Maybe<Scalars['Date']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
  wfa?: Maybe<Scalars['Int']['output']>;
  wfaPerYear?: Maybe<Scalars['Int']['output']>;
  wfo?: Maybe<Scalars['Int']['output']>;
  wfoPerYear?: Maybe<Scalars['Int']['output']>;
};

export type TravelEntry = {
  __typename?: 'TravelEntry';
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  officeID?: Maybe<Scalars['Int']['output']>;
  primaryResidence?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Person>;
};

export type TravelEstimateInput = {
  end: Scalars['Date']['input'];
  start: Scalars['Date']['input'];
};

export type TravelEstimatePayload = {
  __typename?: 'TravelEstimatePayload';
  estimateValue: Scalars['Float']['output'];
};

export type TravelPeriod = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type TravelRequest = {
  __typename?: 'TravelRequest';
  approvedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  office?: Maybe<Office>;
  opsUser: Person;
  primaryResidence: Scalars['Boolean']['output'];
  startDate: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  user: Person;
};

export type TravelRequestInput = {
  endDate: Scalars['Date']['input'];
  location: Scalars['String']['input'];
  officeID?: InputMaybe<Scalars['Int']['input']>;
  primaryResidence: Scalars['Boolean']['input'];
  startDate: Scalars['Date']['input'];
  type: Scalars['String']['input'];
};

export type Trip = {
  __typename?: 'Trip';
  attendees: Array<Person>;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  createdByUser?: Maybe<Person>;
  dateEnd: Scalars['Date']['output'];
  dateStart: Scalars['Date']['output'];
  deleted?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  isBillable: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  locationAddress?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  meetings: Array<TripMeeting>;
  modified: Scalars['DateTime']['output'];
  modifiedBy: Scalars['Int']['output'];
  modifiedByUser?: Maybe<Person>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TripInput = {
  attendees?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateEnd?: InputMaybe<Scalars['Date']['input']>;
  dateStart?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isBillable?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationAddress?: InputMaybe<Scalars['String']['input']>;
  locationCity?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  locationPostalCode?: InputMaybe<Scalars['String']['input']>;
  locationState?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TripMeeting = {
  __typename?: 'TripMeeting';
  attendees: Array<Person>;
  bookingStatus: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  deleted?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  modified: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<Contact>;
  time?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  trip: Trip;
  tripId: Scalars['Int']['output'];
};

export type TripMeetingInput = {
  attendees?: InputMaybe<Array<Scalars['Int']['input']>>;
  bookingStatus?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  stakeholders?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProjectInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activePhases?: InputMaybe<Array<ActivePhase>>;
  billingTypeId?: InputMaybe<Scalars['Int']['input']>;
  businesses?: InputMaybe<Array<Business>>;
  clientServicesLocationId?: InputMaybe<Scalars['Int']['input']>;
  completed?: InputMaybe<Scalars['Int']['input']>;
  contractStatus?: InputMaybe<ContractStatus>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  deliverySubStatus?: InputMaybe<DeliverySubStatus>;
  description?: InputMaybe<Scalars['String']['input']>;
  designLeadIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  elUserId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  experienceDirectorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideFromForecast?: InputMaybe<Scalars['Boolean']['input']>;
  leadBillingNotes?: InputMaybe<Scalars['String']['input']>;
  opportunityId?: InputMaybe<Scalars['Int']['input']>;
  planLink?: InputMaybe<Scalars['String']['input']>;
  plannedHours?: InputMaybe<Scalars['Int']['input']>;
  pmUserId?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  projectType?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['Int']['input']>;
  requested?: InputMaybe<Scalars['Boolean']['input']>;
  resourcingNotes?: InputMaybe<Scalars['String']['input']>;
  salesforceId?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tdUserId?: InputMaybe<Scalars['Int']['input']>;
  technologyLeadIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  weeklyReportLastSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  weeklyReportRequired?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyReportSenderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  weeklyReportSent?: InputMaybe<Scalars['Boolean']['input']>;
  winPercentage?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for adding or updating a contact in a gift campaign */
export type UpsertGiftCampaignEntryInput = {
  /** Holiday Box address line 1 */
  address1HB?: InputMaybe<Scalars['String']['input']>;
  /** Holiday Box address line 2 */
  address1Line2HB?: InputMaybe<Scalars['String']['input']>;
  /** The decision to approve the address. NULL if not reviewed. */
  addressApproved?: InputMaybe<Scalars['Boolean']['input']>;
  campaignId: Scalars['Int']['input'];
  /** Holiday Box city */
  cityHB?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['Int']['input'];
  /** Holiday Box country */
  countryHB?: InputMaybe<Scalars['String']['input']>;
  /** The decision to approve the gift. NULL if undecided. */
  giftApproved?: InputMaybe<Scalars['Boolean']['input']>;
  /** The decision to ship the gift. NULL or FALSE if not shipped. */
  giftShipped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Address verification status. NULL = not reviewed, FALSE = unverified, TRUE = verified */
  isVerifiedAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference to office if SendToAddressType is OFFICE */
  linkedAccountOfficeId?: InputMaybe<Scalars['Int']['input']>;
  /** Holiday Box postal/zip code */
  postalCodeHB?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send to office or custom address */
  sendToAddressType?: InputMaybe<SendToAddressType>;
  /** Holiday Box state/province */
  stateHB?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating or updating a gift campaign */
export type UpsertGiftCampaignInput = {
  /** The title of the gift campaign. Required if creating a new campaign. */
  campaignTitle?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type UserCertificationSkill = {
  __typename?: 'UserCertificationSkill';
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

/**
 * Filter input for user dropdown options.
 * Each filter represents a combination of departments AND seniority levels.
 * Multiple filters are applied with OR logic.
 */
export type UserFilterInput = {
  /** Department IDs to filter by (user must be in one of these departments) */
  departmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Permission names to filter by (user must have one of these permissions) */
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Seniority levels to filter by (user must have one of these levels) */
  seniorityLevels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserInfoInput = {
  departmentName?: InputMaybe<Scalars['String']['input']>;
  nameFirst?: InputMaybe<Scalars['String']['input']>;
  nameLast?: InputMaybe<Scalars['String']['input']>;
  officeName?: InputMaybe<Scalars['String']['input']>;
  rolloverDate?: InputMaybe<Scalars['Date']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
};

/** Any fields mentioned here will be */
export type UserObjInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  availableDays?: InputMaybe<Scalars['Float']['input']>;
  birthdayDay?: InputMaybe<Scalars['Int']['input']>;
  birthdayMonth?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  dateStartedTrackingTime?: InputMaybe<Scalars['Date']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  dietRestrictions?: InputMaybe<Scalars['String']['input']>;
  dottedLineReportingId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  floatingHolidayAllowance?: InputMaybe<Scalars['Float']['input']>;
  ftContractDate?: InputMaybe<Scalars['Date']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  homeOfficeId?: InputMaybe<Scalars['Int']['input']>;
  isPartTime?: InputMaybe<Scalars['Boolean']['input']>;
  isTemporary?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['Int']['input']>;
  nameFirst?: InputMaybe<Scalars['String']['input']>;
  nameLast?: InputMaybe<Scalars['String']['input']>;
  officeId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plannerGroup?: InputMaybe<Scalars['Int']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  ptoDays?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Scalars['Int']['input']>;
  rolloverDate?: InputMaybe<Scalars['Date']['input']>;
  rolloverDays?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  timeTrackerApproverId?: InputMaybe<Scalars['Int']['input']>;
  tracksTime?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserProfessionalSkillTag = {
  __typename?: 'UserProfessionalSkillTag';
  created?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCoreSkill?: Maybe<Scalars['Boolean']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['Int']['output']>;
  skillId: Scalars['Int']['output'];
  yearsExperience?: Maybe<Scalars['Float']['output']>;
};

export type UserProfessionalSkillTagInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isCoreSkill?: InputMaybe<Scalars['Boolean']['input']>;
  yearsExperience?: InputMaybe<Scalars['Float']['input']>;
};

export type VaultActivity = {
  __typename?: 'VaultActivity';
  date?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Person>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  vaultFile?: Maybe<VaultFile>;
  vaultfileId?: Maybe<Scalars['String']['output']>;
};

export type VaultFile = {
  __typename?: 'VaultFile';
  author?: Maybe<Person>;
  authorId?: Maybe<Scalars['Int']['output']>;
  downloads?: Maybe<Scalars['Int']['output']>;
  expires?: Maybe<Scalars['DateTime']['output']>;
  firstDownload?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inboxUser?: Maybe<Person>;
  inboxUserId?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lastDownload?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uploaded?: Maybe<Scalars['DateTime']['output']>;
};

export type WireguardDevice = {
  __typename?: 'WireguardDevice';
  dateCreated: Scalars['DateTime']['output'];
  dateDeleted?: Maybe<Scalars['DateTime']['output']>;
  dateUpdated: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  partialIp: Scalars['String']['output'];
  user?: Maybe<Person>;
  userId: Scalars['Int']['output'];
  wireGuardPrivateKey: Scalars['String']['output'];
  wireGuardPublicKey: Scalars['String']['output'];
};

export type WireguardServerInfo = {
  __typename?: 'WireguardServerInfo';
  displayName: Scalars['String']['output'];
  port: Scalars['String']['output'];
  publicEndpoint: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
  serverPartialIP: Scalars['String']['output'];
};

/** Represents a record of work done by an employee on a project or account */
export type WorkHistory = {
  __typename?: 'WorkHistory';
  account?: Maybe<Account>;
  accountID?: Maybe<Scalars['Int']['output']>;
  assignedTo?: Maybe<Scalars['Int']['output']>;
  completed: Scalars['Boolean']['output'];
  completedBy?: Maybe<Scalars['Int']['output']>;
  completedDate?: Maybe<Scalars['Date']['output']>;
  created: Scalars['Date']['output'];
  customAccountName?: Maybe<Scalars['String']['output']>;
  customProjectName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  hoursWorked?: Maybe<Scalars['Float']['output']>;
  hoursWorkedSinceLastCompleted?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  modifiedBy?: Maybe<Scalars['Int']['output']>;
  modifiedDate: Scalars['Date']['output'];
  needsUpdate: Scalars['Boolean']['output'];
  project?: Maybe<Project>;
  projectID?: Maybe<Scalars['Int']['output']>;
  projectRoles: Array<ProjectRole>;
  proposedBy?: Maybe<Scalars['Int']['output']>;
  proposedDate?: Maybe<Scalars['Date']['output']>;
  proposedUserUpdate?: Maybe<ProposedUserUpdate>;
  skills: Array<ProfessionalSkillTag>;
  startDate?: Maybe<Scalars['Date']['output']>;
  updateUrgency: Scalars['Int']['output'];
  user?: Maybe<Person>;
  userID: Scalars['Int']['output'];
  workDescription?: Maybe<Scalars['String']['output']>;
};

export type WorkHistoryInput = {
  accountID?: InputMaybe<Scalars['Int']['input']>;
  assignedTo?: InputMaybe<Scalars['Int']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  customAccountName?: InputMaybe<Scalars['String']['input']>;
  customProjectName?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  hoursWorked?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  projectID?: InputMaybe<Scalars['Int']['input']>;
  projectRoles?: InputMaybe<Array<ProjectRole>>;
  skills?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  updateUrgency?: InputMaybe<Scalars['Int']['input']>;
  userID?: InputMaybe<Scalars['Int']['input']>;
  workDescription?: InputMaybe<Scalars['String']['input']>;
};

export enum WorkHistoryOrderBy {
  EndDate = 'END_DATE',
  UpdateUrgency = 'UPDATE_URGENCY'
}

export type LastMonthlyHourReportMonth = {
  __typename?: 'lastMonthlyHourReportMonth';
  month?: Maybe<Scalars['String']['output']>;
};

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type ModelOption = {
  __typename?: 'modelOption';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type OpportunityMetricsSummaryResponse = {
  __typename?: 'opportunityMetricsSummaryResponse';
  createdLast30Days: Scalars['Float']['output'];
  createdLast90Days: Scalars['Float']['output'];
  createdYTD: Scalars['Float']['output'];
};

export type ThreadAssistant = {
  __typename?: 'threadAssistant';
  name?: Maybe<Scalars['String']['output']>;
};

export type UserPlannedHoursReduced = {
  __typename?: 'userPlannedHoursReduced';
  hours: Scalars['Float']['output'];
  userID: Scalars['Int']['output'];
};

export type GetEmployeeByEmailQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEmployeeByEmailQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, fullName?: string | null, nameLast: string, nameFirst: string, email?: string | null, photoUrl?: string | null, office?: { __typename?: 'Office', Name?: string | null, OfficeID: number } | null, company?: { __typename?: 'Company', id: number, Name?: string | null } | null } | null };

export type GetEmployeeByIdQueryVariables = Exact<{
  personId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEmployeeByIdQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: number, fullName?: string | null, nameLast: string, nameFirst: string, email?: string | null, photoUrl?: string | null, office?: { __typename?: 'Office', Name?: string | null, OfficeID: number } | null, company?: { __typename?: 'Company', id: number, Name?: string | null } | null } | null };

export type GetEmployeesQueryVariables = Exact<{
  office?: InputMaybe<Scalars['Int']['input']>;
  company?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEmployeesQuery = { __typename?: 'Query', peopleV2: Array<{ __typename?: 'Person', id: number, fullName?: string | null, nameLast: string, nameFirst: string, email?: string | null, photoUrl?: string | null, office?: { __typename?: 'Office', Name?: string | null, OfficeID: number } | null, company?: { __typename?: 'Company', id: number, Name?: string | null } | null }> };

export type GetOfficesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOfficesQuery = { __typename?: 'Query', officeListV2: Array<{ __typename?: 'Office', Country?: string | null, Name?: string | null, OfficeID: number }> };


export const GetEmployeeByEmailDocument = gql`
    query getEmployeeByEmail($email: String) {
  person(email: $email) {
    id
    fullName
    nameLast
    nameFirst
    email
    photoUrl(size: medium)
    office {
      Name
      OfficeID
    }
    company {
      id
      Name
    }
  }
}
    `;

/**
 * __useGetEmployeeByEmailQuery__
 *
 * To run a query within a React component, call `useGetEmployeeByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetEmployeeByEmailQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>(GetEmployeeByEmailDocument, options);
      }
export function useGetEmployeeByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>(GetEmployeeByEmailDocument, options);
        }
// @ts-ignore
export function useGetEmployeeByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>;
export function useGetEmployeeByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeeByEmailQuery | undefined, GetEmployeeByEmailQueryVariables>;
export function useGetEmployeeByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>(GetEmployeeByEmailDocument, options);
        }
export type GetEmployeeByEmailQueryHookResult = ReturnType<typeof useGetEmployeeByEmailQuery>;
export type GetEmployeeByEmailLazyQueryHookResult = ReturnType<typeof useGetEmployeeByEmailLazyQuery>;
export type GetEmployeeByEmailSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeByEmailSuspenseQuery>;
export type GetEmployeeByEmailQueryResult = Apollo.QueryResult<GetEmployeeByEmailQuery, GetEmployeeByEmailQueryVariables>;
export const GetEmployeeByIdDocument = gql`
    query getEmployeeById($personId: Int) {
  person(id: $personId) {
    id
    fullName
    nameLast
    nameFirst
    email
    photoUrl(size: medium)
    office {
      Name
      OfficeID
    }
    company {
      id
      Name
    }
  }
}
    `;

/**
 * __useGetEmployeeByIdQuery__
 *
 * To run a query within a React component, call `useGetEmployeeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeByIdQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetEmployeeByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>(GetEmployeeByIdDocument, options);
      }
export function useGetEmployeeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>(GetEmployeeByIdDocument, options);
        }
// @ts-ignore
export function useGetEmployeeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>;
export function useGetEmployeeByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeeByIdQuery | undefined, GetEmployeeByIdQueryVariables>;
export function useGetEmployeeByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>(GetEmployeeByIdDocument, options);
        }
export type GetEmployeeByIdQueryHookResult = ReturnType<typeof useGetEmployeeByIdQuery>;
export type GetEmployeeByIdLazyQueryHookResult = ReturnType<typeof useGetEmployeeByIdLazyQuery>;
export type GetEmployeeByIdSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeByIdSuspenseQuery>;
export type GetEmployeeByIdQueryResult = Apollo.QueryResult<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>;
export const GetEmployeesDocument = gql`
    query getEmployees($office: Int, $company: Int) {
  peopleV2(office: $office, company: $company, inactive: false) {
    id
    fullName
    nameLast
    nameFirst
    email
    photoUrl(size: medium)
    office {
      Name
      OfficeID
    }
    company {
      id
      Name
    }
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      office: // value for 'office'
 *      company: // value for 'company'
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
// @ts-ignore
export function useGetEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export function useGetEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeesQuery | undefined, GetEmployeesQueryVariables>;
export function useGetEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesSuspenseQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetOfficesDocument = gql`
    query getOffices {
  officeListV2 {
    Country
    Name
    OfficeID
  }
}
    `;

/**
 * __useGetOfficesQuery__
 *
 * To run a query within a React component, call `useGetOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfficesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfficesQuery(baseOptions?: Apollo.QueryHookOptions<GetOfficesQuery, GetOfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfficesQuery, GetOfficesQueryVariables>(GetOfficesDocument, options);
      }
export function useGetOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfficesQuery, GetOfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfficesQuery, GetOfficesQueryVariables>(GetOfficesDocument, options);
        }
// @ts-ignore
export function useGetOfficesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfficesQuery, GetOfficesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfficesQuery, GetOfficesQueryVariables>;
export function useGetOfficesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfficesQuery, GetOfficesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfficesQuery | undefined, GetOfficesQueryVariables>;
export function useGetOfficesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfficesQuery, GetOfficesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfficesQuery, GetOfficesQueryVariables>(GetOfficesDocument, options);
        }
export type GetOfficesQueryHookResult = ReturnType<typeof useGetOfficesQuery>;
export type GetOfficesLazyQueryHookResult = ReturnType<typeof useGetOfficesLazyQuery>;
export type GetOfficesSuspenseQueryHookResult = ReturnType<typeof useGetOfficesSuspenseQuery>;
export type GetOfficesQueryResult = Apollo.QueryResult<GetOfficesQuery, GetOfficesQueryVariables>;